/**
 * PyMOL geodesic sphere tessellations (icosahedral subdivision), generated from
 * packages/engine/layer0/SphereData.h. Five levels selected by the `dot_density`
 * setting (0..4). Each level lists unit-sphere sample directions `dot` and their
 * solid-angle weights `area` (summing to 4π), used by `get_area` to weight each
 * exposed dot: per-dot area = radius² · area[b]. Do not hand-edit — regenerate
 * from SphereData.h if PyMOL updates the tessellation.
 */

export interface SphereRec {
  /** unit-sphere sample directions */
  readonly dot: ReadonlyArray<readonly [number, number, number]>;
  /** per-dot solid-angle weight (Σ = 4π) */
  readonly area: ReadonlyArray<number>;
}

const N_DOT: readonly number[] = [12,42,162,642,2562];
const DOT_START: readonly number[] = [0,12,54,216,858];

const DOTS: ReadonlyArray<readonly [number, number, number]> = [
[0.850650787354,0.525731086731,0.000000000000],
[-0.850650787354,0.525731086731,0.000000000000],
[-0.850650787354,-0.525731086731,0.000000000000],
[0.850650787354,-0.525731086731,0.000000000000],
[0.525731086731,0.000000000000,0.850650787354],
[0.525731086731,0.000000000000,-0.850650787354],
[-0.525731086731,0.000000000000,-0.850650787354],
[-0.525731086731,0.000000000000,0.850650787354],
[0.000000000000,0.850650787354,0.525731086731],
[0.000000000000,-0.850650787354,0.525731086731],
[0.000000000000,-0.850650787354,-0.525731086731],
[0.000000000000,0.850650787354,-0.525731086731],
[0.850650787354,0.525731086731,0.000000000000],
[-0.850650787354,0.525731086731,0.000000000000],
[-0.850650787354,-0.525731086731,0.000000000000],
[0.850650787354,-0.525731086731,0.000000000000],
[0.525731086731,0.000000000000,0.850650787354],
[0.525731086731,0.000000000000,-0.850650787354],
[-0.525731086731,0.000000000000,-0.850650787354],
[-0.525731086731,0.000000000000,0.850650787354],
[0.000000000000,0.850650787354,0.525731086731],
[0.000000000000,-0.850650787354,0.525731086731],
[0.000000000000,-0.850650787354,-0.525731086731],
[0.000000000000,0.850650787354,-0.525731086731],
[0.309016972780,0.499999970198,0.809016942978],
[-0.309016972780,0.499999970198,0.809016942978],
[0.000000000000,0.000000000000,0.999999940395],
[-0.309016972780,-0.499999970198,0.809016942978],
[0.309016972780,-0.499999970198,0.809016942978],
[0.000000000000,0.000000000000,-0.999999940395],
[-0.309016972780,0.499999970198,-0.809016942978],
[0.309016972780,0.499999970198,-0.809016942978],
[0.309016972780,-0.499999970198,-0.809016942978],
[-0.309016972780,-0.499999970198,-0.809016942978],
[0.809016942978,0.309016972780,0.499999970198],
[0.809016942978,-0.309016972780,0.499999970198],
[0.999999940395,0.000000000000,0.000000000000],
[0.809016942978,-0.309016972780,-0.499999970198],
[0.809016942978,0.309016972780,-0.499999970198],
[-0.809016942978,-0.309016972780,0.499999970198],
[-0.809016942978,0.309016972780,0.499999970198],
[-0.999999940395,0.000000000000,0.000000000000],
[-0.809016942978,0.309016972780,-0.499999970198],
[-0.809016942978,-0.309016972780,-0.499999970198],
[0.499999970198,0.809016942978,0.309016972780],
[0.499999970198,0.809016942978,-0.309016972780],
[0.000000000000,0.999999940395,0.000000000000],
[-0.499999970198,0.809016942978,-0.309016972780],
[-0.499999970198,0.809016942978,0.309016972780],
[0.000000000000,-0.999999940395,0.000000000000],
[0.499999970198,-0.809016942978,-0.309016972780],
[0.499999970198,-0.809016942978,0.309016972780],
[-0.499999970198,-0.809016942978,0.309016972780],
[-0.499999970198,-0.809016942978,-0.309016972780],
[0.850650787354,0.525731086731,0.000000000000],
[-0.850650787354,0.525731086731,0.000000000000],
[-0.850650787354,-0.525731086731,0.000000000000],
[0.850650787354,-0.525731086731,0.000000000000],
[0.525731086731,0.000000000000,0.850650787354],
[0.525731086731,0.000000000000,-0.850650787354],
[-0.525731086731,0.000000000000,-0.850650787354],
[-0.525731086731,0.000000000000,0.850650787354],
[0.000000000000,0.850650787354,0.525731086731],
[0.000000000000,-0.850650787354,0.525731086731],
[0.000000000000,-0.850650787354,-0.525731086731],
[0.000000000000,0.850650787354,-0.525731086731],
[0.309016972780,0.499999970198,0.809016942978],
[-0.309016972780,0.499999970198,0.809016942978],
[0.000000000000,0.000000000000,0.999999940395],
[-0.309016972780,-0.499999970198,0.809016942978],
[0.309016972780,-0.499999970198,0.809016942978],
[0.000000000000,0.000000000000,-0.999999940395],
[-0.309016972780,0.499999970198,-0.809016942978],
[0.309016972780,0.499999970198,-0.809016942978],
[0.309016972780,-0.499999970198,-0.809016942978],
[-0.309016972780,-0.499999970198,-0.809016942978],
[0.809016942978,0.309016972780,0.499999970198],
[0.809016942978,-0.309016972780,0.499999970198],
[0.999999940395,0.000000000000,0.000000000000],
[0.809016942978,-0.309016972780,-0.499999970198],
[0.809016942978,0.309016972780,-0.499999970198],
[-0.809016942978,-0.309016972780,0.499999970198],
[-0.809016942978,0.309016972780,0.499999970198],
[-0.999999940395,0.000000000000,0.000000000000],
[-0.809016942978,0.309016972780,-0.499999970198],
[-0.809016942978,-0.309016972780,-0.499999970198],
[0.499999970198,0.809016942978,0.309016972780],
[0.499999970198,0.809016942978,-0.309016972780],
[0.000000000000,0.999999940395,0.000000000000],
[-0.499999970198,0.809016942978,-0.309016972780],
[-0.499999970198,0.809016942978,0.309016972780],
[0.000000000000,-0.999999940395,0.000000000000],
[0.499999970198,-0.809016942978,-0.309016972780],
[0.499999970198,-0.809016942978,0.309016972780],
[-0.499999970198,-0.809016942978,0.309016972780],
[-0.499999970198,-0.809016942978,-0.309016972780],
[0.433888554573,0.259891897440,0.862668514252],
[0.162459850311,0.262865543365,0.951056540012],
[0.273266524076,0.000000000000,0.961938381195],
[0.162459850311,-0.262865543365,0.951056540012],
[0.433888554573,-0.259891897440,0.862668514252],
[0.273266524076,0.000000000000,-0.961938381195],
[0.162459850311,0.262865543365,-0.951056540012],
[0.433888554573,0.259891897440,-0.862668514252],
[0.433888554573,-0.259891897440,-0.862668514252],
[0.162459850311,-0.262865543365,-0.951056540012],
[0.862668514252,0.433888554573,0.259891897440],
[0.951056540012,0.162459850311,0.262865543365],
[0.961938381195,0.273266524076,0.000000000000],
[0.951056540012,0.162459850311,-0.262865543365],
[0.862668514252,0.433888554573,-0.259891897440],
[-0.862668514252,-0.433888554573,0.259891897440],
[-0.951056540012,-0.162459850311,0.262865543365],
[-0.961938381195,-0.273266524076,0.000000000000],
[-0.951056540012,-0.162459850311,-0.262865543365],
[-0.862668514252,-0.433888554573,-0.259891897440],
[0.259891897440,0.862668514252,0.433888554573],
[0.262865543365,0.951056540012,0.162459850311],
[0.000000000000,0.961938381195,0.273266524076],
[-0.262865543365,0.951056540012,0.162459850311],
[-0.259891897440,0.862668514252,0.433888554573],
[0.000000000000,-0.961938381195,0.273266524076],
[0.262865543365,-0.951056540012,0.162459850311],
[0.259891897440,-0.862668514252,0.433888554573],
[-0.259891897440,-0.862668514252,0.433888554573],
[-0.262865543365,-0.951056540012,0.162459850311],
[0.160622030497,0.702046453953,0.693780481815],
[0.425325393677,0.688190996647,0.587785243988],
[0.259891897440,0.862668514252,-0.433888554573],
[0.425325393677,0.688190996647,-0.587785243988],
[0.160622030497,0.702046453953,-0.693780481815],
[0.587785243988,-0.425325393677,0.688190996647],
[0.693780481815,-0.160622030497,0.702046453953],
[0.693780481815,-0.160622030497,-0.702046453953],
[0.587785243988,-0.425325393677,-0.688190996647],
[-0.433888554573,0.259891897440,0.862668514252],
[-0.587785243988,0.425325393677,0.688190996647],
[-0.693780481815,0.160622030497,0.702046453953],
[-0.693780481815,0.160622030497,-0.702046453953],
[-0.587785243988,0.425325393677,-0.688190996647],
[-0.433888554573,0.259891897440,-0.862668514252],
[-0.693780481815,-0.160622030497,0.702046453953],
[-0.587785243988,-0.425325393677,0.688190996647],
[-0.433888554573,-0.259891897440,0.862668514252],
[-0.433888554573,-0.259891897440,-0.862668514252],
[-0.587785243988,-0.425325393677,-0.688190996647],
[-0.693780481815,-0.160622030497,-0.702046453953],
[0.000000000000,0.525731086731,0.850650787354],
[-0.160622030497,0.702046453953,0.693780481815],
[-0.273266524076,0.000000000000,0.961938381195],
[-0.162459850311,0.262865543365,0.951056540012],
[-0.162459850311,-0.262865543365,0.951056540012],
[0.160622030497,-0.702046453953,0.693780481815],
[0.000000000000,-0.525731086731,0.850650787354],
[-0.160622030497,-0.702046453953,0.693780481815],
[-0.273266524076,0.000000000000,-0.961938381195],
[-0.162459850311,0.262865543365,-0.951056540012],
[0.000000000000,0.525731086731,-0.850650787354],
[-0.160622030497,0.702046453953,-0.693780481815],
[0.160622030497,-0.702046453953,-0.693780481815],
[0.000000000000,-0.525731086731,-0.850650787354],
[-0.160622030497,-0.702046453953,-0.693780481815],
[-0.162459850311,-0.262865543365,-0.951056540012],
[0.693780481815,0.160622030497,0.702046453953],
[0.850650787354,0.000000000000,0.525731086731],
[0.961938381195,-0.273266524076,0.000000000000],
[0.951056540012,-0.162459850311,0.262865543365],
[0.862668514252,-0.433888554573,0.259891897440],
[0.951056540012,-0.162459850311,-0.262865543365],
[0.862668514252,-0.433888554573,-0.259891897440],
[0.693780481815,0.160622030497,-0.702046453953],
[0.850650787354,0.000000000000,-0.525731086731],
[-0.850650787354,0.000000000000,0.525731086731],
[-0.961938381195,0.273266524076,0.000000000000],
[-0.951056540012,0.162459850311,0.262865543365],
[-0.862668514252,0.433888554573,0.259891897440],
[-0.951056540012,0.162459850311,-0.262865543365],
[-0.862668514252,0.433888554573,-0.259891897440],
[-0.850650787354,0.000000000000,-0.525731086731],
[0.702046453953,0.693780481815,0.160622030497],
[0.525731086731,0.850650787354,0.000000000000],
[0.702046453953,0.693780481815,-0.160622030497],
[0.000000000000,0.961938381195,-0.273266524076],
[0.262865543365,0.951056540012,-0.162459850311],
[-0.262865543365,0.951056540012,-0.162459850311],
[-0.259891897440,0.862668514252,-0.433888554573],
[-0.702046453953,0.693780481815,0.160622030497],
[-0.525731086731,0.850650787354,0.000000000000],
[-0.702046453953,0.693780481815,-0.160622030497],
[0.000000000000,-0.961938381195,-0.273266524076],
[0.262865543365,-0.951056540012,-0.162459850311],
[0.259891897440,-0.862668514252,-0.433888554573],
[0.702046453953,-0.693780481815,0.160622030497],
[0.525731086731,-0.850650787354,0.000000000000],
[0.702046453953,-0.693780481815,-0.160622030497],
[-0.702046453953,-0.693780481815,0.160622030497],
[-0.525731086731,-0.850650787354,0.000000000000],
[-0.702046453953,-0.693780481815,-0.160622030497],
[-0.262865543365,-0.951056540012,-0.162459850311],
[-0.259891897440,-0.862668514252,-0.433888554573],
[0.587785243988,0.425325393677,0.688190996647],
[0.688190996647,0.587785243988,0.425325393677],
[0.688190996647,0.587785243988,-0.425325393677],
[0.587785243988,0.425325393677,-0.688190996647],
[0.425325393677,-0.688190996647,0.587785243988],
[0.688190996647,-0.587785243988,0.425325393677],
[0.688190996647,-0.587785243988,-0.425325393677],
[0.425325393677,-0.688190996647,-0.587785243988],
[-0.425325393677,0.688190996647,0.587785243988],
[-0.688190996647,0.587785243988,0.425325393677],
[-0.688190996647,0.587785243988,-0.425325393677],
[-0.425325393677,0.688190996647,-0.587785243988],
[-0.688190996647,-0.587785243988,0.425325393677],
[-0.425325393677,-0.688190996647,0.587785243988],
[-0.425325393677,-0.688190996647,-0.587785243988],
[-0.688190996647,-0.587785243988,-0.425325393677],
[0.850650787354,0.525731086731,0.000000000000],
[-0.850650787354,0.525731086731,0.000000000000],
[-0.850650787354,-0.525731086731,0.000000000000],
[0.850650787354,-0.525731086731,0.000000000000],
[0.525731086731,0.000000000000,0.850650787354],
[0.525731086731,0.000000000000,-0.850650787354],
[-0.525731086731,0.000000000000,-0.850650787354],
[-0.525731086731,0.000000000000,0.850650787354],
[0.000000000000,0.850650787354,0.525731086731],
[0.000000000000,-0.850650787354,0.525731086731],
[0.000000000000,-0.850650787354,-0.525731086731],
[0.000000000000,0.850650787354,-0.525731086731],
[0.309016972780,0.499999970198,0.809016942978],
[-0.309016972780,0.499999970198,0.809016942978],
[0.000000000000,0.000000000000,0.999999940395],
[-0.309016972780,-0.499999970198,0.809016942978],
[0.309016972780,-0.499999970198,0.809016942978],
[0.000000000000,0.000000000000,-0.999999940395],
[-0.309016972780,0.499999970198,-0.809016942978],
[0.309016972780,0.499999970198,-0.809016942978],
[0.309016972780,-0.499999970198,-0.809016942978],
[-0.309016972780,-0.499999970198,-0.809016942978],
[0.809016942978,0.309016972780,0.499999970198],
[0.809016942978,-0.309016972780,0.499999970198],
[0.999999940395,0.000000000000,0.000000000000],
[0.809016942978,-0.309016972780,-0.499999970198],
[0.809016942978,0.309016972780,-0.499999970198],
[-0.809016942978,-0.309016972780,0.499999970198],
[-0.809016942978,0.309016972780,0.499999970198],
[-0.999999940395,0.000000000000,0.000000000000],
[-0.809016942978,0.309016972780,-0.499999970198],
[-0.809016942978,-0.309016972780,-0.499999970198],
[0.499999970198,0.809016942978,0.309016972780],
[0.499999970198,0.809016942978,-0.309016972780],
[0.000000000000,0.999999940395,0.000000000000],
[-0.499999970198,0.809016942978,-0.309016972780],
[-0.499999970198,0.809016942978,0.309016972780],
[0.000000000000,-0.999999940395,0.000000000000],
[0.499999970198,-0.809016942978,-0.309016972780],
[0.499999970198,-0.809016942978,0.309016972780],
[-0.499999970198,-0.809016942978,0.309016972780],
[-0.499999970198,-0.809016942978,-0.309016972780],
[0.433888554573,0.259891897440,0.862668514252],
[0.162459850311,0.262865543365,0.951056540012],
[0.273266524076,0.000000000000,0.961938381195],
[0.162459850311,-0.262865543365,0.951056540012],
[0.433888554573,-0.259891897440,0.862668514252],
[0.273266524076,0.000000000000,-0.961938381195],
[0.162459850311,0.262865543365,-0.951056540012],
[0.433888554573,0.259891897440,-0.862668514252],
[0.433888554573,-0.259891897440,-0.862668514252],
[0.162459850311,-0.262865543365,-0.951056540012],
[0.862668514252,0.433888554573,0.259891897440],
[0.951056540012,0.162459850311,0.262865543365],
[0.961938381195,0.273266524076,0.000000000000],
[0.951056540012,0.162459850311,-0.262865543365],
[0.862668514252,0.433888554573,-0.259891897440],
[-0.862668514252,-0.433888554573,0.259891897440],
[-0.951056540012,-0.162459850311,0.262865543365],
[-0.961938381195,-0.273266524076,0.000000000000],
[-0.951056540012,-0.162459850311,-0.262865543365],
[-0.862668514252,-0.433888554573,-0.259891897440],
[0.259891897440,0.862668514252,0.433888554573],
[0.262865543365,0.951056540012,0.162459850311],
[0.000000000000,0.961938381195,0.273266524076],
[-0.262865543365,0.951056540012,0.162459850311],
[-0.259891897440,0.862668514252,0.433888554573],
[0.000000000000,-0.961938381195,0.273266524076],
[0.262865543365,-0.951056540012,0.162459850311],
[0.259891897440,-0.862668514252,0.433888554573],
[-0.259891897440,-0.862668514252,0.433888554573],
[-0.262865543365,-0.951056540012,0.162459850311],
[0.160622030497,0.702046453953,0.693780481815],
[0.425325393677,0.688190996647,0.587785243988],
[0.259891897440,0.862668514252,-0.433888554573],
[0.425325393677,0.688190996647,-0.587785243988],
[0.160622030497,0.702046453953,-0.693780481815],
[0.587785243988,-0.425325393677,0.688190996647],
[0.693780481815,-0.160622030497,0.702046453953],
[0.693780481815,-0.160622030497,-0.702046453953],
[0.587785243988,-0.425325393677,-0.688190996647],
[-0.433888554573,0.259891897440,0.862668514252],
[-0.587785243988,0.425325393677,0.688190996647],
[-0.693780481815,0.160622030497,0.702046453953],
[-0.693780481815,0.160622030497,-0.702046453953],
[-0.587785243988,0.425325393677,-0.688190996647],
[-0.433888554573,0.259891897440,-0.862668514252],
[-0.693780481815,-0.160622030497,0.702046453953],
[-0.587785243988,-0.425325393677,0.688190996647],
[-0.433888554573,-0.259891897440,0.862668514252],
[-0.433888554573,-0.259891897440,-0.862668514252],
[-0.587785243988,-0.425325393677,-0.688190996647],
[-0.693780481815,-0.160622030497,-0.702046453953],
[0.000000000000,0.525731086731,0.850650787354],
[-0.160622030497,0.702046453953,0.693780481815],
[-0.273266524076,0.000000000000,0.961938381195],
[-0.162459850311,0.262865543365,0.951056540012],
[-0.162459850311,-0.262865543365,0.951056540012],
[0.160622030497,-0.702046453953,0.693780481815],
[0.000000000000,-0.525731086731,0.850650787354],
[-0.160622030497,-0.702046453953,0.693780481815],
[-0.273266524076,0.000000000000,-0.961938381195],
[-0.162459850311,0.262865543365,-0.951056540012],
[0.000000000000,0.525731086731,-0.850650787354],
[-0.160622030497,0.702046453953,-0.693780481815],
[0.160622030497,-0.702046453953,-0.693780481815],
[0.000000000000,-0.525731086731,-0.850650787354],
[-0.160622030497,-0.702046453953,-0.693780481815],
[-0.162459850311,-0.262865543365,-0.951056540012],
[0.693780481815,0.160622030497,0.702046453953],
[0.850650787354,0.000000000000,0.525731086731],
[0.961938381195,-0.273266524076,0.000000000000],
[0.951056540012,-0.162459850311,0.262865543365],
[0.862668514252,-0.433888554573,0.259891897440],
[0.951056540012,-0.162459850311,-0.262865543365],
[0.862668514252,-0.433888554573,-0.259891897440],
[0.693780481815,0.160622030497,-0.702046453953],
[0.850650787354,0.000000000000,-0.525731086731],
[-0.850650787354,0.000000000000,0.525731086731],
[-0.961938381195,0.273266524076,0.000000000000],
[-0.951056540012,0.162459850311,0.262865543365],
[-0.862668514252,0.433888554573,0.259891897440],
[-0.951056540012,0.162459850311,-0.262865543365],
[-0.862668514252,0.433888554573,-0.259891897440],
[-0.850650787354,0.000000000000,-0.525731086731],
[0.702046453953,0.693780481815,0.160622030497],
[0.525731086731,0.850650787354,0.000000000000],
[0.702046453953,0.693780481815,-0.160622030497],
[0.000000000000,0.961938381195,-0.273266524076],
[0.262865543365,0.951056540012,-0.162459850311],
[-0.262865543365,0.951056540012,-0.162459850311],
[-0.259891897440,0.862668514252,-0.433888554573],
[-0.702046453953,0.693780481815,0.160622030497],
[-0.525731086731,0.850650787354,0.000000000000],
[-0.702046453953,0.693780481815,-0.160622030497],
[0.000000000000,-0.961938381195,-0.273266524076],
[0.262865543365,-0.951056540012,-0.162459850311],
[0.259891897440,-0.862668514252,-0.433888554573],
[0.702046453953,-0.693780481815,0.160622030497],
[0.525731086731,-0.850650787354,0.000000000000],
[0.702046453953,-0.693780481815,-0.160622030497],
[-0.702046453953,-0.693780481815,0.160622030497],
[-0.525731086731,-0.850650787354,0.000000000000],
[-0.702046453953,-0.693780481815,-0.160622030497],
[-0.262865543365,-0.951056540012,-0.162459850311],
[-0.259891897440,-0.862668514252,-0.433888554573],
[0.587785243988,0.425325393677,0.688190996647],
[0.688190996647,0.587785243988,0.425325393677],
[0.688190996647,0.587785243988,-0.425325393677],
[0.587785243988,0.425325393677,-0.688190996647],
[0.425325393677,-0.688190996647,0.587785243988],
[0.688190996647,-0.587785243988,0.425325393677],
[0.688190996647,-0.587785243988,-0.425325393677],
[0.425325393677,-0.688190996647,-0.587785243988],
[-0.425325393677,0.688190996647,0.587785243988],
[-0.688190996647,0.587785243988,0.425325393677],
[-0.688190996647,0.587785243988,-0.425325393677],
[-0.425325393677,0.688190996647,-0.587785243988],
[-0.688190996647,-0.587785243988,0.425325393677],
[-0.425325393677,-0.688190996647,0.587785243988],
[-0.425325393677,-0.688190996647,-0.587785243988],
[-0.688190996647,-0.587785243988,-0.425325393677],
[0.484441637993,0.131200373173,0.864929378033],
[0.358228772879,0.131655350327,0.924304544926],
[0.403355360031,0.000000000000,0.915043473244],
[0.358228772879,-0.131655350327,0.924304544926],
[0.484441637993,-0.131200373173,0.864929378033],
[0.403355360031,0.000000000000,-0.915043473244],
[0.358228772879,0.131655350327,-0.924304544926],
[0.484441637993,0.131200373173,-0.864929378033],
[0.484441637993,-0.131200373173,-0.864929378033],
[0.358228772879,-0.131655350327,-0.924304544926],
[0.864929378033,0.484441637993,0.131200373173],
[0.924304544926,0.358228772879,0.131655350327],
[0.915043473244,0.403355360031,0.000000000000],
[0.924304544926,0.358228772879,-0.131655350327],
[0.864929378033,0.484441637993,-0.131200373173],
[-0.864929378033,-0.484441637993,0.131200373173],
[-0.924304544926,-0.358228772879,0.131655350327],
[-0.915043473244,-0.403355360031,0.000000000000],
[-0.924304544926,-0.358228772879,-0.131655350327],
[-0.864929378033,-0.484441637993,-0.131200373173],
[0.131200373173,0.864929378033,0.484441637993],
[0.131655350327,0.924304544926,0.358228772879],
[0.000000000000,0.915043473244,0.403355360031],
[-0.131655350327,0.924304544926,0.358228772879],
[-0.131200373173,0.864929378033,0.484441637993],
[0.000000000000,-0.915043473244,0.403355360031],
[0.131655350327,-0.924304544926,0.358228772879],
[0.131200373173,-0.864929378033,0.484441637993],
[-0.131200373173,-0.864929378033,0.484441637993],
[-0.131655350327,-0.924304544926,0.358228772879],
[0.081086292863,0.783843040466,0.615642011166],
[0.213022843003,0.792649149895,0.571251630783],
[0.131200373173,0.864929378033,-0.484441637993],
[0.213022843003,0.792649149895,-0.571251630783],
[0.081086292863,0.783843040466,-0.615642011166],
[0.571251630783,-0.213022843003,0.792649149895],
[0.615642011166,-0.081086292863,0.783843040466],
[0.615642011166,-0.081086292863,-0.783843040466],
[0.571251630783,-0.213022843003,-0.792649149895],
[-0.484441637993,0.131200373173,0.864929378033],
[-0.571251630783,0.213022843003,0.792649149895],
[-0.615642011166,0.081086292863,0.783843040466],
[-0.615642011166,0.081086292863,-0.783843040466],
[-0.571251630783,0.213022843003,-0.792649149895],
[-0.484441637993,0.131200373173,-0.864929378033],
[-0.615642011166,-0.081086292863,0.783843040466],
[-0.571251630783,-0.213022843003,0.792649149895],
[-0.484441637993,-0.131200373173,0.864929378033],
[-0.484441637993,-0.131200373173,-0.864929378033],
[-0.571251630783,-0.213022843003,-0.792649149895],
[-0.615642011166,-0.081086292863,-0.783843040466],
[0.000000000000,0.711281716824,0.702906966209],
[-0.081086292863,0.783843040466,0.615642011166],
[-0.403355360031,0.000000000000,0.915043473244],
[-0.358228772879,0.131655350327,0.924304544926],
[0.156434446573,0.519258499146,0.840177834034],
[0.082323580980,0.399607032537,0.912982463837],
[0.238676920533,0.386187374592,0.891006469727],
[-0.358228772879,-0.131655350327,0.924304544926],
[0.081086292863,-0.783843040466,0.615642011166],
[0.000000000000,-0.711281716824,0.702906966209],
[-0.081086292863,-0.783843040466,0.615642011166],
[-0.082242466509,-0.133071094751,0.987688302994],
[0.000000000000,-0.266404688358,0.963861286640],
[0.082242466509,-0.133071094751,0.987688302994],
[-0.403355360031,0.000000000000,-0.915043473244],
[-0.358228772879,0.131655350327,-0.924304544926],
[0.000000000000,0.711281716824,-0.702906966209],
[-0.081086292863,0.783843040466,-0.615642011166],
[-0.082242466509,0.133071094751,-0.987688302994],
[0.000000000000,0.266404688358,-0.963861286640],
[0.082242466509,0.133071094751,-0.987688302994],
[0.081086292863,-0.783843040466,-0.615642011166],
[0.000000000000,-0.711281716824,-0.702906966209],
[-0.081086292863,-0.783843040466,-0.615642011166],
[-0.358228772879,-0.131655350327,-0.924304544926],
[0.156434446573,-0.519258499146,-0.840177834034],
[0.082323580980,-0.399607032537,-0.912982463837],
[0.238676920533,-0.386187374592,-0.891006469727],
[0.615642011166,0.081086292863,0.783843040466],
[0.702906966209,0.000000000000,0.711281716824],
[0.915043473244,-0.403355360031,0.000000000000],
[0.924304544926,-0.358228772879,0.131655350327],
[0.864929378033,-0.484441637993,0.131200373173],
[0.840177834034,0.156434446573,0.519258499146],
[0.912982463837,0.082323580980,0.399607032537],
[0.891006469727,0.238676920533,0.386187374592],
[0.924304544926,-0.358228772879,-0.131655350327],
[0.864929378033,-0.484441637993,-0.131200373173],
[0.615642011166,0.081086292863,-0.783843040466],
[0.702906966209,0.000000000000,-0.711281716824],
[0.987688302994,-0.082242466509,-0.133071094751],
[0.963861286640,0.000000000000,-0.266404688358],
[0.987688302994,0.082242466509,-0.133071094751],
[-0.702906966209,0.000000000000,0.711281716824],
[-0.915043473244,0.403355360031,0.000000000000],
[-0.924304544926,0.358228772879,0.131655350327],
[-0.864929378033,0.484441637993,0.131200373173],
[-0.840177834034,-0.156434446573,0.519258499146],
[-0.912982463837,-0.082323580980,0.399607032537],
[-0.891006469727,-0.238676920533,0.386187374592],
[-0.924304544926,0.358228772879,-0.131655350327],
[-0.864929378033,0.484441637993,-0.131200373173],
[-0.702906966209,0.000000000000,-0.711281716824],
[-0.987688302994,0.082242466509,-0.133071094751],
[-0.963861286640,0.000000000000,-0.266404688358],
[-0.987688302994,-0.082242466509,-0.133071094751],
[0.783843040466,0.615642011166,0.081086292863],
[0.711281716824,0.702906966209,0.000000000000],
[0.783843040466,0.615642011166,-0.081086292863],
[0.000000000000,0.915043473244,-0.403355360031],
[0.131655350327,0.924304544926,-0.358228772879],
[0.519258499146,0.840177834034,0.156434446573],
[0.399607032537,0.912982463837,0.082323580980],
[0.386187434196,0.891006588936,0.238676950336],
[-0.131655350327,0.924304544926,-0.358228772879],
[-0.131200373173,0.864929378033,-0.484441637993],
[-0.783843040466,0.615642011166,0.081086292863],
[-0.711281716824,0.702906966209,0.000000000000],
[-0.783843040466,0.615642011166,-0.081086292863],
[-0.133071094751,0.987688302994,-0.082242466509],
[-0.266404688358,0.963861286640,0.000000000000],
[-0.133071094751,0.987688302994,0.082242466509],
[0.000000000000,-0.915043473244,-0.403355360031],
[0.131655350327,-0.924304544926,-0.358228772879],
[0.131200373173,-0.864929378033,-0.484441637993],
[0.783843040466,-0.615642011166,0.081086292863],
[0.711281716824,-0.702906966209,0.000000000000],
[0.783843040466,-0.615642011166,-0.081086292863],
[0.133071094751,-0.987688302994,-0.082242466509],
[0.266404688358,-0.963861286640,0.000000000000],
[0.133071094751,-0.987688302994,0.082242466509],
[-0.783843040466,-0.615642011166,0.081086292863],
[-0.711281716824,-0.702906966209,0.000000000000],
[-0.783843040466,-0.615642011166,-0.081086292863],
[-0.131655350327,-0.924304544926,-0.358228772879],
[-0.131200373173,-0.864929378033,-0.484441637993],
[-0.519258499146,-0.840177834034,0.156434446573],
[-0.399607032537,-0.912982463837,0.082323580980],
[-0.386187434196,-0.891006588936,0.238676950336],
[0.571251630783,0.213022843003,0.792649149895],
[0.792649269104,0.571251690388,0.213022872806],
[0.453990459442,0.468429833651,0.757935404778],
[0.513375461102,0.564254224300,0.646577775478],
[0.371748000383,0.601500928402,0.707106769085],
[0.792649269104,0.571251690388,-0.213022872806],
[0.571251630783,0.213022843003,-0.792649149895],
[0.601500928402,0.707106769085,-0.371748000383],
[0.564254224300,0.646577775478,-0.513375461102],
[0.468429833651,0.757935404778,-0.453990459442],
[0.213022843003,-0.792649149895,0.571251630783],
[0.792649269104,-0.571251690388,0.213022872806],
[0.371748000383,-0.601500928402,0.707106769085],
[0.513375461102,-0.564254224300,0.646577775478],
[0.453990459442,-0.468429833651,0.757935404778],
[0.792649269104,-0.571251690388,-0.213022872806],
[0.213022843003,-0.792649149895,-0.571251630783],
[0.757935404778,-0.453990459442,-0.468429833651],
[0.646577775478,-0.513375461102,-0.564254224300],
[0.707106769085,-0.371748000383,-0.601500928402],
[-0.213022843003,0.792649149895,0.571251630783],
[-0.792649269104,0.571251690388,0.213022872806],
[-0.371748000383,0.601500928402,0.707106769085],
[-0.513375461102,0.564254224300,0.646577775478],
[-0.453990459442,0.468429833651,0.757935404778],
[-0.792649269104,0.571251690388,-0.213022872806],
[-0.213022843003,0.792649149895,-0.571251630783],
[-0.757935404778,0.453990459442,-0.468429833651],
[-0.646577775478,0.513375461102,-0.564254224300],
[-0.707106769085,0.371748000383,-0.601500928402],
[-0.792649269104,-0.571251690388,0.213022872806],
[-0.213022843003,-0.792649149895,0.571251630783],
[-0.757935404778,-0.453990459442,0.468429833651],
[-0.646577775478,-0.513375461102,0.564254224300],
[-0.707106769085,-0.371748000383,0.601500928402],
[-0.213022843003,-0.792649149895,-0.571251630783],
[-0.792649269104,-0.571251690388,-0.213022872806],
[-0.371748000383,-0.601500928402,-0.707106769085],
[-0.513375461102,-0.564254224300,-0.646577775478],
[-0.453990459442,-0.468429833651,-0.757935404778],
[0.375038534403,0.383613735437,0.843911468983],
[0.301258891821,0.264082729816,0.916244208813],
[0.137952238321,0.000000000000,0.990438938141],
[0.220117032528,0.132792472839,0.966392636299],
[0.082242466509,0.133071094751,0.987688302994],
[0.220117032528,-0.132792472839,0.966392636299],
[0.375038534403,-0.383613735437,0.843911468983],
[0.301258891821,-0.264082729816,0.916244208813],
[0.238676920533,-0.386187374592,0.891006469727],
[0.137952238321,0.000000000000,-0.990438938141],
[0.220117032528,0.132792472839,-0.966392636299],
[0.375038534403,0.383613735437,-0.843911468983],
[0.301258891821,0.264082729816,-0.916244208813],
[0.238676920533,0.386187374592,-0.891006469727],
[0.375038534403,-0.383613735437,-0.843911468983],
[0.301258891821,-0.264082729816,-0.916244208813],
[0.220117032528,-0.132792472839,-0.966392636299],
[0.082242466509,-0.133071094751,-0.987688302994],
[0.843911468983,0.375038534403,0.383613735437],
[0.916244208813,0.301258891821,0.264082729816],
[0.990438938141,0.137952238321,0.000000000000],
[0.966392636299,0.220117032528,0.132792472839],
[0.987688302994,0.082242466509,0.133071094751],
[0.966392636299,0.220117032528,-0.132792472839],
[0.843911468983,0.375038534403,-0.383613735437],
[0.916244208813,0.301258891821,-0.264082729816],
[0.891006469727,0.238676920533,-0.386187374592],
[-0.843911468983,-0.375038534403,0.383613735437],
[-0.916244208813,-0.301258891821,0.264082729816],
[-0.990438938141,-0.137952238321,0.000000000000],
[-0.966392636299,-0.220117032528,0.132792472839],
[-0.987688302994,-0.082242466509,0.133071094751],
[-0.966392636299,-0.220117032528,-0.132792472839],
[-0.843911468983,-0.375038534403,-0.383613735437],
[-0.916244208813,-0.301258891821,-0.264082729816],
[-0.891006469727,-0.238676920533,-0.386187374592],
[0.383613735437,0.843911468983,0.375038534403],
[0.264082729816,0.916244208813,0.301258891821],
[0.000000000000,0.990438938141,0.137952238321],
[0.132792472839,0.966392636299,0.220117032528],
[0.133071094751,0.987688302994,0.082242466509],
[-0.132792472839,0.966392636299,0.220117032528],
[-0.383613735437,0.843911468983,0.375038534403],
[-0.264082729816,0.916244208813,0.301258891821],
[-0.386187434196,0.891006588936,0.238676950336],
[0.000000000000,-0.990438938141,0.137952238321],
[0.132792472839,-0.966392636299,0.220117032528],
[0.383613735437,-0.843911468983,0.375038534403],
[0.264082729816,-0.916244208813,0.301258891821],
[0.386187434196,-0.891006588936,0.238676950336],
[-0.383613735437,-0.843911468983,0.375038534403],
[-0.264082729816,-0.916244208813,0.301258891821],
[-0.132792472839,-0.966392636299,0.220117032528],
[-0.133071094751,-0.987688302994,0.082242466509],
[0.237086325884,0.606825172901,0.758652269840],
[0.296004563570,0.702309906483,0.647411882877],
[0.346152991056,0.783451735973,0.516121625900],
[0.468429833651,0.757935404778,0.453990459442],
[0.383613735437,0.843911468983,-0.375038534403],
[0.346152991056,0.783451735973,-0.516121625900],
[0.237086325884,0.606825172901,-0.758652269840],
[0.296004563570,0.702309906483,-0.647411882877],
[0.371748000383,0.601500928402,-0.707106769085],
[0.516121625900,-0.346152991056,0.783451735973],
[0.758652269840,-0.237086325884,0.606825172901],
[0.647411882877,-0.296004563570,0.702309906483],
[0.707106769085,-0.371748000383,0.601500928402],
[0.758652269840,-0.237086325884,-0.606825172901],
[0.647411882877,-0.296004563570,-0.702309906483],
[0.516121625900,-0.346152991056,-0.783451735973],
[0.453990459442,-0.468429833651,-0.757935404778],
[-0.375038534403,0.383613735437,0.843911468983],
[-0.516121625900,0.346152991056,0.783451735973],
[-0.758652269840,0.237086325884,0.606825172901],
[-0.647411882877,0.296004563570,0.702309906483],
[-0.707106769085,0.371748000383,0.601500928402],
[-0.758652269840,0.237086325884,-0.606825172901],
[-0.647411882877,0.296004563570,-0.702309906483],
[-0.375038534403,0.383613735437,-0.843911468983],
[-0.516121625900,0.346152991056,-0.783451735973],
[-0.453990459442,0.468429833651,-0.757935404778],
[-0.758652269840,-0.237086325884,0.606825172901],
[-0.647411882877,-0.296004563570,0.702309906483],
[-0.375038534403,-0.383613735437,0.843911468983],
[-0.516121625900,-0.346152991056,0.783451735973],
[-0.453990459442,-0.468429833651,0.757935404778],
[-0.375038534403,-0.383613735437,-0.843911468983],
[-0.516121625900,-0.346152991056,-0.783451735973],
[-0.758652269840,-0.237086325884,-0.606825172901],
[-0.647411882877,-0.296004563570,-0.702309906483],
[-0.707106769085,-0.371748000383,-0.601500928402],
[0.081141851842,0.620239555836,0.780204355717],
[-0.237086325884,0.606825172901,0.758652269840],
[-0.081141851842,0.620239555836,0.780204355717],
[-0.156434446573,0.519258499146,0.840177834034],
[-0.137952238321,0.000000000000,0.990438938141],
[-0.220117032528,0.132792472839,0.966392636299],
[-0.082242466509,0.133071094751,0.987688302994],
[-0.301258891821,0.264082729816,0.916244208813],
[-0.238676920533,0.386187374592,0.891006469727],
[-0.082323580980,0.399607032537,0.912982463837],
[0.000000000000,0.266404688358,0.963861286640],
[-0.220117032528,-0.132792472839,0.966392636299],
[-0.301258891821,-0.264082729816,0.916244208813],
[-0.238676920533,-0.386187374592,0.891006469727],
[0.237086325884,-0.606825172901,0.758652269840],
[0.081141851842,-0.620239555836,0.780204355717],
[0.156434446573,-0.519258499146,0.840177834034],
[-0.237086325884,-0.606825172901,0.758652269840],
[-0.081141851842,-0.620239555836,0.780204355717],
[-0.156434446573,-0.519258499146,0.840177834034],
[-0.082323580980,-0.399607032537,0.912982463837],
[0.082323580980,-0.399607032537,0.912982463837],
[-0.137952238321,0.000000000000,-0.990438938141],
[-0.220117032528,0.132792472839,-0.966392636299],
[-0.301258891821,0.264082729816,-0.916244208813],
[-0.238676920533,0.386187374592,-0.891006469727],
[0.081141851842,0.620239555836,-0.780204355717],
[0.156434446573,0.519258499146,-0.840177834034],
[-0.237086325884,0.606825172901,-0.758652269840],
[-0.081141851842,0.620239555836,-0.780204355717],
[-0.156434446573,0.519258499146,-0.840177834034],
[-0.082323580980,0.399607032537,-0.912982463837],
[0.082323580980,0.399607032537,-0.912982463837],
[0.237086325884,-0.606825172901,-0.758652269840],
[0.081141851842,-0.620239555836,-0.780204355717],
[-0.237086325884,-0.606825172901,-0.758652269840],
[-0.081141851842,-0.620239555836,-0.780204355717],
[-0.156434446573,-0.519258499146,-0.840177834034],
[-0.220117032528,-0.132792472839,-0.966392636299],
[-0.082242466509,-0.133071094751,-0.987688302994],
[-0.301258891821,-0.264082729816,-0.916244208813],
[-0.238676920533,-0.386187374592,-0.891006469727],
[-0.082323580980,-0.399607032537,-0.912982463837],
[0.000000000000,-0.266404688358,-0.963861286640],
[0.758652269840,0.237086325884,0.606825172901],
[0.780204355717,0.081141851842,0.620239555836],
[0.780204355717,-0.081141851842,0.620239555836],
[0.840177834034,-0.156434446573,0.519258499146],
[0.990438938141,-0.137952238321,0.000000000000],
[0.966392636299,-0.220117032528,0.132792472839],
[0.987688302994,-0.082242466509,0.133071094751],
[0.843911468983,-0.375038534403,0.383613735437],
[0.916244208813,-0.301258891821,0.264082729816],
[0.891006469727,-0.238676920533,0.386187374592],
[0.912982463837,-0.082323580980,0.399607032537],
[0.963861286640,0.000000000000,0.266404688358],
[0.966392636299,-0.220117032528,-0.132792472839],
[0.843911468983,-0.375038534403,-0.383613735437],
[0.916244208813,-0.301258891821,-0.264082729816],
[0.891006469727,-0.238676920533,-0.386187374592],
[0.758652269840,0.237086325884,-0.606825172901],
[0.780204355717,0.081141851842,-0.620239555836],
[0.840177834034,0.156434446573,-0.519258499146],
[0.780204355717,-0.081141851842,-0.620239555836],
[0.840177834034,-0.156434446573,-0.519258499146],
[0.912982463837,-0.082323580980,-0.399607032537],
[0.912982463837,0.082323580980,-0.399607032537],
[-0.780204355717,-0.081141851842,0.620239555836],
[-0.780204355717,0.081141851842,0.620239555836],
[-0.840177834034,0.156434446573,0.519258499146],
[-0.990438938141,0.137952238321,0.000000000000],
[-0.966392636299,0.220117032528,0.132792472839],
[-0.987688302994,0.082242466509,0.133071094751],
[-0.843911468983,0.375038534403,0.383613735437],
[-0.916244208813,0.301258891821,0.264082729816],
[-0.891006469727,0.238676920533,0.386187374592],
[-0.912982463837,0.082323580980,0.399607032537],
[-0.963861286640,0.000000000000,0.266404688358],
[-0.966392636299,0.220117032528,-0.132792472839],
[-0.843911468983,0.375038534403,-0.383613735437],
[-0.916244208813,0.301258891821,-0.264082729816],
[-0.891006469727,0.238676920533,-0.386187374592],
[-0.780204355717,-0.081141851842,-0.620239555836],
[-0.840177834034,-0.156434446573,-0.519258499146],
[-0.780204355717,0.081141851842,-0.620239555836],
[-0.840177834034,0.156434446573,-0.519258499146],
[-0.912982463837,0.082323580980,-0.399607032537],
[-0.912982463837,-0.082323580980,-0.399607032537],
[0.606825172901,0.758652269840,0.237086325884],
[0.620239555836,0.780204355717,0.081141851842],
[0.606825172901,0.758652269840,-0.237086325884],
[0.620239555836,0.780204355717,-0.081141851842],
[0.519258499146,0.840177834034,-0.156434446573],
[0.000000000000,0.990438938141,-0.137952238321],
[0.132792472839,0.966392636299,-0.220117032528],
[0.133071094751,0.987688302994,-0.082242466509],
[0.264082729816,0.916244208813,-0.301258891821],
[0.386187434196,0.891006588936,-0.238676950336],
[0.399607032537,0.912982463837,-0.082323580980],
[0.266404688358,0.963861286640,0.000000000000],
[-0.132792472839,0.966392636299,-0.220117032528],
[-0.383613735437,0.843911468983,-0.375038534403],
[-0.264082729816,0.916244208813,-0.301258891821],
[-0.386187434196,0.891006588936,-0.238676950336],
[-0.606825172901,0.758652269840,0.237086325884],
[-0.620239555836,0.780204355717,0.081141851842],
[-0.519258499146,0.840177834034,0.156434446573],
[-0.606825172901,0.758652269840,-0.237086325884],
[-0.620239555836,0.780204355717,-0.081141851842],
[-0.519258499146,0.840177834034,-0.156434446573],
[-0.399607032537,0.912982463837,-0.082323580980],
[-0.399607032537,0.912982463837,0.082323580980],
[0.000000000000,-0.990438938141,-0.137952238321],
[0.132792472839,-0.966392636299,-0.220117032528],
[0.383613735437,-0.843911468983,-0.375038534403],
[0.264082729816,-0.916244208813,-0.301258891821],
[0.386187434196,-0.891006588936,-0.238676950336],
[0.606825172901,-0.758652269840,0.237086325884],
[0.620239555836,-0.780204355717,0.081141851842],
[0.519258499146,-0.840177834034,0.156434446573],
[0.606825172901,-0.758652269840,-0.237086325884],
[0.620239555836,-0.780204355717,-0.081141851842],
[0.519258499146,-0.840177834034,-0.156434446573],
[0.399607032537,-0.912982463837,-0.082323580980],
[0.399607032537,-0.912982463837,0.082323580980],
[-0.606825172901,-0.758652269840,0.237086325884],
[-0.620239555836,-0.780204355717,0.081141851842],
[-0.606825172901,-0.758652269840,-0.237086325884],
[-0.620239555836,-0.780204355717,-0.081141851842],
[-0.519258499146,-0.840177834034,-0.156434446573],
[-0.132792472839,-0.966392636299,-0.220117032528],
[-0.133071094751,-0.987688302994,-0.082242466509],
[-0.383613735437,-0.843911468983,-0.375038534403],
[-0.264082729816,-0.916244208813,-0.301258891821],
[-0.386187434196,-0.891006588936,-0.238676950336],
[-0.399607032537,-0.912982463837,-0.082323580980],
[-0.266404688358,-0.963861286640,0.000000000000],
[0.516121625900,0.346152991056,0.783451735973],
[0.647411882877,0.296004563570,0.702309906483],
[0.707106769085,0.371748000383,0.601500928402],
[0.702309906483,0.647411882877,0.296004563570],
[0.601500928402,0.707106769085,0.371748000383],
[0.783451735973,0.516121625900,0.346152991056],
[0.757935404778,0.453990459442,0.468429833651],
[0.646577775478,0.513375461102,0.564254224300],
[0.564254224300,0.646577775478,0.513375461102],
[0.702309906483,0.647411882877,-0.296004563570],
[0.783451735973,0.516121625900,-0.346152991056],
[0.757935404778,0.453990459442,-0.468429833651],
[0.516121625900,0.346152991056,-0.783451735973],
[0.453990459442,0.468429833651,-0.757935404778],
[0.647411882877,0.296004563570,-0.702309906483],
[0.707106769085,0.371748000383,-0.601500928402],
[0.646577775478,0.513375461102,-0.564254224300],
[0.513375461102,0.564254224300,-0.646577775478],
[0.296004563570,-0.702309906483,0.647411882877],
[0.346152991056,-0.783451735973,0.516121625900],
[0.468429833651,-0.757935404778,0.453990459442],
[0.783451735973,-0.516121625900,0.346152991056],
[0.757935404778,-0.453990459442,0.468429833651],
[0.702309906483,-0.647411882877,0.296004563570],
[0.601500928402,-0.707106769085,0.371748000383],
[0.564254224300,-0.646577775478,0.513375461102],
[0.646577775478,-0.513375461102,0.564254224300],
[0.783451735973,-0.516121625900,-0.346152991056],
[0.702309906483,-0.647411882877,-0.296004563570],
[0.601500928402,-0.707106769085,-0.371748000383],
[0.296004563570,-0.702309906483,-0.647411882877],
[0.371748000383,-0.601500928402,-0.707106769085],
[0.346152991056,-0.783451735973,-0.516121625900],
[0.468429833651,-0.757935404778,-0.453990459442],
[0.564254224300,-0.646577775478,-0.513375461102],
[0.513375461102,-0.564254224300,-0.646577775478],
[-0.296004563570,0.702309906483,0.647411882877],
[-0.346152991056,0.783451735973,0.516121625900],
[-0.468429833651,0.757935404778,0.453990459442],
[-0.783451735973,0.516121625900,0.346152991056],
[-0.757935404778,0.453990459442,0.468429833651],
[-0.702309906483,0.647411882877,0.296004563570],
[-0.601500928402,0.707106769085,0.371748000383],
[-0.564254224300,0.646577775478,0.513375461102],
[-0.646577775478,0.513375461102,0.564254224300],
[-0.783451735973,0.516121625900,-0.346152991056],
[-0.702309906483,0.647411882877,-0.296004563570],
[-0.601500928402,0.707106769085,-0.371748000383],
[-0.296004563570,0.702309906483,-0.647411882877],
[-0.371748000383,0.601500928402,-0.707106769085],
[-0.346152991056,0.783451735973,-0.516121625900],
[-0.468429833651,0.757935404778,-0.453990459442],
[-0.564254224300,0.646577775478,-0.513375461102],
[-0.513375461102,0.564254224300,-0.646577775478],
[-0.783451735973,-0.516121625900,0.346152991056],
[-0.702309906483,-0.647411882877,0.296004563570],
[-0.601500928402,-0.707106769085,0.371748000383],
[-0.296004563570,-0.702309906483,0.647411882877],
[-0.371748000383,-0.601500928402,0.707106769085],
[-0.346152991056,-0.783451735973,0.516121625900],
[-0.468429833651,-0.757935404778,0.453990459442],
[-0.564254224300,-0.646577775478,0.513375461102],
[-0.513375461102,-0.564254224300,0.646577775478],
[-0.296004563570,-0.702309906483,-0.647411882877],
[-0.346152991056,-0.783451735973,-0.516121625900],
[-0.468429833651,-0.757935404778,-0.453990459442],
[-0.783451735973,-0.516121625900,-0.346152991056],
[-0.757935404778,-0.453990459442,-0.468429833651],
[-0.702309906483,-0.647411882877,-0.296004563570],
[-0.601500928402,-0.707106769085,-0.371748000383],
[-0.564254224300,-0.646577775478,-0.513375461102],
[-0.646577775478,-0.513375461102,-0.564254224300],
[0.850650787354,0.525731086731,0.000000000000],
[-0.850650787354,0.525731086731,0.000000000000],
[-0.850650787354,-0.525731086731,0.000000000000],
[0.850650787354,-0.525731086731,0.000000000000],
[0.525731086731,0.000000000000,0.850650787354],
[0.525731086731,0.000000000000,-0.850650787354],
[-0.525731086731,0.000000000000,-0.850650787354],
[-0.525731086731,0.000000000000,0.850650787354],
[0.000000000000,0.850650787354,0.525731086731],
[0.000000000000,-0.850650787354,0.525731086731],
[0.000000000000,-0.850650787354,-0.525731086731],
[0.000000000000,0.850650787354,-0.525731086731],
[0.309016972780,0.499999970198,0.809016942978],
[-0.309016972780,0.499999970198,0.809016942978],
[0.000000000000,0.000000000000,0.999999940395],
[-0.309016972780,-0.499999970198,0.809016942978],
[0.309016972780,-0.499999970198,0.809016942978],
[0.000000000000,0.000000000000,-0.999999940395],
[-0.309016972780,0.499999970198,-0.809016942978],
[0.309016972780,0.499999970198,-0.809016942978],
[0.309016972780,-0.499999970198,-0.809016942978],
[-0.309016972780,-0.499999970198,-0.809016942978],
[0.809016942978,0.309016972780,0.499999970198],
[0.809016942978,-0.309016972780,0.499999970198],
[0.999999940395,0.000000000000,0.000000000000],
[0.809016942978,-0.309016972780,-0.499999970198],
[0.809016942978,0.309016972780,-0.499999970198],
[-0.809016942978,-0.309016972780,0.499999970198],
[-0.809016942978,0.309016972780,0.499999970198],
[-0.999999940395,0.000000000000,0.000000000000],
[-0.809016942978,0.309016972780,-0.499999970198],
[-0.809016942978,-0.309016972780,-0.499999970198],
[0.499999970198,0.809016942978,0.309016972780],
[0.499999970198,0.809016942978,-0.309016972780],
[0.000000000000,0.999999940395,0.000000000000],
[-0.499999970198,0.809016942978,-0.309016972780],
[-0.499999970198,0.809016942978,0.309016972780],
[0.000000000000,-0.999999940395,0.000000000000],
[0.499999970198,-0.809016942978,-0.309016972780],
[0.499999970198,-0.809016942978,0.309016972780],
[-0.499999970198,-0.809016942978,0.309016972780],
[-0.499999970198,-0.809016942978,-0.309016972780],
[0.433888554573,0.259891897440,0.862668514252],
[0.162459850311,0.262865543365,0.951056540012],
[0.273266524076,0.000000000000,0.961938381195],
[0.162459850311,-0.262865543365,0.951056540012],
[0.433888554573,-0.259891897440,0.862668514252],
[0.273266524076,0.000000000000,-0.961938381195],
[0.162459850311,0.262865543365,-0.951056540012],
[0.433888554573,0.259891897440,-0.862668514252],
[0.433888554573,-0.259891897440,-0.862668514252],
[0.162459850311,-0.262865543365,-0.951056540012],
[0.862668514252,0.433888554573,0.259891897440],
[0.951056540012,0.162459850311,0.262865543365],
[0.961938381195,0.273266524076,0.000000000000],
[0.951056540012,0.162459850311,-0.262865543365],
[0.862668514252,0.433888554573,-0.259891897440],
[-0.862668514252,-0.433888554573,0.259891897440],
[-0.951056540012,-0.162459850311,0.262865543365],
[-0.961938381195,-0.273266524076,0.000000000000],
[-0.951056540012,-0.162459850311,-0.262865543365],
[-0.862668514252,-0.433888554573,-0.259891897440],
[0.259891897440,0.862668514252,0.433888554573],
[0.262865543365,0.951056540012,0.162459850311],
[0.000000000000,0.961938381195,0.273266524076],
[-0.262865543365,0.951056540012,0.162459850311],
[-0.259891897440,0.862668514252,0.433888554573],
[0.000000000000,-0.961938381195,0.273266524076],
[0.262865543365,-0.951056540012,0.162459850311],
[0.259891897440,-0.862668514252,0.433888554573],
[-0.259891897440,-0.862668514252,0.433888554573],
[-0.262865543365,-0.951056540012,0.162459850311],
[0.160622030497,0.702046453953,0.693780481815],
[0.425325393677,0.688190996647,0.587785243988],
[0.259891897440,0.862668514252,-0.433888554573],
[0.425325393677,0.688190996647,-0.587785243988],
[0.160622030497,0.702046453953,-0.693780481815],
[0.587785243988,-0.425325393677,0.688190996647],
[0.693780481815,-0.160622030497,0.702046453953],
[0.693780481815,-0.160622030497,-0.702046453953],
[0.587785243988,-0.425325393677,-0.688190996647],
[-0.433888554573,0.259891897440,0.862668514252],
[-0.587785243988,0.425325393677,0.688190996647],
[-0.693780481815,0.160622030497,0.702046453953],
[-0.693780481815,0.160622030497,-0.702046453953],
[-0.587785243988,0.425325393677,-0.688190996647],
[-0.433888554573,0.259891897440,-0.862668514252],
[-0.693780481815,-0.160622030497,0.702046453953],
[-0.587785243988,-0.425325393677,0.688190996647],
[-0.433888554573,-0.259891897440,0.862668514252],
[-0.433888554573,-0.259891897440,-0.862668514252],
[-0.587785243988,-0.425325393677,-0.688190996647],
[-0.693780481815,-0.160622030497,-0.702046453953],
[0.000000000000,0.525731086731,0.850650787354],
[-0.160622030497,0.702046453953,0.693780481815],
[-0.273266524076,0.000000000000,0.961938381195],
[-0.162459850311,0.262865543365,0.951056540012],
[-0.162459850311,-0.262865543365,0.951056540012],
[0.160622030497,-0.702046453953,0.693780481815],
[0.000000000000,-0.525731086731,0.850650787354],
[-0.160622030497,-0.702046453953,0.693780481815],
[-0.273266524076,0.000000000000,-0.961938381195],
[-0.162459850311,0.262865543365,-0.951056540012],
[0.000000000000,0.525731086731,-0.850650787354],
[-0.160622030497,0.702046453953,-0.693780481815],
[0.160622030497,-0.702046453953,-0.693780481815],
[0.000000000000,-0.525731086731,-0.850650787354],
[-0.160622030497,-0.702046453953,-0.693780481815],
[-0.162459850311,-0.262865543365,-0.951056540012],
[0.693780481815,0.160622030497,0.702046453953],
[0.850650787354,0.000000000000,0.525731086731],
[0.961938381195,-0.273266524076,0.000000000000],
[0.951056540012,-0.162459850311,0.262865543365],
[0.862668514252,-0.433888554573,0.259891897440],
[0.951056540012,-0.162459850311,-0.262865543365],
[0.862668514252,-0.433888554573,-0.259891897440],
[0.693780481815,0.160622030497,-0.702046453953],
[0.850650787354,0.000000000000,-0.525731086731],
[-0.850650787354,0.000000000000,0.525731086731],
[-0.961938381195,0.273266524076,0.000000000000],
[-0.951056540012,0.162459850311,0.262865543365],
[-0.862668514252,0.433888554573,0.259891897440],
[-0.951056540012,0.162459850311,-0.262865543365],
[-0.862668514252,0.433888554573,-0.259891897440],
[-0.850650787354,0.000000000000,-0.525731086731],
[0.702046453953,0.693780481815,0.160622030497],
[0.525731086731,0.850650787354,0.000000000000],
[0.702046453953,0.693780481815,-0.160622030497],
[0.000000000000,0.961938381195,-0.273266524076],
[0.262865543365,0.951056540012,-0.162459850311],
[-0.262865543365,0.951056540012,-0.162459850311],
[-0.259891897440,0.862668514252,-0.433888554573],
[-0.702046453953,0.693780481815,0.160622030497],
[-0.525731086731,0.850650787354,0.000000000000],
[-0.702046453953,0.693780481815,-0.160622030497],
[0.000000000000,-0.961938381195,-0.273266524076],
[0.262865543365,-0.951056540012,-0.162459850311],
[0.259891897440,-0.862668514252,-0.433888554573],
[0.702046453953,-0.693780481815,0.160622030497],
[0.525731086731,-0.850650787354,0.000000000000],
[0.702046453953,-0.693780481815,-0.160622030497],
[-0.702046453953,-0.693780481815,0.160622030497],
[-0.525731086731,-0.850650787354,0.000000000000],
[-0.702046453953,-0.693780481815,-0.160622030497],
[-0.262865543365,-0.951056540012,-0.162459850311],
[-0.259891897440,-0.862668514252,-0.433888554573],
[0.587785243988,0.425325393677,0.688190996647],
[0.688190996647,0.587785243988,0.425325393677],
[0.688190996647,0.587785243988,-0.425325393677],
[0.587785243988,0.425325393677,-0.688190996647],
[0.425325393677,-0.688190996647,0.587785243988],
[0.688190996647,-0.587785243988,0.425325393677],
[0.688190996647,-0.587785243988,-0.425325393677],
[0.425325393677,-0.688190996647,-0.587785243988],
[-0.425325393677,0.688190996647,0.587785243988],
[-0.688190996647,0.587785243988,0.425325393677],
[-0.688190996647,0.587785243988,-0.425325393677],
[-0.425325393677,0.688190996647,-0.587785243988],
[-0.688190996647,-0.587785243988,0.425325393677],
[-0.425325393677,-0.688190996647,0.587785243988],
[-0.425325393677,-0.688190996647,-0.587785243988],
[-0.688190996647,-0.587785243988,-0.425325393677],
[0.484441637993,0.131200373173,0.864929378033],
[0.358228772879,0.131655350327,0.924304544926],
[0.403355360031,0.000000000000,0.915043473244],
[0.358228772879,-0.131655350327,0.924304544926],
[0.484441637993,-0.131200373173,0.864929378033],
[0.403355360031,0.000000000000,-0.915043473244],
[0.358228772879,0.131655350327,-0.924304544926],
[0.484441637993,0.131200373173,-0.864929378033],
[0.484441637993,-0.131200373173,-0.864929378033],
[0.358228772879,-0.131655350327,-0.924304544926],
[0.864929378033,0.484441637993,0.131200373173],
[0.924304544926,0.358228772879,0.131655350327],
[0.915043473244,0.403355360031,0.000000000000],
[0.924304544926,0.358228772879,-0.131655350327],
[0.864929378033,0.484441637993,-0.131200373173],
[-0.864929378033,-0.484441637993,0.131200373173],
[-0.924304544926,-0.358228772879,0.131655350327],
[-0.915043473244,-0.403355360031,0.000000000000],
[-0.924304544926,-0.358228772879,-0.131655350327],
[-0.864929378033,-0.484441637993,-0.131200373173],
[0.131200373173,0.864929378033,0.484441637993],
[0.131655350327,0.924304544926,0.358228772879],
[0.000000000000,0.915043473244,0.403355360031],
[-0.131655350327,0.924304544926,0.358228772879],
[-0.131200373173,0.864929378033,0.484441637993],
[0.000000000000,-0.915043473244,0.403355360031],
[0.131655350327,-0.924304544926,0.358228772879],
[0.131200373173,-0.864929378033,0.484441637993],
[-0.131200373173,-0.864929378033,0.484441637993],
[-0.131655350327,-0.924304544926,0.358228772879],
[0.081086292863,0.783843040466,0.615642011166],
[0.213022843003,0.792649149895,0.571251630783],
[0.131200373173,0.864929378033,-0.484441637993],
[0.213022843003,0.792649149895,-0.571251630783],
[0.081086292863,0.783843040466,-0.615642011166],
[0.571251630783,-0.213022843003,0.792649149895],
[0.615642011166,-0.081086292863,0.783843040466],
[0.615642011166,-0.081086292863,-0.783843040466],
[0.571251630783,-0.213022843003,-0.792649149895],
[-0.484441637993,0.131200373173,0.864929378033],
[-0.571251630783,0.213022843003,0.792649149895],
[-0.615642011166,0.081086292863,0.783843040466],
[-0.615642011166,0.081086292863,-0.783843040466],
[-0.571251630783,0.213022843003,-0.792649149895],
[-0.484441637993,0.131200373173,-0.864929378033],
[-0.615642011166,-0.081086292863,0.783843040466],
[-0.571251630783,-0.213022843003,0.792649149895],
[-0.484441637993,-0.131200373173,0.864929378033],
[-0.484441637993,-0.131200373173,-0.864929378033],
[-0.571251630783,-0.213022843003,-0.792649149895],
[-0.615642011166,-0.081086292863,-0.783843040466],
[0.000000000000,0.711281716824,0.702906966209],
[-0.081086292863,0.783843040466,0.615642011166],
[-0.403355360031,0.000000000000,0.915043473244],
[-0.358228772879,0.131655350327,0.924304544926],
[0.156434446573,0.519258499146,0.840177834034],
[0.082323580980,0.399607032537,0.912982463837],
[0.238676920533,0.386187374592,0.891006469727],
[-0.358228772879,-0.131655350327,0.924304544926],
[0.081086292863,-0.783843040466,0.615642011166],
[0.000000000000,-0.711281716824,0.702906966209],
[-0.081086292863,-0.783843040466,0.615642011166],
[-0.082242466509,-0.133071094751,0.987688302994],
[0.000000000000,-0.266404688358,0.963861286640],
[0.082242466509,-0.133071094751,0.987688302994],
[-0.403355360031,0.000000000000,-0.915043473244],
[-0.358228772879,0.131655350327,-0.924304544926],
[0.000000000000,0.711281716824,-0.702906966209],
[-0.081086292863,0.783843040466,-0.615642011166],
[-0.082242466509,0.133071094751,-0.987688302994],
[0.000000000000,0.266404688358,-0.963861286640],
[0.082242466509,0.133071094751,-0.987688302994],
[0.081086292863,-0.783843040466,-0.615642011166],
[0.000000000000,-0.711281716824,-0.702906966209],
[-0.081086292863,-0.783843040466,-0.615642011166],
[-0.358228772879,-0.131655350327,-0.924304544926],
[0.156434446573,-0.519258499146,-0.840177834034],
[0.082323580980,-0.399607032537,-0.912982463837],
[0.238676920533,-0.386187374592,-0.891006469727],
[0.615642011166,0.081086292863,0.783843040466],
[0.702906966209,0.000000000000,0.711281716824],
[0.915043473244,-0.403355360031,0.000000000000],
[0.924304544926,-0.358228772879,0.131655350327],
[0.864929378033,-0.484441637993,0.131200373173],
[0.840177834034,0.156434446573,0.519258499146],
[0.912982463837,0.082323580980,0.399607032537],
[0.891006469727,0.238676920533,0.386187374592],
[0.924304544926,-0.358228772879,-0.131655350327],
[0.864929378033,-0.484441637993,-0.131200373173],
[0.615642011166,0.081086292863,-0.783843040466],
[0.702906966209,0.000000000000,-0.711281716824],
[0.987688302994,-0.082242466509,-0.133071094751],
[0.963861286640,0.000000000000,-0.266404688358],
[0.987688302994,0.082242466509,-0.133071094751],
[-0.702906966209,0.000000000000,0.711281716824],
[-0.915043473244,0.403355360031,0.000000000000],
[-0.924304544926,0.358228772879,0.131655350327],
[-0.864929378033,0.484441637993,0.131200373173],
[-0.840177834034,-0.156434446573,0.519258499146],
[-0.912982463837,-0.082323580980,0.399607032537],
[-0.891006469727,-0.238676920533,0.386187374592],
[-0.924304544926,0.358228772879,-0.131655350327],
[-0.864929378033,0.484441637993,-0.131200373173],
[-0.702906966209,0.000000000000,-0.711281716824],
[-0.987688302994,0.082242466509,-0.133071094751],
[-0.963861286640,0.000000000000,-0.266404688358],
[-0.987688302994,-0.082242466509,-0.133071094751],
[0.783843040466,0.615642011166,0.081086292863],
[0.711281716824,0.702906966209,0.000000000000],
[0.783843040466,0.615642011166,-0.081086292863],
[0.000000000000,0.915043473244,-0.403355360031],
[0.131655350327,0.924304544926,-0.358228772879],
[0.519258499146,0.840177834034,0.156434446573],
[0.399607032537,0.912982463837,0.082323580980],
[0.386187434196,0.891006588936,0.238676950336],
[-0.131655350327,0.924304544926,-0.358228772879],
[-0.131200373173,0.864929378033,-0.484441637993],
[-0.783843040466,0.615642011166,0.081086292863],
[-0.711281716824,0.702906966209,0.000000000000],
[-0.783843040466,0.615642011166,-0.081086292863],
[-0.133071094751,0.987688302994,-0.082242466509],
[-0.266404688358,0.963861286640,0.000000000000],
[-0.133071094751,0.987688302994,0.082242466509],
[0.000000000000,-0.915043473244,-0.403355360031],
[0.131655350327,-0.924304544926,-0.358228772879],
[0.131200373173,-0.864929378033,-0.484441637993],
[0.783843040466,-0.615642011166,0.081086292863],
[0.711281716824,-0.702906966209,0.000000000000],
[0.783843040466,-0.615642011166,-0.081086292863],
[0.133071094751,-0.987688302994,-0.082242466509],
[0.266404688358,-0.963861286640,0.000000000000],
[0.133071094751,-0.987688302994,0.082242466509],
[-0.783843040466,-0.615642011166,0.081086292863],
[-0.711281716824,-0.702906966209,0.000000000000],
[-0.783843040466,-0.615642011166,-0.081086292863],
[-0.131655350327,-0.924304544926,-0.358228772879],
[-0.131200373173,-0.864929378033,-0.484441637993],
[-0.519258499146,-0.840177834034,0.156434446573],
[-0.399607032537,-0.912982463837,0.082323580980],
[-0.386187434196,-0.891006588936,0.238676950336],
[0.571251630783,0.213022843003,0.792649149895],
[0.792649269104,0.571251690388,0.213022872806],
[0.453990459442,0.468429833651,0.757935404778],
[0.513375461102,0.564254224300,0.646577775478],
[0.371748000383,0.601500928402,0.707106769085],
[0.792649269104,0.571251690388,-0.213022872806],
[0.571251630783,0.213022843003,-0.792649149895],
[0.601500928402,0.707106769085,-0.371748000383],
[0.564254224300,0.646577775478,-0.513375461102],
[0.468429833651,0.757935404778,-0.453990459442],
[0.213022843003,-0.792649149895,0.571251630783],
[0.792649269104,-0.571251690388,0.213022872806],
[0.371748000383,-0.601500928402,0.707106769085],
[0.513375461102,-0.564254224300,0.646577775478],
[0.453990459442,-0.468429833651,0.757935404778],
[0.792649269104,-0.571251690388,-0.213022872806],
[0.213022843003,-0.792649149895,-0.571251630783],
[0.757935404778,-0.453990459442,-0.468429833651],
[0.646577775478,-0.513375461102,-0.564254224300],
[0.707106769085,-0.371748000383,-0.601500928402],
[-0.213022843003,0.792649149895,0.571251630783],
[-0.792649269104,0.571251690388,0.213022872806],
[-0.371748000383,0.601500928402,0.707106769085],
[-0.513375461102,0.564254224300,0.646577775478],
[-0.453990459442,0.468429833651,0.757935404778],
[-0.792649269104,0.571251690388,-0.213022872806],
[-0.213022843003,0.792649149895,-0.571251630783],
[-0.757935404778,0.453990459442,-0.468429833651],
[-0.646577775478,0.513375461102,-0.564254224300],
[-0.707106769085,0.371748000383,-0.601500928402],
[-0.792649269104,-0.571251690388,0.213022872806],
[-0.213022843003,-0.792649149895,0.571251630783],
[-0.757935404778,-0.453990459442,0.468429833651],
[-0.646577775478,-0.513375461102,0.564254224300],
[-0.707106769085,-0.371748000383,0.601500928402],
[-0.213022843003,-0.792649149895,-0.571251630783],
[-0.792649269104,-0.571251690388,-0.213022872806],
[-0.371748000383,-0.601500928402,-0.707106769085],
[-0.513375461102,-0.564254224300,-0.646577775478],
[-0.453990459442,-0.468429833651,-0.757935404778],
[0.375038534403,0.383613735437,0.843911468983],
[0.301258891821,0.264082729816,0.916244208813],
[0.137952238321,0.000000000000,0.990438938141],
[0.220117032528,0.132792472839,0.966392636299],
[0.082242466509,0.133071094751,0.987688302994],
[0.220117032528,-0.132792472839,0.966392636299],
[0.375038534403,-0.383613735437,0.843911468983],
[0.301258891821,-0.264082729816,0.916244208813],
[0.238676920533,-0.386187374592,0.891006469727],
[0.137952238321,0.000000000000,-0.990438938141],
[0.220117032528,0.132792472839,-0.966392636299],
[0.375038534403,0.383613735437,-0.843911468983],
[0.301258891821,0.264082729816,-0.916244208813],
[0.238676920533,0.386187374592,-0.891006469727],
[0.375038534403,-0.383613735437,-0.843911468983],
[0.301258891821,-0.264082729816,-0.916244208813],
[0.220117032528,-0.132792472839,-0.966392636299],
[0.082242466509,-0.133071094751,-0.987688302994],
[0.843911468983,0.375038534403,0.383613735437],
[0.916244208813,0.301258891821,0.264082729816],
[0.990438938141,0.137952238321,0.000000000000],
[0.966392636299,0.220117032528,0.132792472839],
[0.987688302994,0.082242466509,0.133071094751],
[0.966392636299,0.220117032528,-0.132792472839],
[0.843911468983,0.375038534403,-0.383613735437],
[0.916244208813,0.301258891821,-0.264082729816],
[0.891006469727,0.238676920533,-0.386187374592],
[-0.843911468983,-0.375038534403,0.383613735437],
[-0.916244208813,-0.301258891821,0.264082729816],
[-0.990438938141,-0.137952238321,0.000000000000],
[-0.966392636299,-0.220117032528,0.132792472839],
[-0.987688302994,-0.082242466509,0.133071094751],
[-0.966392636299,-0.220117032528,-0.132792472839],
[-0.843911468983,-0.375038534403,-0.383613735437],
[-0.916244208813,-0.301258891821,-0.264082729816],
[-0.891006469727,-0.238676920533,-0.386187374592],
[0.383613735437,0.843911468983,0.375038534403],
[0.264082729816,0.916244208813,0.301258891821],
[0.000000000000,0.990438938141,0.137952238321],
[0.132792472839,0.966392636299,0.220117032528],
[0.133071094751,0.987688302994,0.082242466509],
[-0.132792472839,0.966392636299,0.220117032528],
[-0.383613735437,0.843911468983,0.375038534403],
[-0.264082729816,0.916244208813,0.301258891821],
[-0.386187434196,0.891006588936,0.238676950336],
[0.000000000000,-0.990438938141,0.137952238321],
[0.132792472839,-0.966392636299,0.220117032528],
[0.383613735437,-0.843911468983,0.375038534403],
[0.264082729816,-0.916244208813,0.301258891821],
[0.386187434196,-0.891006588936,0.238676950336],
[-0.383613735437,-0.843911468983,0.375038534403],
[-0.264082729816,-0.916244208813,0.301258891821],
[-0.132792472839,-0.966392636299,0.220117032528],
[-0.133071094751,-0.987688302994,0.082242466509],
[0.237086325884,0.606825172901,0.758652269840],
[0.296004563570,0.702309906483,0.647411882877],
[0.346152991056,0.783451735973,0.516121625900],
[0.468429833651,0.757935404778,0.453990459442],
[0.383613735437,0.843911468983,-0.375038534403],
[0.346152991056,0.783451735973,-0.516121625900],
[0.237086325884,0.606825172901,-0.758652269840],
[0.296004563570,0.702309906483,-0.647411882877],
[0.371748000383,0.601500928402,-0.707106769085],
[0.516121625900,-0.346152991056,0.783451735973],
[0.758652269840,-0.237086325884,0.606825172901],
[0.647411882877,-0.296004563570,0.702309906483],
[0.707106769085,-0.371748000383,0.601500928402],
[0.758652269840,-0.237086325884,-0.606825172901],
[0.647411882877,-0.296004563570,-0.702309906483],
[0.516121625900,-0.346152991056,-0.783451735973],
[0.453990459442,-0.468429833651,-0.757935404778],
[-0.375038534403,0.383613735437,0.843911468983],
[-0.516121625900,0.346152991056,0.783451735973],
[-0.758652269840,0.237086325884,0.606825172901],
[-0.647411882877,0.296004563570,0.702309906483],
[-0.707106769085,0.371748000383,0.601500928402],
[-0.758652269840,0.237086325884,-0.606825172901],
[-0.647411882877,0.296004563570,-0.702309906483],
[-0.375038534403,0.383613735437,-0.843911468983],
[-0.516121625900,0.346152991056,-0.783451735973],
[-0.453990459442,0.468429833651,-0.757935404778],
[-0.758652269840,-0.237086325884,0.606825172901],
[-0.647411882877,-0.296004563570,0.702309906483],
[-0.375038534403,-0.383613735437,0.843911468983],
[-0.516121625900,-0.346152991056,0.783451735973],
[-0.453990459442,-0.468429833651,0.757935404778],
[-0.375038534403,-0.383613735437,-0.843911468983],
[-0.516121625900,-0.346152991056,-0.783451735973],
[-0.758652269840,-0.237086325884,-0.606825172901],
[-0.647411882877,-0.296004563570,-0.702309906483],
[-0.707106769085,-0.371748000383,-0.601500928402],
[0.081141851842,0.620239555836,0.780204355717],
[-0.237086325884,0.606825172901,0.758652269840],
[-0.081141851842,0.620239555836,0.780204355717],
[-0.156434446573,0.519258499146,0.840177834034],
[-0.137952238321,0.000000000000,0.990438938141],
[-0.220117032528,0.132792472839,0.966392636299],
[-0.082242466509,0.133071094751,0.987688302994],
[-0.301258891821,0.264082729816,0.916244208813],
[-0.238676920533,0.386187374592,0.891006469727],
[-0.082323580980,0.399607032537,0.912982463837],
[0.000000000000,0.266404688358,0.963861286640],
[-0.220117032528,-0.132792472839,0.966392636299],
[-0.301258891821,-0.264082729816,0.916244208813],
[-0.238676920533,-0.386187374592,0.891006469727],
[0.237086325884,-0.606825172901,0.758652269840],
[0.081141851842,-0.620239555836,0.780204355717],
[0.156434446573,-0.519258499146,0.840177834034],
[-0.237086325884,-0.606825172901,0.758652269840],
[-0.081141851842,-0.620239555836,0.780204355717],
[-0.156434446573,-0.519258499146,0.840177834034],
[-0.082323580980,-0.399607032537,0.912982463837],
[0.082323580980,-0.399607032537,0.912982463837],
[-0.137952238321,0.000000000000,-0.990438938141],
[-0.220117032528,0.132792472839,-0.966392636299],
[-0.301258891821,0.264082729816,-0.916244208813],
[-0.238676920533,0.386187374592,-0.891006469727],
[0.081141851842,0.620239555836,-0.780204355717],
[0.156434446573,0.519258499146,-0.840177834034],
[-0.237086325884,0.606825172901,-0.758652269840],
[-0.081141851842,0.620239555836,-0.780204355717],
[-0.156434446573,0.519258499146,-0.840177834034],
[-0.082323580980,0.399607032537,-0.912982463837],
[0.082323580980,0.399607032537,-0.912982463837],
[0.237086325884,-0.606825172901,-0.758652269840],
[0.081141851842,-0.620239555836,-0.780204355717],
[-0.237086325884,-0.606825172901,-0.758652269840],
[-0.081141851842,-0.620239555836,-0.780204355717],
[-0.156434446573,-0.519258499146,-0.840177834034],
[-0.220117032528,-0.132792472839,-0.966392636299],
[-0.082242466509,-0.133071094751,-0.987688302994],
[-0.301258891821,-0.264082729816,-0.916244208813],
[-0.238676920533,-0.386187374592,-0.891006469727],
[-0.082323580980,-0.399607032537,-0.912982463837],
[0.000000000000,-0.266404688358,-0.963861286640],
[0.758652269840,0.237086325884,0.606825172901],
[0.780204355717,0.081141851842,0.620239555836],
[0.780204355717,-0.081141851842,0.620239555836],
[0.840177834034,-0.156434446573,0.519258499146],
[0.990438938141,-0.137952238321,0.000000000000],
[0.966392636299,-0.220117032528,0.132792472839],
[0.987688302994,-0.082242466509,0.133071094751],
[0.843911468983,-0.375038534403,0.383613735437],
[0.916244208813,-0.301258891821,0.264082729816],
[0.891006469727,-0.238676920533,0.386187374592],
[0.912982463837,-0.082323580980,0.399607032537],
[0.963861286640,0.000000000000,0.266404688358],
[0.966392636299,-0.220117032528,-0.132792472839],
[0.843911468983,-0.375038534403,-0.383613735437],
[0.916244208813,-0.301258891821,-0.264082729816],
[0.891006469727,-0.238676920533,-0.386187374592],
[0.758652269840,0.237086325884,-0.606825172901],
[0.780204355717,0.081141851842,-0.620239555836],
[0.840177834034,0.156434446573,-0.519258499146],
[0.780204355717,-0.081141851842,-0.620239555836],
[0.840177834034,-0.156434446573,-0.519258499146],
[0.912982463837,-0.082323580980,-0.399607032537],
[0.912982463837,0.082323580980,-0.399607032537],
[-0.780204355717,-0.081141851842,0.620239555836],
[-0.780204355717,0.081141851842,0.620239555836],
[-0.840177834034,0.156434446573,0.519258499146],
[-0.990438938141,0.137952238321,0.000000000000],
[-0.966392636299,0.220117032528,0.132792472839],
[-0.987688302994,0.082242466509,0.133071094751],
[-0.843911468983,0.375038534403,0.383613735437],
[-0.916244208813,0.301258891821,0.264082729816],
[-0.891006469727,0.238676920533,0.386187374592],
[-0.912982463837,0.082323580980,0.399607032537],
[-0.963861286640,0.000000000000,0.266404688358],
[-0.966392636299,0.220117032528,-0.132792472839],
[-0.843911468983,0.375038534403,-0.383613735437],
[-0.916244208813,0.301258891821,-0.264082729816],
[-0.891006469727,0.238676920533,-0.386187374592],
[-0.780204355717,-0.081141851842,-0.620239555836],
[-0.840177834034,-0.156434446573,-0.519258499146],
[-0.780204355717,0.081141851842,-0.620239555836],
[-0.840177834034,0.156434446573,-0.519258499146],
[-0.912982463837,0.082323580980,-0.399607032537],
[-0.912982463837,-0.082323580980,-0.399607032537],
[0.606825172901,0.758652269840,0.237086325884],
[0.620239555836,0.780204355717,0.081141851842],
[0.606825172901,0.758652269840,-0.237086325884],
[0.620239555836,0.780204355717,-0.081141851842],
[0.519258499146,0.840177834034,-0.156434446573],
[0.000000000000,0.990438938141,-0.137952238321],
[0.132792472839,0.966392636299,-0.220117032528],
[0.133071094751,0.987688302994,-0.082242466509],
[0.264082729816,0.916244208813,-0.301258891821],
[0.386187434196,0.891006588936,-0.238676950336],
[0.399607032537,0.912982463837,-0.082323580980],
[0.266404688358,0.963861286640,0.000000000000],
[-0.132792472839,0.966392636299,-0.220117032528],
[-0.383613735437,0.843911468983,-0.375038534403],
[-0.264082729816,0.916244208813,-0.301258891821],
[-0.386187434196,0.891006588936,-0.238676950336],
[-0.606825172901,0.758652269840,0.237086325884],
[-0.620239555836,0.780204355717,0.081141851842],
[-0.519258499146,0.840177834034,0.156434446573],
[-0.606825172901,0.758652269840,-0.237086325884],
[-0.620239555836,0.780204355717,-0.081141851842],
[-0.519258499146,0.840177834034,-0.156434446573],
[-0.399607032537,0.912982463837,-0.082323580980],
[-0.399607032537,0.912982463837,0.082323580980],
[0.000000000000,-0.990438938141,-0.137952238321],
[0.132792472839,-0.966392636299,-0.220117032528],
[0.383613735437,-0.843911468983,-0.375038534403],
[0.264082729816,-0.916244208813,-0.301258891821],
[0.386187434196,-0.891006588936,-0.238676950336],
[0.606825172901,-0.758652269840,0.237086325884],
[0.620239555836,-0.780204355717,0.081141851842],
[0.519258499146,-0.840177834034,0.156434446573],
[0.606825172901,-0.758652269840,-0.237086325884],
[0.620239555836,-0.780204355717,-0.081141851842],
[0.519258499146,-0.840177834034,-0.156434446573],
[0.399607032537,-0.912982463837,-0.082323580980],
[0.399607032537,-0.912982463837,0.082323580980],
[-0.606825172901,-0.758652269840,0.237086325884],
[-0.620239555836,-0.780204355717,0.081141851842],
[-0.606825172901,-0.758652269840,-0.237086325884],
[-0.620239555836,-0.780204355717,-0.081141851842],
[-0.519258499146,-0.840177834034,-0.156434446573],
[-0.132792472839,-0.966392636299,-0.220117032528],
[-0.133071094751,-0.987688302994,-0.082242466509],
[-0.383613735437,-0.843911468983,-0.375038534403],
[-0.264082729816,-0.916244208813,-0.301258891821],
[-0.386187434196,-0.891006588936,-0.238676950336],
[-0.399607032537,-0.912982463837,-0.082323580980],
[-0.266404688358,-0.963861286640,0.000000000000],
[0.516121625900,0.346152991056,0.783451735973],
[0.647411882877,0.296004563570,0.702309906483],
[0.707106769085,0.371748000383,0.601500928402],
[0.702309906483,0.647411882877,0.296004563570],
[0.601500928402,0.707106769085,0.371748000383],
[0.783451735973,0.516121625900,0.346152991056],
[0.757935404778,0.453990459442,0.468429833651],
[0.646577775478,0.513375461102,0.564254224300],
[0.564254224300,0.646577775478,0.513375461102],
[0.702309906483,0.647411882877,-0.296004563570],
[0.783451735973,0.516121625900,-0.346152991056],
[0.757935404778,0.453990459442,-0.468429833651],
[0.516121625900,0.346152991056,-0.783451735973],
[0.453990459442,0.468429833651,-0.757935404778],
[0.647411882877,0.296004563570,-0.702309906483],
[0.707106769085,0.371748000383,-0.601500928402],
[0.646577775478,0.513375461102,-0.564254224300],
[0.513375461102,0.564254224300,-0.646577775478],
[0.296004563570,-0.702309906483,0.647411882877],
[0.346152991056,-0.783451735973,0.516121625900],
[0.468429833651,-0.757935404778,0.453990459442],
[0.783451735973,-0.516121625900,0.346152991056],
[0.757935404778,-0.453990459442,0.468429833651],
[0.702309906483,-0.647411882877,0.296004563570],
[0.601500928402,-0.707106769085,0.371748000383],
[0.564254224300,-0.646577775478,0.513375461102],
[0.646577775478,-0.513375461102,0.564254224300],
[0.783451735973,-0.516121625900,-0.346152991056],
[0.702309906483,-0.647411882877,-0.296004563570],
[0.601500928402,-0.707106769085,-0.371748000383],
[0.296004563570,-0.702309906483,-0.647411882877],
[0.371748000383,-0.601500928402,-0.707106769085],
[0.346152991056,-0.783451735973,-0.516121625900],
[0.468429833651,-0.757935404778,-0.453990459442],
[0.564254224300,-0.646577775478,-0.513375461102],
[0.513375461102,-0.564254224300,-0.646577775478],
[-0.296004563570,0.702309906483,0.647411882877],
[-0.346152991056,0.783451735973,0.516121625900],
[-0.468429833651,0.757935404778,0.453990459442],
[-0.783451735973,0.516121625900,0.346152991056],
[-0.757935404778,0.453990459442,0.468429833651],
[-0.702309906483,0.647411882877,0.296004563570],
[-0.601500928402,0.707106769085,0.371748000383],
[-0.564254224300,0.646577775478,0.513375461102],
[-0.646577775478,0.513375461102,0.564254224300],
[-0.783451735973,0.516121625900,-0.346152991056],
[-0.702309906483,0.647411882877,-0.296004563570],
[-0.601500928402,0.707106769085,-0.371748000383],
[-0.296004563570,0.702309906483,-0.647411882877],
[-0.371748000383,0.601500928402,-0.707106769085],
[-0.346152991056,0.783451735973,-0.516121625900],
[-0.468429833651,0.757935404778,-0.453990459442],
[-0.564254224300,0.646577775478,-0.513375461102],
[-0.513375461102,0.564254224300,-0.646577775478],
[-0.783451735973,-0.516121625900,0.346152991056],
[-0.702309906483,-0.647411882877,0.296004563570],
[-0.601500928402,-0.707106769085,0.371748000383],
[-0.296004563570,-0.702309906483,0.647411882877],
[-0.371748000383,-0.601500928402,0.707106769085],
[-0.346152991056,-0.783451735973,0.516121625900],
[-0.468429833651,-0.757935404778,0.453990459442],
[-0.564254224300,-0.646577775478,0.513375461102],
[-0.513375461102,-0.564254224300,0.646577775478],
[-0.296004563570,-0.702309906483,-0.647411882877],
[-0.346152991056,-0.783451735973,-0.516121625900],
[-0.468429833651,-0.757935404778,-0.453990459442],
[-0.783451735973,-0.516121625900,-0.346152991056],
[-0.757935404778,-0.453990459442,-0.468429833651],
[-0.702309906483,-0.647411882877,-0.296004563570],
[-0.601500928402,-0.707106769085,-0.371748000383],
[-0.564254224300,-0.646577775478,-0.513375461102],
[-0.646577775478,-0.513375461102,-0.564254224300],
[0.506298005581,0.065757550299,0.859847843647],
[0.445365041494,0.065816916525,0.892926692963],
[0.465657591820,0.000000000000,0.884964942932],
[0.445365041494,-0.065816916525,0.892926692963],
[0.506298005581,-0.065757550299,0.859847843647],
[0.465657591820,0.000000000000,-0.884964942932],
[0.445365041494,0.065816916525,-0.892926692963],
[0.506298005581,0.065757550299,-0.859847843647],
[0.506298005581,-0.065757550299,-0.859847843647],
[0.445365041494,-0.065816916525,-0.892926692963],
[0.859847843647,0.506298005581,0.065757550299],
[0.892926692963,0.445365041494,0.065816916525],
[0.884964942932,0.465657591820,0.000000000000],
[0.892926692963,0.445365041494,-0.065816916525],
[0.859847843647,0.506298005581,-0.065757550299],
[-0.859847843647,-0.506298005581,0.065757550299],
[-0.892926692963,-0.445365041494,0.065816916525],
[-0.884964942932,-0.465657591820,0.000000000000],
[-0.892926692963,-0.445365041494,-0.065816916525],
[-0.859847843647,-0.506298005581,-0.065757550299],
[0.065757550299,0.859847843647,0.506298005581],
[0.065816916525,0.892926692963,0.445365041494],
[0.000000000000,0.884964942932,0.465657591820],
[-0.065816916525,0.892926692963,0.445365041494],
[-0.065757550299,0.859847843647,0.506298005581],
[0.000000000000,-0.884964942932,0.465657591820],
[0.065816916525,-0.892926692963,0.445365041494],
[0.065757550299,-0.859847843647,0.506298005581],
[-0.065757550299,-0.859847843647,0.506298005581],
[-0.065816916525,-0.892926692963,0.445365041494],
[0.040640402585,0.819207370281,0.572055578232],
[0.106494009495,0.827109813690,0.551859021187],
[0.065757550299,0.859847843647,-0.506298005581],
[0.106494009495,0.827109813690,-0.551859021187],
[0.040640402585,0.819207370281,-0.572055578232],
[0.551859021187,-0.106494009495,0.827109813690],
[0.572055578232,-0.040640402585,0.819207370281],
[0.572055578232,-0.040640402585,-0.819207370281],
[0.551859021187,-0.106494009495,-0.827109813690],
[-0.506298005581,0.065757550299,0.859847843647],
[-0.551859021187,0.106494009495,0.827109813690],
[-0.572055578232,0.040640402585,0.819207370281],
[-0.572055578232,0.040640402585,-0.819207370281],
[-0.551859021187,0.106494009495,-0.827109813690],
[-0.506298005581,0.065757550299,-0.859847843647],
[-0.572055578232,-0.040640402585,0.819207370281],
[-0.551859021187,-0.106494009495,0.827109813690],
[-0.506298005581,-0.065757550299,0.859847843647],
[-0.506298005581,-0.065757550299,-0.859847843647],
[-0.551859021187,-0.106494009495,-0.827109813690],
[-0.572055578232,-0.040640402585,-0.819207370281],
[0.000000000000,0.786432683468,0.617675960064],
[-0.040640402585,0.819207370281,0.572055578232],
[-0.465657591820,0.000000000000,0.884964942932],
[-0.445365041494,0.065816916525,0.892926692963],
[0.233445361257,0.511205196381,0.827147245407],
[0.198227226734,0.454261869192,0.868534505367],
[0.274693757296,0.444463819265,0.852640211582],
[-0.445365041494,-0.065816916525,0.892926692963],
[0.040640402585,-0.819207370281,0.572055578232],
[0.000000000000,-0.786432683468,0.617675960064],
[-0.040640402585,-0.819207370281,0.572055578232],
[-0.041248388588,-0.066741287708,0.996917307377],
[0.000000000000,-0.133523419499,0.991045594215],
[0.041248388588,-0.066741287708,0.996917307377],
[-0.465657591820,0.000000000000,-0.884964942932],
[-0.445365041494,0.065816916525,-0.892926692963],
[0.000000000000,0.786432683468,-0.617675960064],
[-0.040640402585,0.819207370281,-0.572055578232],
[-0.041248388588,0.066741287708,-0.996917307377],
[0.000000000000,0.133523419499,-0.991045594215],
[0.041248388588,0.066741287708,-0.996917307377],
[0.040640402585,-0.819207370281,-0.572055578232],
[0.000000000000,-0.786432683468,-0.617675960064],
[-0.040640402585,-0.819207370281,-0.572055578232],
[-0.445365041494,-0.065816916525,-0.892926692963],
[0.233445361257,-0.511205196381,-0.827147245407],
[0.198227226734,-0.454261869192,-0.868534505367],
[0.274693757296,-0.444463819265,-0.852640211582],
[0.572055578232,0.040640402585,0.819207370281],
[0.617675960064,0.000000000000,0.786432683468],
[0.884964942932,-0.465657591820,0.000000000000],
[0.892926692963,-0.445365041494,0.065816916525],
[0.859847843647,-0.506298005581,0.065757550299],
[0.827147245407,0.233445361257,0.511205196381],
[0.868534505367,0.198227226734,0.454261869192],
[0.852640211582,0.274693757296,0.444463819265],
[0.892926692963,-0.445365041494,-0.065816916525],
[0.859847843647,-0.506298005581,-0.065757550299],
[0.572055578232,0.040640402585,-0.819207370281],
[0.617675960064,0.000000000000,-0.786432683468],
[0.996917307377,-0.041248388588,-0.066741287708],
[0.991045594215,0.000000000000,-0.133523419499],
[0.996917307377,0.041248388588,-0.066741287708],
[-0.617675960064,0.000000000000,0.786432683468],
[-0.884964942932,0.465657591820,0.000000000000],
[-0.892926692963,0.445365041494,0.065816916525],
[-0.859847843647,0.506298005581,0.065757550299],
[-0.827147245407,-0.233445361257,0.511205196381],
[-0.868534505367,-0.198227226734,0.454261869192],
[-0.852640211582,-0.274693757296,0.444463819265],
[-0.892926692963,0.445365041494,-0.065816916525],
[-0.859847843647,0.506298005581,-0.065757550299],
[-0.617675960064,0.000000000000,-0.786432683468],
[-0.996917307377,0.041248388588,-0.066741287708],
[-0.991045594215,0.000000000000,-0.133523419499],
[-0.996917307377,-0.041248388588,-0.066741287708],
[0.819207370281,0.572055578232,0.040640402585],
[0.786432683468,0.617675960064,0.000000000000],
[0.819207370281,0.572055578232,-0.040640402585],
[0.000000000000,0.884964942932,-0.465657591820],
[0.065816916525,0.892926692963,-0.445365041494],
[0.511205196381,0.827147245407,0.233445361257],
[0.454261839390,0.868534505367,0.198227211833],
[0.444463849068,0.852640151978,0.274693727493],
[-0.065816916525,0.892926692963,-0.445365041494],
[-0.065757550299,0.859847843647,-0.506298005581],
[-0.819207370281,0.572055578232,0.040640402585],
[-0.786432683468,0.617675960064,0.000000000000],
[-0.819207370281,0.572055578232,-0.040640402585],
[-0.066741287708,0.996917307377,-0.041248388588],
[-0.133523419499,0.991045594215,0.000000000000],
[-0.066741287708,0.996917307377,0.041248388588],
[0.000000000000,-0.884964942932,-0.465657591820],
[0.065816916525,-0.892926692963,-0.445365041494],
[0.065757550299,-0.859847843647,-0.506298005581],
[0.819207370281,-0.572055578232,0.040640402585],
[0.786432683468,-0.617675960064,0.000000000000],
[0.819207370281,-0.572055578232,-0.040640402585],
[0.066741287708,-0.996917307377,-0.041248388588],
[0.133523419499,-0.991045594215,0.000000000000],
[0.066741287708,-0.996917307377,0.041248388588],
[-0.819207370281,-0.572055578232,0.040640402585],
[-0.786432683468,-0.617675960064,0.000000000000],
[-0.819207370281,-0.572055578232,-0.040640402585],
[-0.065816916525,-0.892926692963,-0.445365041494],
[-0.065757550299,-0.859847843647,-0.506298005581],
[-0.511205196381,-0.827147245407,0.233445361257],
[-0.454261839390,-0.868534505367,0.198227211833],
[-0.444463849068,-0.852640151978,0.274693727493],
[0.551859021187,0.106494009495,0.827109813690],
[0.827109813690,0.551859021187,0.106494009495],
[0.382683426142,0.485712230206,0.785898923874],
[0.414272665977,0.536783874035,0.735011100769],
[0.341435045004,0.552453517914,0.760406017303],
[0.827109813690,0.551859021187,-0.106494009495],
[0.551859021187,0.106494009495,-0.827109813690],
[0.552453517914,0.760406017303,-0.341435045004],
[0.536783814430,0.735010981560,-0.414272606373],
[0.485712230206,0.785898923874,-0.382683426142],
[0.106494009495,-0.827109813690,0.551859021187],
[0.827109813690,-0.551859021187,0.106494009495],
[0.341435045004,-0.552453517914,0.760406017303],
[0.414272665977,-0.536783874035,0.735011100769],
[0.382683426142,-0.485712230206,0.785898923874],
[0.827109813690,-0.551859021187,-0.106494009495],
[0.106494009495,-0.827109813690,-0.551859021187],
[0.785898923874,-0.382683426142,-0.485712230206],
[0.735011100769,-0.414272665977,-0.536783874035],
[0.760406017303,-0.341435045004,-0.552453517914],
[-0.106494009495,0.827109813690,0.551859021187],
[-0.827109813690,0.551859021187,0.106494009495],
[-0.341435045004,0.552453517914,0.760406017303],
[-0.414272665977,0.536783874035,0.735011100769],
[-0.382683426142,0.485712230206,0.785898923874],
[-0.827109813690,0.551859021187,-0.106494009495],
[-0.106494009495,0.827109813690,-0.551859021187],
[-0.785898923874,0.382683426142,-0.485712230206],
[-0.735011100769,0.414272665977,-0.536783874035],
[-0.760406017303,0.341435045004,-0.552453517914],
[-0.827109813690,-0.551859021187,0.106494009495],
[-0.106494009495,-0.827109813690,0.551859021187],
[-0.785898923874,-0.382683426142,0.485712230206],
[-0.735011100769,-0.414272665977,0.536783874035],
[-0.760406017303,-0.341435045004,0.552453517914],
[-0.106494009495,-0.827109813690,-0.551859021187],
[-0.827109813690,-0.551859021187,-0.106494009495],
[-0.341435045004,-0.552453517914,-0.760406017303],
[-0.414272665977,-0.536783874035,-0.735011100769],
[-0.382683426142,-0.485712230206,-0.785898923874],
[0.342848271132,0.442866742611,0.828446865082],
[0.307659417391,0.385906159878,0.869725227356],
[0.069141581655,0.000000000000,0.997606873512],
[0.110384985805,0.066709376872,0.991647660732],
[0.041248388588,0.066741287708,0.996917307377],
[0.368518292904,0.262660562992,0.891741991043],
[0.330606490374,0.198386684060,0.922681987286],
[0.397350579500,0.196412235498,0.896400988102],
[0.110384985805,-0.066709376872,0.991647660732],
[0.342848271132,-0.442866742611,0.828446865082],
[0.307659417391,-0.385906159878,0.869725227356],
[0.274693757296,-0.444463819265,0.852640211582],
[0.247325703502,-0.066566854715,0.966643095016],
[0.289929419756,-0.132569819689,0.947821795940],
[0.316777586937,-0.066042400897,0.946197807789],
[0.069141581655,0.000000000000,-0.997606873512],
[0.110384985805,0.066709376872,-0.991647660732],
[0.342848271132,0.442866742611,-0.828446865082],
[0.307659417391,0.385906159878,-0.869725227356],
[0.274693757296,0.444463819265,-0.852640211582],
[0.247325703502,0.066566854715,-0.966643095016],
[0.289929419756,0.132569819689,-0.947821795940],
[0.316777586937,0.066042400897,-0.946197807789],
[0.342848271132,-0.442866742611,-0.828446865082],
[0.307659417391,-0.385906159878,-0.869725227356],
[0.110384985805,-0.066709376872,-0.991647660732],
[0.041248388588,-0.066741287708,-0.996917307377],
[0.368518292904,-0.262660562992,-0.891741991043],
[0.330606490374,-0.198386684060,-0.922681987286],
[0.397350579500,-0.196412235498,-0.896400988102],
[0.828446865082,0.342848271132,0.442866742611],
[0.869725227356,0.307659417391,0.385906159878],
[0.997606873512,0.069141581655,0.000000000000],
[0.991647660732,0.110384985805,0.066709376872],
[0.996917307377,0.041248388588,0.066741287708],
[0.891741991043,0.368518292904,0.262660562992],
[0.922681987286,0.330606490374,0.198386684060],
[0.896400988102,0.397350579500,0.196412235498],
[0.991647660732,0.110384985805,-0.066709376872],
[0.828446865082,0.342848271132,-0.442866742611],
[0.869725227356,0.307659417391,-0.385906159878],
[0.852640211582,0.274693757296,-0.444463819265],
[0.966643095016,0.247325703502,-0.066566854715],
[0.947821795940,0.289929419756,-0.132569819689],
[0.946197807789,0.316777586937,-0.066042400897],
[-0.828446865082,-0.342848271132,0.442866742611],
[-0.869725227356,-0.307659417391,0.385906159878],
[-0.997606873512,-0.069141581655,0.000000000000],
[-0.991647660732,-0.110384985805,0.066709376872],
[-0.996917307377,-0.041248388588,0.066741287708],
[-0.891741991043,-0.368518292904,0.262660562992],
[-0.922681987286,-0.330606490374,0.198386684060],
[-0.896400988102,-0.397350579500,0.196412235498],
[-0.991647660732,-0.110384985805,-0.066709376872],
[-0.828446865082,-0.342848271132,-0.442866742611],
[-0.869725227356,-0.307659417391,-0.385906159878],
[-0.852640211582,-0.274693757296,-0.444463819265],
[-0.966643095016,-0.247325703502,-0.066566854715],
[-0.947821795940,-0.289929419756,-0.132569819689],
[-0.946197807789,-0.316777586937,-0.066042400897],
[0.442866742611,0.828446865082,0.342848271132],
[0.385906100273,0.869725286961,0.307659387589],
[0.000000000000,0.997606873512,0.069141581655],
[0.066709376872,0.991647660732,0.110384985805],
[0.066741287708,0.996917307377,0.041248388588],
[0.262660562992,0.891741991043,0.368518292904],
[0.198386684060,0.922681987286,0.330606490374],
[0.196412235498,0.896400988102,0.397350579500],
[-0.066709376872,0.991647660732,0.110384985805],
[-0.442866742611,0.828446865082,0.342848271132],
[-0.385906100273,0.869725286961,0.307659387589],
[-0.444463849068,0.852640151978,0.274693727493],
[-0.066566854715,0.966643095016,0.247325703502],
[-0.132569819689,0.947821795940,0.289929419756],
[-0.066042400897,0.946197807789,0.316777586937],
[0.000000000000,-0.997606873512,0.069141581655],
[0.066709376872,-0.991647660732,0.110384985805],
[0.442866742611,-0.828446865082,0.342848271132],
[0.385906100273,-0.869725286961,0.307659387589],
[0.444463849068,-0.852640151978,0.274693727493],
[0.066566854715,-0.966643095016,0.247325703502],
[0.132569819689,-0.947821795940,0.289929419756],
[0.066042400897,-0.946197807789,0.316777586937],
[-0.442866742611,-0.828446865082,0.342848271132],
[-0.385906100273,-0.869725286961,0.307659387589],
[-0.066709376872,-0.991647660732,0.110384985805],
[-0.066741287708,-0.996917307377,0.041248388588],
[-0.262660562992,-0.891741991043,0.368518292904],
[-0.198386684060,-0.922681987286,0.330606490374],
[-0.196412235498,-0.896400988102,0.397350579500],
[0.273706704378,0.554740190506,0.785714983940],
[0.305212467909,0.605741500854,0.734794259071],
[0.427134811878,0.803015947342,0.415597438812],
[0.485712230206,0.785898923874,0.382683426142],
[0.228899985552,0.703982532024,0.672319412231],
[0.255179554224,0.749435067177,0.610925853252],
[0.187431842089,0.749785602093,0.634579241276],
[0.442866742611,0.828446865082,-0.342848271132],
[0.427134811878,0.803015947342,-0.415597438812],
[0.273706704378,0.554740190506,-0.785714983940],
[0.305212467909,0.605741500854,-0.734794259071],
[0.341435045004,0.552453517914,-0.760406017303],
[0.303801119328,0.825175166130,-0.476225703955],
[0.280319362879,0.790112078190,-0.545108973980],
[0.237228676677,0.830358564854,-0.504209458828],
[0.415597438812,-0.427134811878,0.803015947342],
[0.785714983940,-0.273706704378,0.554740190506],
[0.734794259071,-0.305212467909,0.605741500854],
[0.760406017303,-0.341435045004,0.552453517914],
[0.476225703955,-0.303801119328,0.825175166130],
[0.545108973980,-0.280319362879,0.790112078190],
[0.504209458828,-0.237228676677,0.830358564854],
[0.785714983940,-0.273706704378,-0.554740190506],
[0.734794259071,-0.305212467909,-0.605741500854],
[0.415597438812,-0.427134811878,-0.803015947342],
[0.382683426142,-0.485712230206,-0.785898923874],
[0.672319412231,-0.228899985552,-0.703982532024],
[0.610925853252,-0.255179554224,-0.749435067177],
[0.634579241276,-0.187431842089,-0.749785602093],
[-0.342848271132,0.442866742611,0.828446865082],
[-0.415597438812,0.427134811878,0.803015947342],
[-0.785714983940,0.273706704378,0.554740190506],
[-0.734794259071,0.305212467909,0.605741500854],
[-0.760406017303,0.341435045004,0.552453517914],
[-0.476225703955,0.303801119328,0.825175166130],
[-0.545108973980,0.280319362879,0.790112078190],
[-0.504209458828,0.237228676677,0.830358564854],
[-0.785714983940,0.273706704378,-0.554740190506],
[-0.734794259071,0.305212467909,-0.605741500854],
[-0.342848271132,0.442866742611,-0.828446865082],
[-0.415597438812,0.427134811878,-0.803015947342],
[-0.382683426142,0.485712230206,-0.785898923874],
[-0.672319412231,0.228899985552,-0.703982532024],
[-0.610925853252,0.255179554224,-0.749435067177],
[-0.634579241276,0.187431842089,-0.749785602093],
[-0.785714983940,-0.273706704378,0.554740190506],
[-0.734794259071,-0.305212467909,0.605741500854],
[-0.342848271132,-0.442866742611,0.828446865082],
[-0.415597438812,-0.427134811878,0.803015947342],
[-0.382683426142,-0.485712230206,0.785898923874],
[-0.672319412231,-0.228899985552,0.703982532024],
[-0.610925853252,-0.255179554224,0.749435067177],
[-0.634579241276,-0.187431842089,0.749785602093],
[-0.342848271132,-0.442866742611,-0.828446865082],
[-0.415597438812,-0.427134811878,-0.803015947342],
[-0.785714983940,-0.273706704378,-0.554740190506],
[-0.734794259071,-0.305212467909,-0.605741500854],
[-0.760406017303,-0.341435045004,-0.552453517914],
[-0.476225703955,-0.303801119328,-0.825175166130],
[-0.545108973980,-0.280319362879,-0.790112078190],
[-0.504209458828,-0.237228676677,-0.830358564854],
[0.197274446487,0.564512789249,0.801503598690],
[-0.273706704378,0.554740190506,0.785714983940],
[-0.197274446487,0.564512789249,0.801503598690],
[-0.233445361257,0.511205196381,0.827147245407],
[0.121192574501,0.662841916084,0.738886237144],
[0.040677066892,0.667502403259,0.743495702744],
[0.080572985113,0.708969175816,0.700621724129],
[-0.069141581655,0.000000000000,0.997606873512],
[-0.110384985805,0.066709376872,0.991647660732],
[-0.041248388588,0.066741287708,0.996917307377],
[-0.307659417391,0.385906159878,0.869725227356],
[-0.274693757296,0.444463819265,0.852640211582],
[-0.247325703502,0.066566854715,0.966643095016],
[-0.289929419756,0.132569819689,0.947821795940],
[-0.316777586937,0.066042400897,0.946197807789],
[-0.198227226734,0.454261869192,0.868534505367],
[0.000000000000,0.133523419499,0.991045594215],
[-0.041299182922,0.464213401079,0.884760022163],
[0.000000000000,0.400968074799,0.916092038155],
[0.041299182922,0.464213401079,0.884760022163],
[-0.110384985805,-0.066709376872,0.991647660732],
[-0.307659417391,-0.385906159878,0.869725227356],
[-0.274693757296,-0.444463819265,0.852640211582],
[-0.247325703502,-0.066566854715,0.966643095016],
[-0.289929419756,-0.132569819689,0.947821795940],
[-0.316777586937,-0.066042400897,0.946197807789],
[0.273706704378,-0.554740190506,0.785714983940],
[0.197274446487,-0.564512789249,0.801503598690],
[0.233445361257,-0.511205196381,0.827147245407],
[-0.273706704378,-0.554740190506,0.785714983940],
[-0.197274446487,-0.564512789249,0.801503598690],
[-0.233445361257,-0.511205196381,0.827147245407],
[0.121192574501,-0.662841916084,0.738886237144],
[0.040677066892,-0.667502403259,0.743495702744],
[0.080572985113,-0.708969175816,0.700621724129],
[-0.198227226734,-0.454261869192,0.868534505367],
[0.198227226734,-0.454261869192,0.868534505367],
[-0.122800238431,-0.332341909409,0.935130417347],
[-0.041301984340,-0.334140032530,0.941618025303],
[-0.081501059234,-0.265518426895,0.960654795170],
[-0.069141581655,0.000000000000,-0.997606873512],
[-0.110384985805,0.066709376872,-0.991647660732],
[-0.307659417391,0.385906159878,-0.869725227356],
[-0.274693757296,0.444463819265,-0.852640211582],
[-0.247325703502,0.066566854715,-0.966643095016],
[-0.289929419756,0.132569819689,-0.947821795940],
[-0.316777586937,0.066042400897,-0.946197807789],
[0.197274446487,0.564512789249,-0.801503598690],
[0.233445361257,0.511205196381,-0.827147245407],
[-0.273706704378,0.554740190506,-0.785714983940],
[-0.197274446487,0.564512789249,-0.801503598690],
[-0.233445361257,0.511205196381,-0.827147245407],
[0.121192574501,0.662841916084,-0.738886237144],
[0.040677066892,0.667502403259,-0.743495702744],
[0.080572985113,0.708969175816,-0.700621724129],
[-0.198227226734,0.454261869192,-0.868534505367],
[0.198227226734,0.454261869192,-0.868534505367],
[-0.122800238431,0.332341909409,-0.935130417347],
[-0.041301984340,0.334140032530,-0.941618025303],
[-0.081501059234,0.265518426895,-0.960654795170],
[0.273706704378,-0.554740190506,-0.785714983940],
[0.197274446487,-0.564512789249,-0.801503598690],
[-0.273706704378,-0.554740190506,-0.785714983940],
[-0.197274446487,-0.564512789249,-0.801503598690],
[-0.233445361257,-0.511205196381,-0.827147245407],
[0.121192574501,-0.662841916084,-0.738886237144],
[0.040677066892,-0.667502403259,-0.743495702744],
[0.080572985113,-0.708969175816,-0.700621724129],
[-0.110384985805,-0.066709376872,-0.991647660732],
[-0.041248388588,-0.066741287708,-0.996917307377],
[-0.307659417391,-0.385906159878,-0.869725227356],
[-0.274693757296,-0.444463819265,-0.852640211582],
[-0.247325703502,-0.066566854715,-0.966643095016],
[-0.289929419756,-0.132569819689,-0.947821795940],
[-0.316777586937,-0.066042400897,-0.946197807789],
[-0.198227226734,-0.454261869192,-0.868534505367],
[0.000000000000,-0.133523419499,-0.991045594215],
[-0.041299182922,-0.464213401079,-0.884760022163],
[0.000000000000,-0.400968074799,-0.916092038155],
[0.041299182922,-0.464213401079,-0.884760022163],
[0.785714983940,0.273706704378,0.554740190506],
[0.801503598690,0.197274446487,0.564512789249],
[0.801503598690,-0.197274446487,0.564512789249],
[0.827147245407,-0.233445361257,0.511205196381],
[0.738886237144,0.121192574501,0.662841916084],
[0.743495702744,0.040677066892,0.667502403259],
[0.700621724129,0.080572985113,0.708969175816],
[0.997606873512,-0.069141581655,0.000000000000],
[0.991647660732,-0.110384985805,0.066709376872],
[0.996917307377,-0.041248388588,0.066741287708],
[0.828446865082,-0.342848271132,0.442866742611],
[0.869725227356,-0.307659417391,0.385906159878],
[0.852640211582,-0.274693757296,0.444463819265],
[0.966643095016,-0.247325703502,0.066566854715],
[0.947821795940,-0.289929419756,0.132569819689],
[0.946197807789,-0.316777586937,0.066042400897],
[0.868534505367,-0.198227226734,0.454261869192],
[0.991045594215,0.000000000000,0.133523419499],
[0.884760022163,-0.041299182922,0.464213401079],
[0.916092038155,0.000000000000,0.400968074799],
[0.884760022163,0.041299182922,0.464213401079],
[0.991647660732,-0.110384985805,-0.066709376872],
[0.828446865082,-0.342848271132,-0.442866742611],
[0.869725227356,-0.307659417391,-0.385906159878],
[0.852640211582,-0.274693757296,-0.444463819265],
[0.966643095016,-0.247325703502,-0.066566854715],
[0.947821795940,-0.289929419756,-0.132569819689],
[0.946197807789,-0.316777586937,-0.066042400897],
[0.785714983940,0.273706704378,-0.554740190506],
[0.801503598690,0.197274446487,-0.564512789249],
[0.827147245407,0.233445361257,-0.511205196381],
[0.801503598690,-0.197274446487,-0.564512789249],
[0.827147245407,-0.233445361257,-0.511205196381],
[0.738886237144,0.121192574501,-0.662841916084],
[0.743495702744,0.040677066892,-0.667502403259],
[0.700621724129,0.080572985113,-0.708969175816],
[0.868534505367,-0.198227226734,-0.454261869192],
[0.868534505367,0.198227226734,-0.454261869192],
[0.935130417347,-0.122800238431,-0.332341909409],
[0.941618025303,-0.041301984340,-0.334140032530],
[0.960654795170,-0.081501059234,-0.265518426895],
[-0.801503598690,-0.197274446487,0.564512789249],
[-0.801503598690,0.197274446487,0.564512789249],
[-0.827147245407,0.233445361257,0.511205196381],
[-0.738886237144,-0.121192574501,0.662841916084],
[-0.743495702744,-0.040677066892,0.667502403259],
[-0.700621724129,-0.080572985113,0.708969175816],
[-0.997606873512,0.069141581655,0.000000000000],
[-0.991647660732,0.110384985805,0.066709376872],
[-0.996917307377,0.041248388588,0.066741287708],
[-0.828446865082,0.342848271132,0.442866742611],
[-0.869725227356,0.307659417391,0.385906159878],
[-0.852640211582,0.274693757296,0.444463819265],
[-0.966643095016,0.247325703502,0.066566854715],
[-0.947821795940,0.289929419756,0.132569819689],
[-0.946197807789,0.316777586937,0.066042400897],
[-0.868534505367,0.198227226734,0.454261869192],
[-0.991045594215,0.000000000000,0.133523419499],
[-0.884760022163,0.041299182922,0.464213401079],
[-0.916092038155,0.000000000000,0.400968074799],
[-0.884760022163,-0.041299182922,0.464213401079],
[-0.991647660732,0.110384985805,-0.066709376872],
[-0.828446865082,0.342848271132,-0.442866742611],
[-0.869725227356,0.307659417391,-0.385906159878],
[-0.852640211582,0.274693757296,-0.444463819265],
[-0.966643095016,0.247325703502,-0.066566854715],
[-0.947821795940,0.289929419756,-0.132569819689],
[-0.946197807789,0.316777586937,-0.066042400897],
[-0.801503598690,-0.197274446487,-0.564512789249],
[-0.827147245407,-0.233445361257,-0.511205196381],
[-0.801503598690,0.197274446487,-0.564512789249],
[-0.827147245407,0.233445361257,-0.511205196381],
[-0.738886237144,-0.121192574501,-0.662841916084],
[-0.743495702744,-0.040677066892,-0.667502403259],
[-0.700621724129,-0.080572985113,-0.708969175816],
[-0.868534505367,0.198227226734,-0.454261869192],
[-0.868534505367,-0.198227226734,-0.454261869192],
[-0.935130417347,0.122800238431,-0.332341909409],
[-0.941618025303,0.041301984340,-0.334140032530],
[-0.960654795170,0.081501059234,-0.265518426895],
[0.554740190506,0.785714983940,0.273706704378],
[0.564512789249,0.801503598690,0.197274446487],
[0.554740190506,0.785714983940,-0.273706704378],
[0.564512789249,0.801503598690,-0.197274446487],
[0.511205196381,0.827147245407,-0.233445361257],
[0.662841916084,0.738886237144,0.121192574501],
[0.667502462864,0.743495821953,0.040677070618],
[0.708969175816,0.700621724129,0.080572985113],
[0.000000000000,0.997606873512,-0.069141581655],
[0.066709376872,0.991647660732,-0.110384985805],
[0.066741287708,0.996917307377,-0.041248388588],
[0.385906100273,0.869725286961,-0.307659387589],
[0.444463849068,0.852640151978,-0.274693727493],
[0.066566854715,0.966643095016,-0.247325703502],
[0.132569819689,0.947821795940,-0.289929419756],
[0.066042400897,0.946197807789,-0.316777586937],
[0.454261839390,0.868534505367,-0.198227211833],
[0.133523419499,0.991045594215,0.000000000000],
[0.464213401079,0.884760022163,-0.041299182922],
[0.400968074799,0.916092038155,0.000000000000],
[0.464213401079,0.884760022163,0.041299182922],
[-0.066709376872,0.991647660732,-0.110384985805],
[-0.442866742611,0.828446865082,-0.342848271132],
[-0.385906100273,0.869725286961,-0.307659387589],
[-0.444463849068,0.852640151978,-0.274693727493],
[-0.066566854715,0.966643095016,-0.247325703502],
[-0.132569819689,0.947821795940,-0.289929419756],
[-0.066042400897,0.946197807789,-0.316777586937],
[-0.554740190506,0.785714983940,0.273706704378],
[-0.564512789249,0.801503598690,0.197274446487],
[-0.511205196381,0.827147245407,0.233445361257],
[-0.554740190506,0.785714983940,-0.273706704378],
[-0.564512789249,0.801503598690,-0.197274446487],
[-0.511205196381,0.827147245407,-0.233445361257],
[-0.662841916084,0.738886237144,0.121192574501],
[-0.667502462864,0.743495821953,0.040677070618],
[-0.708969175816,0.700621724129,0.080572985113],
[-0.454261839390,0.868534505367,-0.198227211833],
[-0.454261839390,0.868534505367,0.198227211833],
[-0.332341909409,0.935130417347,-0.122800238431],
[-0.334140032530,0.941618025303,-0.041301984340],
[-0.265518426895,0.960654795170,-0.081501059234],
[0.000000000000,-0.997606873512,-0.069141581655],
[0.066709376872,-0.991647660732,-0.110384985805],
[0.442866742611,-0.828446865082,-0.342848271132],
[0.385906100273,-0.869725286961,-0.307659387589],
[0.444463849068,-0.852640151978,-0.274693727493],
[0.066566854715,-0.966643095016,-0.247325703502],
[0.132569819689,-0.947821795940,-0.289929419756],
[0.066042400897,-0.946197807789,-0.316777586937],
[0.554740190506,-0.785714983940,0.273706704378],
[0.564512789249,-0.801503598690,0.197274446487],
[0.511205196381,-0.827147245407,0.233445361257],
[0.554740190506,-0.785714983940,-0.273706704378],
[0.564512789249,-0.801503598690,-0.197274446487],
[0.511205196381,-0.827147245407,-0.233445361257],
[0.662841916084,-0.738886237144,0.121192574501],
[0.667502462864,-0.743495821953,0.040677070618],
[0.708969175816,-0.700621724129,0.080572985113],
[0.454261839390,-0.868534505367,-0.198227211833],
[0.454261839390,-0.868534505367,0.198227211833],
[0.332341909409,-0.935130417347,-0.122800238431],
[0.334140032530,-0.941618025303,-0.041301984340],
[0.265518426895,-0.960654795170,-0.081501059234],
[-0.554740190506,-0.785714983940,0.273706704378],
[-0.564512789249,-0.801503598690,0.197274446487],
[-0.554740190506,-0.785714983940,-0.273706704378],
[-0.564512789249,-0.801503598690,-0.197274446487],
[-0.511205196381,-0.827147245407,-0.233445361257],
[-0.662841916084,-0.738886237144,0.121192574501],
[-0.667502462864,-0.743495821953,0.040677070618],
[-0.708969175816,-0.700621724129,0.080572985113],
[-0.066709376872,-0.991647660732,-0.110384985805],
[-0.066741287708,-0.996917307377,-0.041248388588],
[-0.442866742611,-0.828446865082,-0.342848271132],
[-0.385906100273,-0.869725286961,-0.307659387589],
[-0.444463849068,-0.852640151978,-0.274693727493],
[-0.066566854715,-0.966643095016,-0.247325703502],
[-0.132569819689,-0.947821795940,-0.289929419756],
[-0.066042400897,-0.946197807789,-0.316777586937],
[-0.454261839390,-0.868534505367,-0.198227211833],
[-0.133523419499,-0.991045594215,0.000000000000],
[-0.464213401079,-0.884760022163,-0.041299182922],
[-0.400968074799,-0.916092038155,0.000000000000],
[-0.464213401079,-0.884760022163,0.041299182922],
[0.415597438812,0.427134811878,0.803015947342],
[0.734794259071,0.305212467909,0.605741500854],
[0.760406017303,0.341435045004,0.552453517914],
[0.476225703955,0.303801119328,0.825175166130],
[0.545108973980,0.280319362879,0.790112078190],
[0.504209458828,0.237228676677,0.830358564854],
[0.605741500854,0.734794259071,0.305212467909],
[0.552453517914,0.760406017303,0.341435045004],
[0.803015947342,0.415597438812,0.427134811878],
[0.785898923874,0.382683426142,0.485712230206],
[0.703982532024,0.672319412231,0.228899985552],
[0.749435067177,0.610925912857,0.255179554224],
[0.749785602093,0.634579300880,0.187431842089],
[0.735011100769,0.414272665977,0.536783874035],
[0.536783814430,0.735010981560,0.414272606373],
[0.619241595268,0.470917046070,0.628312826157],
[0.581951975822,0.540650010109,0.607478022575],
[0.552418172359,0.496441334486,0.669612050056],
[0.605741500854,0.734794259071,-0.305212467909],
[0.803015947342,0.415597438812,-0.427134811878],
[0.785898923874,0.382683426142,-0.485712230206],
[0.703982532024,0.672319412231,-0.228899985552],
[0.749435067177,0.610925912857,-0.255179554224],
[0.749785602093,0.634579300880,-0.187431842089],
[0.415597438812,0.427134811878,-0.803015947342],
[0.382683426142,0.485712230206,-0.785898923874],
[0.734794259071,0.305212467909,-0.605741500854],
[0.760406017303,0.341435045004,-0.552453517914],
[0.476225703955,0.303801119328,-0.825175166130],
[0.545108973980,0.280319362879,-0.790112078190],
[0.504209458828,0.237228676677,-0.830358564854],
[0.735011100769,0.414272665977,-0.536783874035],
[0.414272665977,0.536783874035,-0.735011100769],
[0.669612050056,0.552418172359,-0.496441334486],
[0.607478022575,0.581951975822,-0.540650010109],
[0.628312826157,0.619241595268,-0.470917046070],
[0.305212467909,-0.605741500854,0.734794259071],
[0.427134811878,-0.803015947342,0.415597438812],
[0.485712230206,-0.785898923874,0.382683426142],
[0.228899985552,-0.703982532024,0.672319412231],
[0.255179554224,-0.749435067177,0.610925853252],
[0.187431842089,-0.749785602093,0.634579241276],
[0.803015947342,-0.415597438812,0.427134811878],
[0.785898923874,-0.382683426142,0.485712230206],
[0.605741500854,-0.734794259071,0.305212467909],
[0.552453517914,-0.760406017303,0.341435045004],
[0.825175166130,-0.476225703955,0.303801119328],
[0.790112197399,-0.545108973980,0.280319362879],
[0.830358564854,-0.504209458828,0.237228661776],
[0.536783814430,-0.735010981560,0.414272606373],
[0.735011100769,-0.414272665977,0.536783874035],
[0.496441334486,-0.669612050056,0.552418172359],
[0.540650010109,-0.607478022575,0.581951975822],
[0.470917046070,-0.628312826157,0.619241595268],
[0.803015947342,-0.415597438812,-0.427134811878],
[0.605741500854,-0.734794259071,-0.305212467909],
[0.552453517914,-0.760406017303,-0.341435045004],
[0.825175166130,-0.476225703955,-0.303801119328],
[0.790112197399,-0.545108973980,-0.280319362879],
[0.830358564854,-0.504209458828,-0.237228661776],
[0.305212467909,-0.605741500854,-0.734794259071],
[0.341435045004,-0.552453517914,-0.760406017303],
[0.427134811878,-0.803015947342,-0.415597438812],
[0.485712230206,-0.785898923874,-0.382683426142],
[0.228899985552,-0.703982532024,-0.672319412231],
[0.255179554224,-0.749435067177,-0.610925853252],
[0.187431842089,-0.749785602093,-0.634579241276],
[0.536783814430,-0.735010981560,-0.414272606373],
[0.414272665977,-0.536783874035,-0.735011100769],
[0.628312826157,-0.619241595268,-0.470917046070],
[0.607478022575,-0.581951975822,-0.540650010109],
[0.669612050056,-0.552418172359,-0.496441334486],
[-0.305212467909,0.605741500854,0.734794259071],
[-0.427134811878,0.803015947342,0.415597438812],
[-0.485712230206,0.785898923874,0.382683426142],
[-0.228899985552,0.703982532024,0.672319412231],
[-0.255179554224,0.749435067177,0.610925853252],
[-0.187431842089,0.749785602093,0.634579241276],
[-0.803015947342,0.415597438812,0.427134811878],
[-0.785898923874,0.382683426142,0.485712230206],
[-0.605741500854,0.734794259071,0.305212467909],
[-0.552453517914,0.760406017303,0.341435045004],
[-0.825175166130,0.476225703955,0.303801119328],
[-0.790112197399,0.545108973980,0.280319362879],
[-0.830358564854,0.504209458828,0.237228661776],
[-0.536783814430,0.735010981560,0.414272606373],
[-0.735011100769,0.414272665977,0.536783874035],
[-0.496441334486,0.669612050056,0.552418172359],
[-0.540650010109,0.607478022575,0.581951975822],
[-0.470917046070,0.628312826157,0.619241595268],
[-0.803015947342,0.415597438812,-0.427134811878],
[-0.605741500854,0.734794259071,-0.305212467909],
[-0.552453517914,0.760406017303,-0.341435045004],
[-0.825175166130,0.476225703955,-0.303801119328],
[-0.790112197399,0.545108973980,-0.280319362879],
[-0.830358564854,0.504209458828,-0.237228661776],
[-0.305212467909,0.605741500854,-0.734794259071],
[-0.341435045004,0.552453517914,-0.760406017303],
[-0.427134811878,0.803015947342,-0.415597438812],
[-0.485712230206,0.785898923874,-0.382683426142],
[-0.228899985552,0.703982532024,-0.672319412231],
[-0.255179554224,0.749435067177,-0.610925853252],
[-0.187431842089,0.749785602093,-0.634579241276],
[-0.536783814430,0.735010981560,-0.414272606373],
[-0.414272665977,0.536783874035,-0.735011100769],
[-0.628312826157,0.619241595268,-0.470917046070],
[-0.607478022575,0.581951975822,-0.540650010109],
[-0.669612050056,0.552418172359,-0.496441334486],
[-0.803015947342,-0.415597438812,0.427134811878],
[-0.605741500854,-0.734794259071,0.305212467909],
[-0.552453517914,-0.760406017303,0.341435045004],
[-0.825175166130,-0.476225703955,0.303801119328],
[-0.790112197399,-0.545108973980,0.280319362879],
[-0.830358564854,-0.504209458828,0.237228661776],
[-0.305212467909,-0.605741500854,0.734794259071],
[-0.341435045004,-0.552453517914,0.760406017303],
[-0.427134811878,-0.803015947342,0.415597438812],
[-0.485712230206,-0.785898923874,0.382683426142],
[-0.228899985552,-0.703982532024,0.672319412231],
[-0.255179554224,-0.749435067177,0.610925853252],
[-0.187431842089,-0.749785602093,0.634579241276],
[-0.536783814430,-0.735010981560,0.414272606373],
[-0.414272665977,-0.536783874035,0.735011100769],
[-0.628312826157,-0.619241595268,0.470917046070],
[-0.607478022575,-0.581951975822,0.540650010109],
[-0.669612050056,-0.552418172359,0.496441334486],
[-0.305212467909,-0.605741500854,-0.734794259071],
[-0.427134811878,-0.803015947342,-0.415597438812],
[-0.485712230206,-0.785898923874,-0.382683426142],
[-0.228899985552,-0.703982532024,-0.672319412231],
[-0.255179554224,-0.749435067177,-0.610925853252],
[-0.187431842089,-0.749785602093,-0.634579241276],
[-0.803015947342,-0.415597438812,-0.427134811878],
[-0.785898923874,-0.382683426142,-0.485712230206],
[-0.605741500854,-0.734794259071,-0.305212467909],
[-0.552453517914,-0.760406017303,-0.341435045004],
[-0.825175166130,-0.476225703955,-0.303801119328],
[-0.790112197399,-0.545108973980,-0.280319362879],
[-0.830358564854,-0.504209458828,-0.237228661776],
[-0.536783814430,-0.735010981560,-0.414272606373],
[-0.735011100769,-0.414272665977,-0.536783874035],
[-0.496441334486,-0.669612050056,-0.552418172359],
[-0.540650010109,-0.607478022575,-0.581951975822],
[-0.470917046070,-0.628312826157,-0.619241595268],
[0.460266560316,0.196015223861,0.865871071815],
[0.422363609076,0.131748646498,0.896800577641],
[0.339122503996,0.000000000000,0.940742254257],
[0.381721526384,0.065988346934,0.921918809414],
[0.316777586937,0.066042400897,0.946197807789],
[0.381721526384,-0.065988346934,0.921918809414],
[0.460266560316,-0.196015223861,0.865871071815],
[0.422363609076,-0.131748646498,0.896800577641],
[0.397350579500,-0.196412235498,0.896400988102],
[0.339122503996,0.000000000000,-0.940742254257],
[0.381721526384,0.065988346934,-0.921918809414],
[0.460266560316,0.196015223861,-0.865871071815],
[0.422363609076,0.131748646498,-0.896800577641],
[0.397350579500,0.196412235498,-0.896400988102],
[0.460266560316,-0.196015223861,-0.865871071815],
[0.422363609076,-0.131748646498,-0.896800577641],
[0.381721526384,-0.065988346934,-0.921918809414],
[0.316777586937,-0.066042400897,-0.946197807789],
[0.865871071815,0.460266560316,0.196015223861],
[0.896800577641,0.422363609076,0.131748646498],
[0.940742254257,0.339122503996,0.000000000000],
[0.921918809414,0.381721526384,0.065988346934],
[0.946197807789,0.316777586937,0.066042400897],
[0.921918809414,0.381721526384,-0.065988346934],
[0.865871071815,0.460266560316,-0.196015223861],
[0.896800577641,0.422363609076,-0.131748646498],
[0.896400988102,0.397350579500,-0.196412235498],
[-0.865871071815,-0.460266560316,0.196015223861],
[-0.896800577641,-0.422363609076,0.131748646498],
[-0.940742254257,-0.339122503996,0.000000000000],
[-0.921918809414,-0.381721526384,0.065988346934],
[-0.946197807789,-0.316777586937,0.066042400897],
[-0.921918809414,-0.381721526384,-0.065988346934],
[-0.865871071815,-0.460266560316,-0.196015223861],
[-0.896800577641,-0.422363609076,-0.131748646498],
[-0.896400988102,-0.397350579500,-0.196412235498],
[0.196015223861,0.865871071815,0.460266560316],
[0.131748646498,0.896800577641,0.422363609076],
[0.000000000000,0.940742254257,0.339122503996],
[0.065988346934,0.921918809414,0.381721526384],
[0.066042400897,0.946197807789,0.316777586937],
[-0.065988346934,0.921918809414,0.381721526384],
[-0.196015223861,0.865871071815,0.460266560316],
[-0.131748646498,0.896800577641,0.422363609076],
[-0.196412235498,0.896400988102,0.397350579500],
[0.000000000000,-0.940742254257,0.339122503996],
[0.065988346934,-0.921918809414,0.381721526384],
[0.196015223861,-0.865871071815,0.460266560316],
[0.131748646498,-0.896800577641,0.422363609076],
[0.196412235498,-0.896400988102,0.397350579500],
[-0.196015223861,-0.865871071815,0.460266560316],
[-0.131748646498,-0.896800577641,0.422363609076],
[-0.065988346934,-0.921918809414,0.381721526384],
[-0.066042400897,-0.946197807789,0.316777586937],
[0.121144086123,0.744727015495,0.656281888485],
[0.147413507104,0.790170073509,0.594895362854],
[0.172531709075,0.830812275410,0.529135048389],
[0.237228676677,0.830358564854,0.504209458828],
[0.196015223861,0.865871071815,-0.460266560316],
[0.172531709075,0.830812275410,-0.529135048389],
[0.121144086123,0.744727015495,-0.656281888485],
[0.147413507104,0.790170073509,-0.594895362854],
[0.187431842089,0.749785602093,-0.634579241276],
[0.529134988785,-0.172531694174,0.830812156200],
[0.656281888485,-0.121144086123,0.744727015495],
[0.594895362854,-0.147413507104,0.790170073509],
[0.634579241276,-0.187431842089,0.749785602093],
[0.656281888485,-0.121144086123,-0.744727015495],
[0.594895362854,-0.147413507104,-0.790170073509],
[0.529134988785,-0.172531694174,-0.830812156200],
[0.504209458828,-0.237228676677,-0.830358564854],
[-0.460266560316,0.196015223861,0.865871071815],
[-0.529134988785,0.172531694174,0.830812156200],
[-0.656281888485,0.121144086123,0.744727015495],
[-0.594895362854,0.147413507104,0.790170073509],
[-0.634579241276,0.187431842089,0.749785602093],
[-0.656281888485,0.121144086123,-0.744727015495],
[-0.594895362854,0.147413507104,-0.790170073509],
[-0.460266560316,0.196015223861,-0.865871071815],
[-0.529134988785,0.172531694174,-0.830812156200],
[-0.504209458828,0.237228676677,-0.830358564854],
[-0.656281888485,-0.121144086123,0.744727015495],
[-0.594895362854,-0.147413507104,0.790170073509],
[-0.460266560316,-0.196015223861,0.865871071815],
[-0.529134988785,-0.172531694174,0.830812156200],
[-0.504209458828,-0.237228676677,0.830358564854],
[-0.460266560316,-0.196015223861,-0.865871071815],
[-0.529134988785,-0.172531694174,-0.830812156200],
[-0.656281888485,-0.121144086123,-0.744727015495],
[-0.594895362854,-0.147413507104,-0.790170073509],
[-0.634579241276,-0.187431842089,-0.749785602093],
[0.040642105043,0.749387085438,0.660883605480],
[-0.121144086123,0.744727015495,0.656281888485],
[-0.040642105043,0.749387085438,0.660883605480],
[-0.080572985113,0.708969175816,0.700621724129],
[-0.339122503996,0.000000000000,0.940742254257],
[-0.381721526384,0.065988346934,0.921918809414],
[-0.422363609076,0.131748646498,0.896800577641],
[-0.397350579500,0.196412235498,0.896400988102],
[0.078459091485,0.524110496044,0.848028540611],
[0.119755484164,0.460881620646,0.879344463348],
[0.201188594103,0.325529992580,0.923879563808],
[0.161006405950,0.394136220217,0.904838979244],
[0.122800238431,0.332341909409,0.935130417347],
[-0.381721526384,-0.065988346934,0.921918809414],
[-0.422363609076,-0.131748646498,0.896800577641],
[-0.397350579500,-0.196412235498,0.896400988102],
[0.121144086123,-0.744727015495,0.656281888485],
[0.040642105043,-0.749387085438,0.660883605480],
[-0.121144086123,-0.744727015495,0.656281888485],
[-0.040642105043,-0.749387085438,0.660883605480],
[-0.080572985113,-0.708969175816,0.700621724129],
[-0.122729502618,-0.198580488563,0.972369968891],
[-0.041250910610,-0.200367778540,0.978851914406],
[0.122729502618,-0.198580488563,0.972369968891],
[0.041250910610,-0.200367778540,0.978851914406],
[0.081501059234,-0.265518426895,0.960654795170],
[-0.339122503996,0.000000000000,-0.940742254257],
[-0.381721526384,0.065988346934,-0.921918809414],
[-0.422363609076,0.131748646498,-0.896800577641],
[-0.397350579500,0.196412235498,-0.896400988102],
[0.040642105043,0.749387085438,-0.660883605480],
[-0.121144086123,0.744727015495,-0.656281888485],
[-0.040642105043,0.749387085438,-0.660883605480],
[-0.080572985113,0.708969175816,-0.700621724129],
[-0.122729502618,0.198580488563,-0.972369968891],
[-0.041250910610,0.200367778540,-0.978851914406],
[0.122729502618,0.198580488563,-0.972369968891],
[0.041250910610,0.200367778540,-0.978851914406],
[0.081501059234,0.265518426895,-0.960654795170],
[0.121144086123,-0.744727015495,-0.656281888485],
[0.040642105043,-0.749387085438,-0.660883605480],
[-0.121144086123,-0.744727015495,-0.656281888485],
[-0.040642105043,-0.749387085438,-0.660883605480],
[-0.080572985113,-0.708969175816,-0.700621724129],
[-0.381721526384,-0.065988346934,-0.921918809414],
[-0.422363609076,-0.131748646498,-0.896800577641],
[-0.397350579500,-0.196412235498,-0.896400988102],
[0.078459091485,-0.524110496044,-0.848028540611],
[0.119755484164,-0.460881620646,-0.879344463348],
[0.201188594103,-0.325529992580,-0.923879563808],
[0.161006405950,-0.394136220217,-0.904838979244],
[0.122800238431,-0.332341909409,-0.935130417347],
[0.656281888485,0.121144086123,0.744727015495],
[0.660883605480,0.040642105043,0.749387085438],
[0.660883605480,-0.040642105043,0.749387085438],
[0.700621724129,-0.080572985113,0.708969175816],
[0.940742254257,-0.339122503996,0.000000000000],
[0.921918809414,-0.381721526384,0.065988346934],
[0.865871071815,-0.460266560316,0.196015223861],
[0.896800577641,-0.422363609076,0.131748646498],
[0.896400988102,-0.397350579500,0.196412235498],
[0.848028540611,0.078459091485,0.524110496044],
[0.879344463348,0.119755484164,0.460881620646],
[0.923879563808,0.201188594103,0.325529992580],
[0.904838979244,0.161006405950,0.394136220217],
[0.935130417347,0.122800238431,0.332341909409],
[0.921918809414,-0.381721526384,-0.065988346934],
[0.865871071815,-0.460266560316,-0.196015223861],
[0.896800577641,-0.422363609076,-0.131748646498],
[0.896400988102,-0.397350579500,-0.196412235498],
[0.656281888485,0.121144086123,-0.744727015495],
[0.660883605480,0.040642105043,-0.749387085438],
[0.660883605480,-0.040642105043,-0.749387085438],
[0.700621724129,-0.080572985113,-0.708969175816],
[0.972369849682,-0.122729487717,-0.198580473661],
[0.978851914406,-0.041250910610,-0.200367778540],
[0.972369849682,0.122729487717,-0.198580473661],
[0.978851914406,0.041250910610,-0.200367778540],
[0.960654795170,0.081501059234,-0.265518426895],
[-0.660883605480,-0.040642105043,0.749387085438],
[-0.660883605480,0.040642105043,0.749387085438],
[-0.700621724129,0.080572985113,0.708969175816],
[-0.940742254257,0.339122503996,0.000000000000],
[-0.921918809414,0.381721526384,0.065988346934],
[-0.865871071815,0.460266560316,0.196015223861],
[-0.896800577641,0.422363609076,0.131748646498],
[-0.896400988102,0.397350579500,0.196412235498],
[-0.848028540611,-0.078459091485,0.524110496044],
[-0.879344463348,-0.119755484164,0.460881620646],
[-0.923879563808,-0.201188594103,0.325529992580],
[-0.904838979244,-0.161006405950,0.394136220217],
[-0.935130417347,-0.122800238431,0.332341909409],
[-0.921918809414,0.381721526384,-0.065988346934],
[-0.865871071815,0.460266560316,-0.196015223861],
[-0.896800577641,0.422363609076,-0.131748646498],
[-0.896400988102,0.397350579500,-0.196412235498],
[-0.660883605480,-0.040642105043,-0.749387085438],
[-0.660883605480,0.040642105043,-0.749387085438],
[-0.700621724129,0.080572985113,-0.708969175816],
[-0.972369849682,0.122729487717,-0.198580473661],
[-0.978851914406,0.041250910610,-0.200367778540],
[-0.972369849682,-0.122729487717,-0.198580473661],
[-0.978851914406,-0.041250910610,-0.200367778540],
[-0.960654795170,-0.081501059234,-0.265518426895],
[0.744727015495,0.656281888485,0.121144086123],
[0.749387085438,0.660883605480,0.040642105043],
[0.744727015495,0.656281888485,-0.121144086123],
[0.749387085438,0.660883605480,-0.040642105043],
[0.708969175816,0.700621724129,-0.080572985113],
[0.000000000000,0.940742254257,-0.339122503996],
[0.065988346934,0.921918809414,-0.381721526384],
[0.131748646498,0.896800577641,-0.422363609076],
[0.196412235498,0.896400988102,-0.397350579500],
[0.524110496044,0.848028540611,0.078459091485],
[0.460881620646,0.879344463348,0.119755484164],
[0.325529992580,0.923879563808,0.201188594103],
[0.394136220217,0.904838919640,0.161006391048],
[0.332341909409,0.935130417347,0.122800238431],
[-0.065988346934,0.921918809414,-0.381721526384],
[-0.196015223861,0.865871071815,-0.460266560316],
[-0.131748646498,0.896800577641,-0.422363609076],
[-0.196412235498,0.896400988102,-0.397350579500],
[-0.744727015495,0.656281888485,0.121144086123],
[-0.749387085438,0.660883605480,0.040642105043],
[-0.744727015495,0.656281888485,-0.121144086123],
[-0.749387085438,0.660883605480,-0.040642105043],
[-0.708969175816,0.700621724129,-0.080572985113],
[-0.198580473661,0.972369849682,-0.122729487717],
[-0.200367778540,0.978851914406,-0.041250910610],
[-0.198580473661,0.972369849682,0.122729487717],
[-0.200367778540,0.978851914406,0.041250910610],
[-0.265518426895,0.960654795170,0.081501059234],
[0.000000000000,-0.940742254257,-0.339122503996],
[0.065988346934,-0.921918809414,-0.381721526384],
[0.196015223861,-0.865871071815,-0.460266560316],
[0.131748646498,-0.896800577641,-0.422363609076],
[0.196412235498,-0.896400988102,-0.397350579500],
[0.744727015495,-0.656281888485,0.121144086123],
[0.749387085438,-0.660883605480,0.040642105043],
[0.744727015495,-0.656281888485,-0.121144086123],
[0.749387085438,-0.660883605480,-0.040642105043],
[0.708969175816,-0.700621724129,-0.080572985113],
[0.198580473661,-0.972369849682,-0.122729487717],
[0.200367778540,-0.978851914406,-0.041250910610],
[0.198580473661,-0.972369849682,0.122729487717],
[0.200367778540,-0.978851914406,0.041250910610],
[0.265518426895,-0.960654795170,0.081501059234],
[-0.744727015495,-0.656281888485,0.121144086123],
[-0.749387085438,-0.660883605480,0.040642105043],
[-0.744727015495,-0.656281888485,-0.121144086123],
[-0.749387085438,-0.660883605480,-0.040642105043],
[-0.708969175816,-0.700621724129,-0.080572985113],
[-0.065988346934,-0.921918809414,-0.381721526384],
[-0.196015223861,-0.865871071815,-0.460266560316],
[-0.131748646498,-0.896800577641,-0.422363609076],
[-0.196412235498,-0.896400988102,-0.397350579500],
[-0.524110496044,-0.848028540611,0.078459091485],
[-0.460881620646,-0.879344463348,0.119755484164],
[-0.325529992580,-0.923879563808,0.201188594103],
[-0.394136220217,-0.904838919640,0.161006391048],
[-0.332341909409,-0.935130417347,0.122800238431],
[0.529134988785,0.172531694174,0.830812156200],
[0.594895362854,0.147413507104,0.790170073509],
[0.634579241276,0.187431842089,0.749785602093],
[0.790170133114,0.594895362854,0.147413522005],
[0.830812156200,0.529134988785,0.172531709075],
[0.830358564854,0.504209458828,0.237228661776],
[0.522498548031,0.448259413242,0.725299060345],
[0.485208272934,0.517970383167,0.704471170902],
[0.399769037962,0.646839916706,0.649448037148],
[0.443957388401,0.584715723991,0.678976714611],
[0.470917046070,0.628312826157,0.619241595268],
[0.790170133114,0.594895362854,-0.147413522005],
[0.830812156200,0.529134988785,-0.172531709075],
[0.830358564854,0.504209458828,-0.237228661776],
[0.529134988785,0.172531694174,-0.830812156200],
[0.594895362854,0.147413507104,-0.790170073509],
[0.634579241276,0.187431842089,-0.749785602093],
[0.646839916706,0.649448037148,-0.399769037962],
[0.584715723991,0.678976714611,-0.443957388401],
[0.448259413242,0.725299060345,-0.522498548031],
[0.517970383167,0.704471170902,-0.485208272934],
[0.496441334486,0.669612050056,-0.552418172359],
[0.147413507104,-0.790170073509,0.594895362854],
[0.172531709075,-0.830812275410,0.529135048389],
[0.237228676677,-0.830358564854,0.504209458828],
[0.830812156200,-0.529134988785,0.172531709075],
[0.790170133114,-0.594895362854,0.147413522005],
[0.749785602093,-0.634579300880,0.187431842089],
[0.399769037962,-0.646839916706,0.649448037148],
[0.443957388401,-0.584715723991,0.678976714611],
[0.522498548031,-0.448259413242,0.725299060345],
[0.485208272934,-0.517970383167,0.704471170902],
[0.552418172359,-0.496441334486,0.669612050056],
[0.830812156200,-0.529134988785,-0.172531709075],
[0.790170133114,-0.594895362854,-0.147413522005],
[0.749785602093,-0.634579300880,-0.187431842089],
[0.147413507104,-0.790170073509,-0.594895362854],
[0.172531709075,-0.830812275410,-0.529135048389],
[0.237228676677,-0.830358564854,-0.504209458828],
[0.725299060345,-0.522498548031,-0.448259413242],
[0.704471170902,-0.485208272934,-0.517970383167],
[0.649448037148,-0.399769037962,-0.646839916706],
[0.678976714611,-0.443957388401,-0.584715723991],
[0.619241595268,-0.470917046070,-0.628312826157],
[-0.147413507104,0.790170073509,0.594895362854],
[-0.172531709075,0.830812275410,0.529135048389],
[-0.237228676677,0.830358564854,0.504209458828],
[-0.830812156200,0.529134988785,0.172531709075],
[-0.790170133114,0.594895362854,0.147413522005],
[-0.749785602093,0.634579300880,0.187431842089],
[-0.399769037962,0.646839916706,0.649448037148],
[-0.443957388401,0.584715723991,0.678976714611],
[-0.522498548031,0.448259413242,0.725299060345],
[-0.485208272934,0.517970383167,0.704471170902],
[-0.552418172359,0.496441334486,0.669612050056],
[-0.830812156200,0.529134988785,-0.172531709075],
[-0.790170133114,0.594895362854,-0.147413522005],
[-0.749785602093,0.634579300880,-0.187431842089],
[-0.147413507104,0.790170073509,-0.594895362854],
[-0.172531709075,0.830812275410,-0.529135048389],
[-0.237228676677,0.830358564854,-0.504209458828],
[-0.725299060345,0.522498548031,-0.448259413242],
[-0.704471170902,0.485208272934,-0.517970383167],
[-0.649448037148,0.399769037962,-0.646839916706],
[-0.678976714611,0.443957388401,-0.584715723991],
[-0.619241595268,0.470917046070,-0.628312826157],
[-0.830812156200,-0.529134988785,0.172531709075],
[-0.790170133114,-0.594895362854,0.147413522005],
[-0.749785602093,-0.634579300880,0.187431842089],
[-0.147413507104,-0.790170073509,0.594895362854],
[-0.172531709075,-0.830812275410,0.529135048389],
[-0.237228676677,-0.830358564854,0.504209458828],
[-0.725299060345,-0.522498548031,0.448259413242],
[-0.704471170902,-0.485208272934,0.517970383167],
[-0.649448037148,-0.399769037962,0.646839916706],
[-0.678976714611,-0.443957388401,0.584715723991],
[-0.619241595268,-0.470917046070,0.628312826157],
[-0.147413507104,-0.790170073509,-0.594895362854],
[-0.172531709075,-0.830812275410,-0.529135048389],
[-0.237228676677,-0.830358564854,-0.504209458828],
[-0.830812156200,-0.529134988785,-0.172531709075],
[-0.790170133114,-0.594895362854,-0.147413522005],
[-0.749785602093,-0.634579300880,-0.187431842089],
[-0.399769037962,-0.646839916706,-0.649448037148],
[-0.443957388401,-0.584715723991,-0.678976714611],
[-0.522498548031,-0.448259413242,-0.725299060345],
[-0.485208272934,-0.517970383167,-0.704471170902],
[-0.552418172359,-0.496441334486,-0.669612050056],
[0.405433833599,0.322524696589,0.855336964130],
[0.339208841324,0.324863553047,0.882836937904],
[0.270627111197,0.325928956270,0.905831813812],
[0.232455179095,0.264151185751,0.936049580574],
[0.206102609634,0.000000000000,0.978530406952],
[0.179595917463,0.066604390740,0.981483221054],
[0.247325703502,0.066566854715,0.966643095016],
[0.122729502618,0.198580488563,0.972369968891],
[0.151548892260,0.133256375790,0.979426145554],
[0.191779986024,0.198337361217,0.961188256741],
[0.261550366879,0.199094086885,0.944432556629],
[0.289929419756,0.132569819689,0.947821795940],
[0.179595917463,-0.066604390740,0.981483221054],
[0.151548892260,-0.133256375790,0.979426145554],
[0.191779986024,-0.198337361217,0.961188256741],
[0.405433833599,-0.322524696589,0.855336964130],
[0.339208841324,-0.324863553047,0.882836937904],
[0.368518292904,-0.262660562992,0.891741991043],
[0.201188594103,-0.325529992580,0.923879563808],
[0.270627111197,-0.325928956270,0.905831813812],
[0.232455179095,-0.264151185751,0.936049580574],
[0.261550366879,-0.199094086885,0.944432556629],
[0.330606490374,-0.198386684060,0.922681987286],
[0.206102609634,0.000000000000,-0.978530406952],
[0.179595917463,0.066604390740,-0.981483221054],
[0.151548892260,0.133256375790,-0.979426145554],
[0.191779986024,0.198337361217,-0.961188256741],
[0.405433833599,0.322524696589,-0.855336964130],
[0.339208841324,0.324863553047,-0.882836937904],
[0.368518292904,0.262660562992,-0.891741991043],
[0.201188594103,0.325529992580,-0.923879563808],
[0.270627111197,0.325928956270,-0.905831813812],
[0.232455179095,0.264151185751,-0.936049580574],
[0.261550366879,0.199094086885,-0.944432556629],
[0.330606490374,0.198386684060,-0.922681987286],
[0.405433833599,-0.322524696589,-0.855336964130],
[0.339208841324,-0.324863553047,-0.882836937904],
[0.270627111197,-0.325928956270,-0.905831813812],
[0.232455179095,-0.264151185751,-0.936049580574],
[0.179595917463,-0.066604390740,-0.981483221054],
[0.247325703502,-0.066566854715,-0.966643095016],
[0.122729502618,-0.198580488563,-0.972369968891],
[0.151548892260,-0.133256375790,-0.979426145554],
[0.191779986024,-0.198337361217,-0.961188256741],
[0.261550366879,-0.199094086885,-0.944432556629],
[0.289929419756,-0.132569819689,-0.947821795940],
[0.855336964130,0.405433833599,0.322524696589],
[0.882836937904,0.339208841324,0.324863553047],
[0.905831813812,0.270627111197,0.325928956270],
[0.936049580574,0.232455179095,0.264151185751],
[0.978530406952,0.206102609634,0.000000000000],
[0.981483101845,0.179595902562,0.066604383290],
[0.966643095016,0.247325703502,0.066566854715],
[0.972369849682,0.122729487717,0.198580473661],
[0.979426145554,0.151548892260,0.133256375790],
[0.961188256741,0.191779986024,0.198337361217],
[0.944432675838,0.261550396681,0.199094116688],
[0.947821795940,0.289929419756,0.132569819689],
[0.981483101845,0.179595902562,-0.066604383290],
[0.979426145554,0.151548892260,-0.133256375790],
[0.961188256741,0.191779986024,-0.198337361217],
[0.855336964130,0.405433833599,-0.322524696589],
[0.882836937904,0.339208841324,-0.324863553047],
[0.891741991043,0.368518292904,-0.262660562992],
[0.923879563808,0.201188594103,-0.325529992580],
[0.905831813812,0.270627111197,-0.325928956270],
[0.936049580574,0.232455179095,-0.264151185751],
[0.944432675838,0.261550396681,-0.199094116688],
[0.922681987286,0.330606490374,-0.198386684060],
[-0.855336964130,-0.405433833599,0.322524696589],
[-0.882836937904,-0.339208841324,0.324863553047],
[-0.905831813812,-0.270627111197,0.325928956270],
[-0.936049580574,-0.232455179095,0.264151185751],
[-0.978530406952,-0.206102609634,0.000000000000],
[-0.981483101845,-0.179595902562,0.066604383290],
[-0.966643095016,-0.247325703502,0.066566854715],
[-0.972369849682,-0.122729487717,0.198580473661],
[-0.979426145554,-0.151548892260,0.133256375790],
[-0.961188256741,-0.191779986024,0.198337361217],
[-0.944432675838,-0.261550396681,0.199094116688],
[-0.947821795940,-0.289929419756,0.132569819689],
[-0.981483101845,-0.179595902562,-0.066604383290],
[-0.979426145554,-0.151548892260,-0.133256375790],
[-0.961188256741,-0.191779986024,-0.198337361217],
[-0.855336964130,-0.405433833599,-0.322524696589],
[-0.882836937904,-0.339208841324,-0.324863553047],
[-0.891741991043,-0.368518292904,-0.262660562992],
[-0.923879563808,-0.201188594103,-0.325529992580],
[-0.905831813812,-0.270627111197,-0.325928956270],
[-0.936049580574,-0.232455179095,-0.264151185751],
[-0.944432675838,-0.261550396681,-0.199094116688],
[-0.922681987286,-0.330606490374,-0.198386684060],
[0.322524696589,0.855336964130,0.405433833599],
[0.324863553047,0.882836937904,0.339208841324],
[0.325928986073,0.905831813812,0.270627111197],
[0.264151185751,0.936049580574,0.232455179095],
[0.000000000000,0.978530406952,0.206102609634],
[0.066604383290,0.981483101845,0.179595902562],
[0.066566854715,0.966643095016,0.247325703502],
[0.198580473661,0.972369849682,0.122729487717],
[0.133256375790,0.979426145554,0.151548892260],
[0.198337361217,0.961188256741,0.191779986024],
[0.199094086885,0.944432556629,0.261550366879],
[0.132569819689,0.947821795940,0.289929419756],
[-0.066604383290,0.981483101845,0.179595902562],
[-0.133256375790,0.979426145554,0.151548892260],
[-0.198337361217,0.961188256741,0.191779986024],
[-0.322524696589,0.855336964130,0.405433833599],
[-0.324863553047,0.882836937904,0.339208841324],
[-0.262660562992,0.891741991043,0.368518292904],
[-0.325529992580,0.923879563808,0.201188594103],
[-0.325928986073,0.905831813812,0.270627111197],
[-0.264151185751,0.936049580574,0.232455179095],
[-0.199094086885,0.944432556629,0.261550366879],
[-0.198386684060,0.922681987286,0.330606490374],
[0.000000000000,-0.978530406952,0.206102609634],
[0.066604383290,-0.981483101845,0.179595902562],
[0.133256375790,-0.979426145554,0.151548892260],
[0.198337361217,-0.961188256741,0.191779986024],
[0.322524696589,-0.855336964130,0.405433833599],
[0.324863553047,-0.882836937904,0.339208841324],
[0.262660562992,-0.891741991043,0.368518292904],
[0.325529992580,-0.923879563808,0.201188594103],
[0.325928986073,-0.905831813812,0.270627111197],
[0.264151185751,-0.936049580574,0.232455179095],
[0.199094086885,-0.944432556629,0.261550366879],
[0.198386684060,-0.922681987286,0.330606490374],
[-0.322524696589,-0.855336964130,0.405433833599],
[-0.324863553047,-0.882836937904,0.339208841324],
[-0.325928986073,-0.905831813812,0.270627111197],
[-0.264151185751,-0.936049580574,0.232455179095],
[-0.066604383290,-0.981483101845,0.179595902562],
[-0.066566854715,-0.966643095016,0.247325703502],
[-0.198580473661,-0.972369849682,0.122729487717],
[-0.133256375790,-0.979426145554,0.151548892260],
[-0.198337361217,-0.961188256741,0.191779986024],
[-0.199094086885,-0.944432556629,0.261550366879],
[-0.132569819689,-0.947821795940,0.289929419756],
[0.199331194162,0.656005680561,0.727958440781],
[0.267381101847,0.656619668007,0.705236136913],
[0.334691524506,0.653497219086,0.678913056850],
[0.361591756344,0.697037041187,0.619185566902],
[0.366027295589,0.816232562065,0.446976989508],
[0.303801119328,0.825175166130,0.476225703955],
[0.448259413242,0.725299060345,0.522498548031],
[0.408285975456,0.772575497627,0.486240506172],
[0.386730432510,0.737712204456,0.553371787071],
[0.322140991688,0.745338499546,0.583691358566],
[0.280319362879,0.790112078190,0.545108973980],
[0.322524696589,0.855336964130,-0.405433833599],
[0.366027295589,0.816232562065,-0.446976989508],
[0.408285975456,0.772575497627,-0.486240506172],
[0.386730432510,0.737712204456,-0.553371787071],
[0.199331194162,0.656005680561,-0.727958440781],
[0.267381101847,0.656619668007,-0.705236136913],
[0.228899985552,0.703982532024,-0.672319412231],
[0.399769037962,0.646839916706,-0.649448037148],
[0.334691524506,0.653497219086,-0.678913056850],
[0.361591756344,0.697037041187,-0.619185566902],
[0.322140991688,0.745338499546,-0.583691358566],
[0.255179554224,0.749435067177,-0.610925853252],
[0.446976989508,-0.366027295589,0.816232562065],
[0.486240506172,-0.408285975456,0.772575497627],
[0.553371787071,-0.386730432510,0.737712204456],
[0.727958440781,-0.199331194162,0.656005680561],
[0.705236136913,-0.267381101847,0.656619668007],
[0.672319412231,-0.228899985552,0.703982532024],
[0.649448037148,-0.399769037962,0.646839916706],
[0.678913056850,-0.334691524506,0.653497219086],
[0.619185566902,-0.361591756344,0.697037041187],
[0.583691358566,-0.322140991688,0.745338499546],
[0.610925853252,-0.255179554224,0.749435067177],
[0.727958440781,-0.199331194162,-0.656005680561],
[0.705236136913,-0.267381101847,-0.656619668007],
[0.678913056850,-0.334691524506,-0.653497219086],
[0.619185566902,-0.361591756344,-0.697037041187],
[0.446976989508,-0.366027295589,-0.816232562065],
[0.476225703955,-0.303801119328,-0.825175166130],
[0.522498548031,-0.448259413242,-0.725299060345],
[0.486240506172,-0.408285975456,-0.772575497627],
[0.553371787071,-0.386730432510,-0.737712204456],
[0.583691358566,-0.322140991688,-0.745338499546],
[0.545108973980,-0.280319362879,-0.790112078190],
[-0.405433833599,0.322524696589,0.855336964130],
[-0.446976989508,0.366027295589,0.816232562065],
[-0.486240506172,0.408285975456,0.772575497627],
[-0.553371787071,0.386730432510,0.737712204456],
[-0.727958440781,0.199331194162,0.656005680561],
[-0.705236136913,0.267381101847,0.656619668007],
[-0.672319412231,0.228899985552,0.703982532024],
[-0.649448037148,0.399769037962,0.646839916706],
[-0.678913056850,0.334691524506,0.653497219086],
[-0.619185566902,0.361591756344,0.697037041187],
[-0.583691358566,0.322140991688,0.745338499546],
[-0.610925853252,0.255179554224,0.749435067177],
[-0.727958440781,0.199331194162,-0.656005680561],
[-0.705236136913,0.267381101847,-0.656619668007],
[-0.678913056850,0.334691524506,-0.653497219086],
[-0.619185566902,0.361591756344,-0.697037041187],
[-0.405433833599,0.322524696589,-0.855336964130],
[-0.446976989508,0.366027295589,-0.816232562065],
[-0.476225703955,0.303801119328,-0.825175166130],
[-0.522498548031,0.448259413242,-0.725299060345],
[-0.486240506172,0.408285975456,-0.772575497627],
[-0.553371787071,0.386730432510,-0.737712204456],
[-0.583691358566,0.322140991688,-0.745338499546],
[-0.545108973980,0.280319362879,-0.790112078190],
[-0.727958440781,-0.199331194162,0.656005680561],
[-0.705236136913,-0.267381101847,0.656619668007],
[-0.678913056850,-0.334691524506,0.653497219086],
[-0.619185566902,-0.361591756344,0.697037041187],
[-0.405433833599,-0.322524696589,0.855336964130],
[-0.446976989508,-0.366027295589,0.816232562065],
[-0.476225703955,-0.303801119328,0.825175166130],
[-0.522498548031,-0.448259413242,0.725299060345],
[-0.486240506172,-0.408285975456,0.772575497627],
[-0.553371787071,-0.386730432510,0.737712204456],
[-0.583691358566,-0.322140991688,0.745338499546],
[-0.545108973980,-0.280319362879,0.790112078190],
[-0.405433833599,-0.322524696589,-0.855336964130],
[-0.446976989508,-0.366027295589,-0.816232562065],
[-0.486240506172,-0.408285975456,-0.772575497627],
[-0.553371787071,-0.386730432510,-0.737712204456],
[-0.727958440781,-0.199331194162,-0.656005680561],
[-0.705236136913,-0.267381101847,-0.656619668007],
[-0.672319412231,-0.228899985552,-0.703982532024],
[-0.649448037148,-0.399769037962,-0.646839916706],
[-0.678913056850,-0.334691524506,-0.653497219086],
[-0.619185566902,-0.361591756344,-0.697037041187],
[-0.583691358566,-0.322140991688,-0.745338499546],
[-0.610925853252,-0.255179554224,-0.749435067177],
[0.159612923861,0.615455865860,0.771840512753],
[0.119078218937,0.571140229702,0.812169492245],
[0.040675185621,0.574457764626,0.817523002625],
[-0.199331194162,0.656005680561,0.727958440781],
[-0.159612923861,0.615455865860,0.771840512753],
[-0.121192574501,0.662841916084,0.738886237144],
[-0.078459091485,0.524110496044,0.848028540611],
[-0.119078218937,0.571140229702,0.812169492245],
[-0.040675185621,0.574457764626,0.817523002625],
[0.000000000000,0.622291564941,0.782785594463],
[-0.040677066892,0.667502403259,0.743495702744],
[-0.206102609634,0.000000000000,0.978530406952],
[-0.179595917463,0.066604390740,0.981483221054],
[-0.122729502618,0.198580488563,0.972369968891],
[-0.151548892260,0.133256375790,0.979426145554],
[-0.191779986024,0.198337361217,0.961188256741],
[-0.339208841324,0.324863553047,0.882836937904],
[-0.368518292904,0.262660562992,0.891741991043],
[-0.201188594103,0.325529992580,0.923879563808],
[-0.270627111197,0.325928956270,0.905831813812],
[-0.232455179095,0.264151185751,0.936049580574],
[-0.261550366879,0.199094086885,0.944432556629],
[-0.330606490374,0.198386684060,0.922681987286],
[-0.119755484164,0.460881620646,0.879344463348],
[-0.161006405950,0.394136220217,0.904838979244],
[-0.122800238431,0.332341909409,0.935130417347],
[0.041250910610,0.200367778540,0.978851914406],
[0.081501059234,0.265518426895,0.960654795170],
[-0.041250910610,0.200367778540,0.978851914406],
[-0.081501059234,0.265518426895,0.960654795170],
[-0.041301984340,0.334140032530,0.941618025303],
[0.041301984340,0.334140032530,0.941618025303],
[-0.179595917463,-0.066604390740,0.981483221054],
[-0.151548892260,-0.133256375790,0.979426145554],
[-0.191779986024,-0.198337361217,0.961188256741],
[-0.339208841324,-0.324863553047,0.882836937904],
[-0.368518292904,-0.262660562992,0.891741991043],
[-0.201188594103,-0.325529992580,0.923879563808],
[-0.270627111197,-0.325928956270,0.905831813812],
[-0.232455179095,-0.264151185751,0.936049580574],
[-0.261550366879,-0.199094086885,0.944432556629],
[-0.330606490374,-0.198386684060,0.922681987286],
[0.199331194162,-0.656005680561,0.727958440781],
[0.159612923861,-0.615455865860,0.771840512753],
[0.078459091485,-0.524110496044,0.848028540611],
[0.119078218937,-0.571140229702,0.812169492245],
[0.040675185621,-0.574457764626,0.817523002625],
[-0.199331194162,-0.656005680561,0.727958440781],
[-0.159612923861,-0.615455865860,0.771840512753],
[-0.121192574501,-0.662841916084,0.738886237144],
[-0.078459091485,-0.524110496044,0.848028540611],
[-0.119078218937,-0.571140229702,0.812169492245],
[-0.040675185621,-0.574457764626,0.817523002625],
[0.000000000000,-0.622291564941,0.782785594463],
[-0.040677066892,-0.667502403259,0.743495702744],
[-0.161006405950,-0.394136220217,0.904838979244],
[-0.119755484164,-0.460881620646,0.879344463348],
[-0.041299182922,-0.464213401079,0.884760022163],
[0.161006405950,-0.394136220217,0.904838979244],
[0.122800238431,-0.332341909409,0.935130417347],
[0.119755484164,-0.460881620646,0.879344463348],
[0.041299182922,-0.464213401079,0.884760022163],
[0.000000000000,-0.400968074799,0.916092038155],
[0.041301984340,-0.334140032530,0.941618025303],
[-0.206102609634,0.000000000000,-0.978530406952],
[-0.179595917463,0.066604390740,-0.981483221054],
[-0.151548892260,0.133256375790,-0.979426145554],
[-0.191779986024,0.198337361217,-0.961188256741],
[-0.339208841324,0.324863553047,-0.882836937904],
[-0.368518292904,0.262660562992,-0.891741991043],
[-0.201188594103,0.325529992580,-0.923879563808],
[-0.270627111197,0.325928956270,-0.905831813812],
[-0.232455179095,0.264151185751,-0.936049580574],
[-0.261550366879,0.199094086885,-0.944432556629],
[-0.330606490374,0.198386684060,-0.922681987286],
[0.159612923861,0.615455865860,-0.771840512753],
[0.078459091485,0.524110496044,-0.848028540611],
[0.119078218937,0.571140229702,-0.812169492245],
[0.040675185621,0.574457764626,-0.817523002625],
[-0.199331194162,0.656005680561,-0.727958440781],
[-0.159612923861,0.615455865860,-0.771840512753],
[-0.121192574501,0.662841916084,-0.738886237144],
[-0.078459091485,0.524110496044,-0.848028540611],
[-0.119078218937,0.571140229702,-0.812169492245],
[-0.040675185621,0.574457764626,-0.817523002625],
[0.000000000000,0.622291564941,-0.782785594463],
[-0.040677066892,0.667502403259,-0.743495702744],
[-0.161006405950,0.394136220217,-0.904838979244],
[-0.119755484164,0.460881620646,-0.879344463348],
[-0.041299182922,0.464213401079,-0.884760022163],
[0.161006405950,0.394136220217,-0.904838979244],
[0.122800238431,0.332341909409,-0.935130417347],
[0.119755484164,0.460881620646,-0.879344463348],
[0.041299182922,0.464213401079,-0.884760022163],
[0.000000000000,0.400968074799,-0.916092038155],
[0.041301984340,0.334140032530,-0.941618025303],
[0.199331194162,-0.656005680561,-0.727958440781],
[0.159612923861,-0.615455865860,-0.771840512753],
[0.119078218937,-0.571140229702,-0.812169492245],
[0.040675185621,-0.574457764626,-0.817523002625],
[-0.199331194162,-0.656005680561,-0.727958440781],
[-0.159612923861,-0.615455865860,-0.771840512753],
[-0.121192574501,-0.662841916084,-0.738886237144],
[-0.078459091485,-0.524110496044,-0.848028540611],
[-0.119078218937,-0.571140229702,-0.812169492245],
[-0.040675185621,-0.574457764626,-0.817523002625],
[0.000000000000,-0.622291564941,-0.782785594463],
[-0.040677066892,-0.667502403259,-0.743495702744],
[-0.179595917463,-0.066604390740,-0.981483221054],
[-0.122729502618,-0.198580488563,-0.972369968891],
[-0.151548892260,-0.133256375790,-0.979426145554],
[-0.191779986024,-0.198337361217,-0.961188256741],
[-0.339208841324,-0.324863553047,-0.882836937904],
[-0.368518292904,-0.262660562992,-0.891741991043],
[-0.201188594103,-0.325529992580,-0.923879563808],
[-0.270627111197,-0.325928956270,-0.905831813812],
[-0.232455179095,-0.264151185751,-0.936049580574],
[-0.261550366879,-0.199094086885,-0.944432556629],
[-0.330606490374,-0.198386684060,-0.922681987286],
[-0.119755484164,-0.460881620646,-0.879344463348],
[-0.161006405950,-0.394136220217,-0.904838979244],
[-0.122800238431,-0.332341909409,-0.935130417347],
[0.041250910610,-0.200367778540,-0.978851914406],
[0.081501059234,-0.265518426895,-0.960654795170],
[-0.041250910610,-0.200367778540,-0.978851914406],
[-0.081501059234,-0.265518426895,-0.960654795170],
[-0.041301984340,-0.334140032530,-0.941618025303],
[0.041301984340,-0.334140032530,-0.941618025303],
[0.727958440781,0.199331194162,0.656005680561],
[0.771840512753,0.159612923861,0.615455865860],
[0.812169492245,0.119078218937,0.571140229702],
[0.817523002625,0.040675185621,0.574457764626],
[0.771840512753,-0.159612923861,0.615455865860],
[0.738886237144,-0.121192574501,0.662841916084],
[0.848028540611,-0.078459091485,0.524110496044],
[0.812169492245,-0.119078218937,0.571140229702],
[0.817523002625,-0.040675185621,0.574457764626],
[0.782785594463,0.000000000000,0.622291564941],
[0.743495702744,-0.040677066892,0.667502403259],
[0.978530406952,-0.206102609634,0.000000000000],
[0.981483101845,-0.179595902562,0.066604383290],
[0.972369849682,-0.122729487717,0.198580473661],
[0.979426145554,-0.151548892260,0.133256375790],
[0.961188256741,-0.191779986024,0.198337361217],
[0.855336964130,-0.405433833599,0.322524696589],
[0.882836937904,-0.339208841324,0.324863553047],
[0.891741991043,-0.368518292904,0.262660562992],
[0.923879563808,-0.201188594103,0.325529992580],
[0.905831813812,-0.270627111197,0.325928956270],
[0.936049580574,-0.232455179095,0.264151185751],
[0.944432675838,-0.261550396681,0.199094116688],
[0.922681987286,-0.330606490374,0.198386684060],
[0.879344463348,-0.119755484164,0.460881620646],
[0.904838979244,-0.161006405950,0.394136220217],
[0.935130417347,-0.122800238431,0.332341909409],
[0.978851914406,0.041250910610,0.200367778540],
[0.960654795170,0.081501059234,0.265518426895],
[0.978851914406,-0.041250910610,0.200367778540],
[0.960654795170,-0.081501059234,0.265518426895],
[0.941618025303,-0.041301984340,0.334140032530],
[0.941618025303,0.041301984340,0.334140032530],
[0.981483101845,-0.179595902562,-0.066604383290],
[0.979426145554,-0.151548892260,-0.133256375790],
[0.961188256741,-0.191779986024,-0.198337361217],
[0.855336964130,-0.405433833599,-0.322524696589],
[0.882836937904,-0.339208841324,-0.324863553047],
[0.891741991043,-0.368518292904,-0.262660562992],
[0.923879563808,-0.201188594103,-0.325529992580],
[0.905831813812,-0.270627111197,-0.325928956270],
[0.936049580574,-0.232455179095,-0.264151185751],
[0.944432675838,-0.261550396681,-0.199094116688],
[0.922681987286,-0.330606490374,-0.198386684060],
[0.727958440781,0.199331194162,-0.656005680561],
[0.771840512753,0.159612923861,-0.615455865860],
[0.848028540611,0.078459091485,-0.524110496044],
[0.812169492245,0.119078218937,-0.571140229702],
[0.817523002625,0.040675185621,-0.574457764626],
[0.771840512753,-0.159612923861,-0.615455865860],
[0.738886237144,-0.121192574501,-0.662841916084],
[0.848028540611,-0.078459091485,-0.524110496044],
[0.812169492245,-0.119078218937,-0.571140229702],
[0.817523002625,-0.040675185621,-0.574457764626],
[0.782785594463,0.000000000000,-0.622291564941],
[0.743495702744,-0.040677066892,-0.667502403259],
[0.904838979244,-0.161006405950,-0.394136220217],
[0.879344463348,-0.119755484164,-0.460881620646],
[0.884760022163,-0.041299182922,-0.464213401079],
[0.904838979244,0.161006405950,-0.394136220217],
[0.935130417347,0.122800238431,-0.332341909409],
[0.879344463348,0.119755484164,-0.460881620646],
[0.884760022163,0.041299182922,-0.464213401079],
[0.916092038155,0.000000000000,-0.400968074799],
[0.941618025303,0.041301984340,-0.334140032530],
[-0.771840512753,-0.159612923861,0.615455865860],
[-0.812169492245,-0.119078218937,0.571140229702],
[-0.817523002625,-0.040675185621,0.574457764626],
[-0.771840512753,0.159612923861,0.615455865860],
[-0.738886237144,0.121192574501,0.662841916084],
[-0.848028540611,0.078459091485,0.524110496044],
[-0.812169492245,0.119078218937,0.571140229702],
[-0.817523002625,0.040675185621,0.574457764626],
[-0.782785594463,0.000000000000,0.622291564941],
[-0.743495702744,0.040677066892,0.667502403259],
[-0.978530406952,0.206102609634,0.000000000000],
[-0.981483101845,0.179595902562,0.066604383290],
[-0.972369849682,0.122729487717,0.198580473661],
[-0.979426145554,0.151548892260,0.133256375790],
[-0.961188256741,0.191779986024,0.198337361217],
[-0.855336964130,0.405433833599,0.322524696589],
[-0.882836937904,0.339208841324,0.324863553047],
[-0.891741991043,0.368518292904,0.262660562992],
[-0.923879563808,0.201188594103,0.325529992580],
[-0.905831813812,0.270627111197,0.325928956270],
[-0.936049580574,0.232455179095,0.264151185751],
[-0.944432675838,0.261550396681,0.199094116688],
[-0.922681987286,0.330606490374,0.198386684060],
[-0.879344463348,0.119755484164,0.460881620646],
[-0.904838979244,0.161006405950,0.394136220217],
[-0.935130417347,0.122800238431,0.332341909409],
[-0.978851914406,-0.041250910610,0.200367778540],
[-0.960654795170,-0.081501059234,0.265518426895],
[-0.978851914406,0.041250910610,0.200367778540],
[-0.960654795170,0.081501059234,0.265518426895],
[-0.941618025303,0.041301984340,0.334140032530],
[-0.941618025303,-0.041301984340,0.334140032530],
[-0.981483101845,0.179595902562,-0.066604383290],
[-0.979426145554,0.151548892260,-0.133256375790],
[-0.961188256741,0.191779986024,-0.198337361217],
[-0.855336964130,0.405433833599,-0.322524696589],
[-0.882836937904,0.339208841324,-0.324863553047],
[-0.891741991043,0.368518292904,-0.262660562992],
[-0.923879563808,0.201188594103,-0.325529992580],
[-0.905831813812,0.270627111197,-0.325928956270],
[-0.936049580574,0.232455179095,-0.264151185751],
[-0.944432675838,0.261550396681,-0.199094116688],
[-0.922681987286,0.330606490374,-0.198386684060],
[-0.771840512753,-0.159612923861,-0.615455865860],
[-0.848028540611,-0.078459091485,-0.524110496044],
[-0.812169492245,-0.119078218937,-0.571140229702],
[-0.817523002625,-0.040675185621,-0.574457764626],
[-0.771840512753,0.159612923861,-0.615455865860],
[-0.738886237144,0.121192574501,-0.662841916084],
[-0.848028540611,0.078459091485,-0.524110496044],
[-0.812169492245,0.119078218937,-0.571140229702],
[-0.817523002625,0.040675185621,-0.574457764626],
[-0.782785594463,0.000000000000,-0.622291564941],
[-0.743495702744,0.040677066892,-0.667502403259],
[-0.904838979244,0.161006405950,-0.394136220217],
[-0.879344463348,0.119755484164,-0.460881620646],
[-0.884760022163,0.041299182922,-0.464213401079],
[-0.904838979244,-0.161006405950,-0.394136220217],
[-0.935130417347,-0.122800238431,-0.332341909409],
[-0.879344463348,-0.119755484164,-0.460881620646],
[-0.884760022163,-0.041299182922,-0.464213401079],
[-0.916092038155,0.000000000000,-0.400968074799],
[-0.941618025303,-0.041301984340,-0.334140032530],
[0.656005680561,0.727958440781,0.199331194162],
[0.615455865860,0.771840512753,0.159612923861],
[0.571140229702,0.812169492245,0.119078218937],
[0.574457764626,0.817523002625,0.040675185621],
[0.656005680561,0.727958440781,-0.199331194162],
[0.615455865860,0.771840512753,-0.159612923861],
[0.662841916084,0.738886237144,-0.121192574501],
[0.524110496044,0.848028540611,-0.078459091485],
[0.571140229702,0.812169492245,-0.119078218937],
[0.574457764626,0.817523002625,-0.040675185621],
[0.622291564941,0.782785594463,0.000000000000],
[0.667502462864,0.743495821953,-0.040677070618],
[0.000000000000,0.978530406952,-0.206102609634],
[0.066604383290,0.981483101845,-0.179595902562],
[0.198580473661,0.972369849682,-0.122729487717],
[0.133256375790,0.979426145554,-0.151548892260],
[0.198337361217,0.961188256741,-0.191779986024],
[0.324863553047,0.882836937904,-0.339208841324],
[0.262660562992,0.891741991043,-0.368518292904],
[0.325529992580,0.923879563808,-0.201188594103],
[0.325928986073,0.905831813812,-0.270627111197],
[0.264151185751,0.936049580574,-0.232455179095],
[0.199094086885,0.944432556629,-0.261550366879],
[0.198386684060,0.922681987286,-0.330606490374],
[0.460881620646,0.879344463348,-0.119755484164],
[0.394136220217,0.904838919640,-0.161006391048],
[0.332341909409,0.935130417347,-0.122800238431],
[0.200367778540,0.978851914406,0.041250910610],
[0.265518426895,0.960654795170,0.081501059234],
[0.200367778540,0.978851914406,-0.041250910610],
[0.265518426895,0.960654795170,-0.081501059234],
[0.334140032530,0.941618025303,-0.041301984340],
[0.334140032530,0.941618025303,0.041301984340],
[-0.066604383290,0.981483101845,-0.179595902562],
[-0.133256375790,0.979426145554,-0.151548892260],
[-0.198337361217,0.961188256741,-0.191779986024],
[-0.322524696589,0.855336964130,-0.405433833599],
[-0.324863553047,0.882836937904,-0.339208841324],
[-0.262660562992,0.891741991043,-0.368518292904],
[-0.325529992580,0.923879563808,-0.201188594103],
[-0.325928986073,0.905831813812,-0.270627111197],
[-0.264151185751,0.936049580574,-0.232455179095],
[-0.199094086885,0.944432556629,-0.261550366879],
[-0.198386684060,0.922681987286,-0.330606490374],
[-0.656005680561,0.727958440781,0.199331194162],
[-0.615455865860,0.771840512753,0.159612923861],
[-0.524110496044,0.848028540611,0.078459091485],
[-0.571140229702,0.812169492245,0.119078218937],
[-0.574457764626,0.817523002625,0.040675185621],
[-0.656005680561,0.727958440781,-0.199331194162],
[-0.615455865860,0.771840512753,-0.159612923861],
[-0.662841916084,0.738886237144,-0.121192574501],
[-0.524110496044,0.848028540611,-0.078459091485],
[-0.571140229702,0.812169492245,-0.119078218937],
[-0.574457764626,0.817523002625,-0.040675185621],
[-0.622291564941,0.782785594463,0.000000000000],
[-0.667502462864,0.743495821953,-0.040677070618],
[-0.394136220217,0.904838919640,-0.161006391048],
[-0.460881620646,0.879344463348,-0.119755484164],
[-0.464213401079,0.884760022163,-0.041299182922],
[-0.394136220217,0.904838919640,0.161006391048],
[-0.332341909409,0.935130417347,0.122800238431],
[-0.460881620646,0.879344463348,0.119755484164],
[-0.464213401079,0.884760022163,0.041299182922],
[-0.400968074799,0.916092038155,0.000000000000],
[-0.334140032530,0.941618025303,0.041301984340],
[0.000000000000,-0.978530406952,-0.206102609634],
[0.066604383290,-0.981483101845,-0.179595902562],
[0.133256375790,-0.979426145554,-0.151548892260],
[0.198337361217,-0.961188256741,-0.191779986024],
[0.322524696589,-0.855336964130,-0.405433833599],
[0.324863553047,-0.882836937904,-0.339208841324],
[0.262660562992,-0.891741991043,-0.368518292904],
[0.325529992580,-0.923879563808,-0.201188594103],
[0.325928986073,-0.905831813812,-0.270627111197],
[0.264151185751,-0.936049580574,-0.232455179095],
[0.199094086885,-0.944432556629,-0.261550366879],
[0.198386684060,-0.922681987286,-0.330606490374],
[0.656005680561,-0.727958440781,0.199331194162],
[0.615455865860,-0.771840512753,0.159612923861],
[0.524110496044,-0.848028540611,0.078459091485],
[0.571140229702,-0.812169492245,0.119078218937],
[0.574457764626,-0.817523002625,0.040675185621],
[0.656005680561,-0.727958440781,-0.199331194162],
[0.615455865860,-0.771840512753,-0.159612923861],
[0.662841916084,-0.738886237144,-0.121192574501],
[0.524110496044,-0.848028540611,-0.078459091485],
[0.571140229702,-0.812169492245,-0.119078218937],
[0.574457764626,-0.817523002625,-0.040675185621],
[0.622291564941,-0.782785594463,0.000000000000],
[0.667502462864,-0.743495821953,-0.040677070618],
[0.394136220217,-0.904838919640,-0.161006391048],
[0.460881620646,-0.879344463348,-0.119755484164],
[0.464213401079,-0.884760022163,-0.041299182922],
[0.394136220217,-0.904838919640,0.161006391048],
[0.332341909409,-0.935130417347,0.122800238431],
[0.460881620646,-0.879344463348,0.119755484164],
[0.464213401079,-0.884760022163,0.041299182922],
[0.400968074799,-0.916092038155,0.000000000000],
[0.334140032530,-0.941618025303,0.041301984340],
[-0.656005680561,-0.727958440781,0.199331194162],
[-0.615455865860,-0.771840512753,0.159612923861],
[-0.571140229702,-0.812169492245,0.119078218937],
[-0.574457764626,-0.817523002625,0.040675185621],
[-0.656005680561,-0.727958440781,-0.199331194162],
[-0.615455865860,-0.771840512753,-0.159612923861],
[-0.662841916084,-0.738886237144,-0.121192574501],
[-0.524110496044,-0.848028540611,-0.078459091485],
[-0.571140229702,-0.812169492245,-0.119078218937],
[-0.574457764626,-0.817523002625,-0.040675185621],
[-0.622291564941,-0.782785594463,0.000000000000],
[-0.667502462864,-0.743495821953,-0.040677070618],
[-0.066604383290,-0.981483101845,-0.179595902562],
[-0.198580473661,-0.972369849682,-0.122729487717],
[-0.133256375790,-0.979426145554,-0.151548892260],
[-0.198337361217,-0.961188256741,-0.191779986024],
[-0.322524696589,-0.855336964130,-0.405433833599],
[-0.324863553047,-0.882836937904,-0.339208841324],
[-0.262660562992,-0.891741991043,-0.368518292904],
[-0.325529992580,-0.923879563808,-0.201188594103],
[-0.325928986073,-0.905831813812,-0.270627111197],
[-0.264151185751,-0.936049580574,-0.232455179095],
[-0.199094086885,-0.944432556629,-0.261550366879],
[-0.198386684060,-0.922681987286,-0.330606490374],
[-0.460881620646,-0.879344463348,-0.119755484164],
[-0.394136220217,-0.904838919640,-0.161006391048],
[-0.332341909409,-0.935130417347,-0.122800238431],
[-0.200367778540,-0.978851914406,0.041250910610],
[-0.265518426895,-0.960654795170,0.081501059234],
[-0.200367778540,-0.978851914406,-0.041250910610],
[-0.265518426895,-0.960654795170,-0.081501059234],
[-0.334140032530,-0.941618025303,-0.041301984340],
[-0.334140032530,-0.941618025303,0.041301984340],
[0.446976989508,0.366027295589,0.816232562065],
[0.486240506172,0.408285975456,0.772575497627],
[0.553371787071,0.386730432510,0.737712204456],
[0.705236136913,0.267381101847,0.656619668007],
[0.672319412231,0.228899985552,0.703982532024],
[0.649448037148,0.399769037962,0.646839916706],
[0.678913056850,0.334691524506,0.653497219086],
[0.619185566902,0.361591756344,0.697037041187],
[0.583691358566,0.322140991688,0.745338499546],
[0.610925853252,0.255179554224,0.749435067177],
[0.656619668007,0.705236136913,0.267381101847],
[0.646839916706,0.649448037148,0.399769037962],
[0.653497219086,0.678913056850,0.334691524506],
[0.697037041187,0.619185566902,0.361591756344],
[0.816232562065,0.446976989508,0.366027295589],
[0.825175166130,0.476225703955,0.303801119328],
[0.725299060345,0.522498548031,0.448259413242],
[0.772575497627,0.486240506172,0.408285975456],
[0.737712204456,0.553371787071,0.386730432510],
[0.745338499546,0.583691358566,0.322140991688],
[0.790112197399,0.545108973980,0.280319362879],
[0.678976714611,0.443957388401,0.584715723991],
[0.704471170902,0.485208272934,0.517970383167],
[0.669612050056,0.552418172359,0.496441334486],
[0.517970383167,0.704471170902,0.485208272934],
[0.496441334486,0.669612050056,0.552418172359],
[0.584715723991,0.678976714611,0.443957388401],
[0.628312826157,0.619241595268,0.470917046070],
[0.607478022575,0.581951975822,0.540650010109],
[0.540650010109,0.607478022575,0.581951975822],
[0.656619668007,0.705236136913,-0.267381101847],
[0.653497219086,0.678913056850,-0.334691524506],
[0.697037041187,0.619185566902,-0.361591756344],
[0.816232562065,0.446976989508,-0.366027295589],
[0.825175166130,0.476225703955,-0.303801119328],
[0.725299060345,0.522498548031,-0.448259413242],
[0.772575497627,0.486240506172,-0.408285975456],
[0.737712204456,0.553371787071,-0.386730432510],
[0.745338499546,0.583691358566,-0.322140991688],
[0.790112197399,0.545108973980,-0.280319362879],
[0.446976989508,0.366027295589,-0.816232562065],
[0.522498548031,0.448259413242,-0.725299060345],
[0.486240506172,0.408285975456,-0.772575497627],
[0.553371787071,0.386730432510,-0.737712204456],
[0.705236136913,0.267381101847,-0.656619668007],
[0.672319412231,0.228899985552,-0.703982532024],
[0.649448037148,0.399769037962,-0.646839916706],
[0.678913056850,0.334691524506,-0.653497219086],
[0.619185566902,0.361591756344,-0.697037041187],
[0.583691358566,0.322140991688,-0.745338499546],
[0.610925853252,0.255179554224,-0.749435067177],
[0.704471170902,0.485208272934,-0.517970383167],
[0.678976714611,0.443957388401,-0.584715723991],
[0.619241595268,0.470917046070,-0.628312826157],
[0.443957388401,0.584715723991,-0.678976714611],
[0.470917046070,0.628312826157,-0.619241595268],
[0.485208272934,0.517970383167,-0.704471170902],
[0.552418172359,0.496441334486,-0.669612050056],
[0.581951975822,0.540650010109,-0.607478022575],
[0.540650010109,0.607478022575,-0.581951975822],
[0.267381101847,-0.656619668007,0.705236136913],
[0.334691524506,-0.653497219086,0.678913056850],
[0.361591756344,-0.697037041187,0.619185566902],
[0.366027295589,-0.816232562065,0.446976989508],
[0.303801119328,-0.825175166130,0.476225703955],
[0.448259413242,-0.725299060345,0.522498548031],
[0.408285975456,-0.772575497627,0.486240506172],
[0.386730432510,-0.737712204456,0.553371787071],
[0.322140991688,-0.745338499546,0.583691358566],
[0.280319362879,-0.790112078190,0.545108973980],
[0.816232562065,-0.446976989508,0.366027295589],
[0.725299060345,-0.522498548031,0.448259413242],
[0.772575497627,-0.486240506172,0.408285975456],
[0.737712204456,-0.553371787071,0.386730432510],
[0.656619668007,-0.705236136913,0.267381101847],
[0.703982532024,-0.672319412231,0.228899985552],
[0.646839916706,-0.649448037148,0.399769037962],
[0.653497219086,-0.678913056850,0.334691524506],
[0.697037041187,-0.619185566902,0.361591756344],
[0.745338499546,-0.583691358566,0.322140991688],
[0.749435067177,-0.610925912857,0.255179554224],
[0.517970383167,-0.704471170902,0.485208272934],
[0.584715723991,-0.678976714611,0.443957388401],
[0.628312826157,-0.619241595268,0.470917046070],
[0.678976714611,-0.443957388401,0.584715723991],
[0.619241595268,-0.470917046070,0.628312826157],
[0.704471170902,-0.485208272934,0.517970383167],
[0.669612050056,-0.552418172359,0.496441334486],
[0.607478022575,-0.581951975822,0.540650010109],
[0.581951975822,-0.540650010109,0.607478022575],
[0.816232562065,-0.446976989508,-0.366027295589],
[0.772575497627,-0.486240506172,-0.408285975456],
[0.737712204456,-0.553371787071,-0.386730432510],
[0.656619668007,-0.705236136913,-0.267381101847],
[0.703982532024,-0.672319412231,-0.228899985552],
[0.646839916706,-0.649448037148,-0.399769037962],
[0.653497219086,-0.678913056850,-0.334691524506],
[0.697037041187,-0.619185566902,-0.361591756344],
[0.745338499546,-0.583691358566,-0.322140991688],
[0.749435067177,-0.610925912857,-0.255179554224],
[0.267381101847,-0.656619668007,-0.705236136913],
[0.399769037962,-0.646839916706,-0.649448037148],
[0.334691524506,-0.653497219086,-0.678913056850],
[0.361591756344,-0.697037041187,-0.619185566902],
[0.366027295589,-0.816232562065,-0.446976989508],
[0.303801119328,-0.825175166130,-0.476225703955],
[0.448259413242,-0.725299060345,-0.522498548031],
[0.408285975456,-0.772575497627,-0.486240506172],
[0.386730432510,-0.737712204456,-0.553371787071],
[0.322140991688,-0.745338499546,-0.583691358566],
[0.280319362879,-0.790112078190,-0.545108973980],
[0.584715723991,-0.678976714611,-0.443957388401],
[0.517970383167,-0.704471170902,-0.485208272934],
[0.496441334486,-0.669612050056,-0.552418172359],
[0.485208272934,-0.517970383167,-0.704471170902],
[0.552418172359,-0.496441334486,-0.669612050056],
[0.443957388401,-0.584715723991,-0.678976714611],
[0.470917046070,-0.628312826157,-0.619241595268],
[0.540650010109,-0.607478022575,-0.581951975822],
[0.581951975822,-0.540650010109,-0.607478022575],
[-0.267381101847,0.656619668007,0.705236136913],
[-0.334691524506,0.653497219086,0.678913056850],
[-0.361591756344,0.697037041187,0.619185566902],
[-0.366027295589,0.816232562065,0.446976989508],
[-0.303801119328,0.825175166130,0.476225703955],
[-0.448259413242,0.725299060345,0.522498548031],
[-0.408285975456,0.772575497627,0.486240506172],
[-0.386730432510,0.737712204456,0.553371787071],
[-0.322140991688,0.745338499546,0.583691358566],
[-0.280319362879,0.790112078190,0.545108973980],
[-0.816232562065,0.446976989508,0.366027295589],
[-0.725299060345,0.522498548031,0.448259413242],
[-0.772575497627,0.486240506172,0.408285975456],
[-0.737712204456,0.553371787071,0.386730432510],
[-0.656619668007,0.705236136913,0.267381101847],
[-0.703982532024,0.672319412231,0.228899985552],
[-0.646839916706,0.649448037148,0.399769037962],
[-0.653497219086,0.678913056850,0.334691524506],
[-0.697037041187,0.619185566902,0.361591756344],
[-0.745338499546,0.583691358566,0.322140991688],
[-0.749435067177,0.610925912857,0.255179554224],
[-0.517970383167,0.704471170902,0.485208272934],
[-0.584715723991,0.678976714611,0.443957388401],
[-0.628312826157,0.619241595268,0.470917046070],
[-0.678976714611,0.443957388401,0.584715723991],
[-0.619241595268,0.470917046070,0.628312826157],
[-0.704471170902,0.485208272934,0.517970383167],
[-0.669612050056,0.552418172359,0.496441334486],
[-0.607478022575,0.581951975822,0.540650010109],
[-0.581951975822,0.540650010109,0.607478022575],
[-0.816232562065,0.446976989508,-0.366027295589],
[-0.772575497627,0.486240506172,-0.408285975456],
[-0.737712204456,0.553371787071,-0.386730432510],
[-0.656619668007,0.705236136913,-0.267381101847],
[-0.703982532024,0.672319412231,-0.228899985552],
[-0.646839916706,0.649448037148,-0.399769037962],
[-0.653497219086,0.678913056850,-0.334691524506],
[-0.697037041187,0.619185566902,-0.361591756344],
[-0.745338499546,0.583691358566,-0.322140991688],
[-0.749435067177,0.610925912857,-0.255179554224],
[-0.267381101847,0.656619668007,-0.705236136913],
[-0.399769037962,0.646839916706,-0.649448037148],
[-0.334691524506,0.653497219086,-0.678913056850],
[-0.361591756344,0.697037041187,-0.619185566902],
[-0.366027295589,0.816232562065,-0.446976989508],
[-0.303801119328,0.825175166130,-0.476225703955],
[-0.448259413242,0.725299060345,-0.522498548031],
[-0.408285975456,0.772575497627,-0.486240506172],
[-0.386730432510,0.737712204456,-0.553371787071],
[-0.322140991688,0.745338499546,-0.583691358566],
[-0.280319362879,0.790112078190,-0.545108973980],
[-0.584715723991,0.678976714611,-0.443957388401],
[-0.517970383167,0.704471170902,-0.485208272934],
[-0.496441334486,0.669612050056,-0.552418172359],
[-0.485208272934,0.517970383167,-0.704471170902],
[-0.552418172359,0.496441334486,-0.669612050056],
[-0.443957388401,0.584715723991,-0.678976714611],
[-0.470917046070,0.628312826157,-0.619241595268],
[-0.540650010109,0.607478022575,-0.581951975822],
[-0.581951975822,0.540650010109,-0.607478022575],
[-0.816232562065,-0.446976989508,0.366027295589],
[-0.772575497627,-0.486240506172,0.408285975456],
[-0.737712204456,-0.553371787071,0.386730432510],
[-0.656619668007,-0.705236136913,0.267381101847],
[-0.703982532024,-0.672319412231,0.228899985552],
[-0.646839916706,-0.649448037148,0.399769037962],
[-0.653497219086,-0.678913056850,0.334691524506],
[-0.697037041187,-0.619185566902,0.361591756344],
[-0.745338499546,-0.583691358566,0.322140991688],
[-0.749435067177,-0.610925912857,0.255179554224],
[-0.267381101847,-0.656619668007,0.705236136913],
[-0.399769037962,-0.646839916706,0.649448037148],
[-0.334691524506,-0.653497219086,0.678913056850],
[-0.361591756344,-0.697037041187,0.619185566902],
[-0.366027295589,-0.816232562065,0.446976989508],
[-0.303801119328,-0.825175166130,0.476225703955],
[-0.448259413242,-0.725299060345,0.522498548031],
[-0.408285975456,-0.772575497627,0.486240506172],
[-0.386730432510,-0.737712204456,0.553371787071],
[-0.322140991688,-0.745338499546,0.583691358566],
[-0.280319362879,-0.790112078190,0.545108973980],
[-0.584715723991,-0.678976714611,0.443957388401],
[-0.517970383167,-0.704471170902,0.485208272934],
[-0.496441334486,-0.669612050056,0.552418172359],
[-0.485208272934,-0.517970383167,0.704471170902],
[-0.552418172359,-0.496441334486,0.669612050056],
[-0.443957388401,-0.584715723991,0.678976714611],
[-0.470917046070,-0.628312826157,0.619241595268],
[-0.540650010109,-0.607478022575,0.581951975822],
[-0.581951975822,-0.540650010109,0.607478022575],
[-0.267381101847,-0.656619668007,-0.705236136913],
[-0.334691524506,-0.653497219086,-0.678913056850],
[-0.361591756344,-0.697037041187,-0.619185566902],
[-0.366027295589,-0.816232562065,-0.446976989508],
[-0.303801119328,-0.825175166130,-0.476225703955],
[-0.448259413242,-0.725299060345,-0.522498548031],
[-0.408285975456,-0.772575497627,-0.486240506172],
[-0.386730432510,-0.737712204456,-0.553371787071],
[-0.322140991688,-0.745338499546,-0.583691358566],
[-0.280319362879,-0.790112078190,-0.545108973980],
[-0.816232562065,-0.446976989508,-0.366027295589],
[-0.725299060345,-0.522498548031,-0.448259413242],
[-0.772575497627,-0.486240506172,-0.408285975456],
[-0.737712204456,-0.553371787071,-0.386730432510],
[-0.656619668007,-0.705236136913,-0.267381101847],
[-0.703982532024,-0.672319412231,-0.228899985552],
[-0.646839916706,-0.649448037148,-0.399769037962],
[-0.653497219086,-0.678913056850,-0.334691524506],
[-0.697037041187,-0.619185566902,-0.361591756344],
[-0.745338499546,-0.583691358566,-0.322140991688],
[-0.749435067177,-0.610925912857,-0.255179554224],
[-0.517970383167,-0.704471170902,-0.485208272934],
[-0.584715723991,-0.678976714611,-0.443957388401],
[-0.628312826157,-0.619241595268,-0.470917046070],
[-0.678976714611,-0.443957388401,-0.584715723991],
[-0.619241595268,-0.470917046070,-0.628312826157],
[-0.704471170902,-0.485208272934,-0.517970383167],
[-0.669612050056,-0.552418172359,-0.496441334486],
[-0.607478022575,-0.581951975822,-0.540650010109],
[-0.581951975822,-0.540650010109,-0.607478022575]
];

const AREAS: readonly number[] = [
1.047197699547,1.047197699547,1.047197699547,1.047197699547,1.047197699547,1.047197699547,1.047197699547,1.047197699547,1.047197699547,1.047197699547,1.047197699547,1.047197699547,0.249147176743,0.249147176743,0.249147176743,0.249147176743,0.249147176743,0.249147176743,0.249147176743,0.249147176743,0.249147176743,0.249147176743,0.249147176743,0.249147176743,0.319220244884,0.319220244884,0.319220244884,0.319220244884,0.319220244884,0.319220244884,0.319220244884,0.319220244884,0.319220244884,0.319220244884,0.319220244884,0.319220244884,0.319220244884,0.319220244884,0.319220244884,0.319220244884,0.319220244884,0.319220244884,0.319220244884,0.319220244884,0.319220244884,0.319220244884,0.319220244884,0.319220244884,0.319220244884,0.319220244884,0.319220244884,0.319220244884,0.319220244884,0.319220244884,0.061128523201,0.061128523201,0.061128523201,0.061128523201,0.061128441244,0.061128441244,0.061128441244,0.061128441244,0.061128281057,0.061128284782,0.061128284782,0.061128284782,0.079041972756,0.079042211175,0.079042129219,0.079041972756,0.079042211175,0.079042129219,0.079041972756,0.079042211175,0.079041965306,0.079042211175,0.079042047262,0.079042211175,0.079042129219,0.079042054713,0.079042211175,0.079042054713,0.079042211175,0.079042129219,0.079042054713,0.079042211175,0.079041972756,0.079042211175,0.079042129219,0.079041972756,0.079042211175,0.079042129219,0.079041972756,0.079042211175,0.079041972756,0.079042211175,0.074927665293,0.082765117288,0.074927583337,0.082765117288,0.074927583337,0.074927583337,0.082765117288,0.074927583337,0.074927665293,0.082765117288,0.074927665293,0.082765117288,0.074927665293,0.082765117288,0.074927583337,0.074927665293,0.082765117288,0.074927665293,0.082765117288,0.074927583337,0.074927583337,0.082765117288,0.074927501380,0.082765117288,0.074927501380,0.074927501380,0.082765117288,0.074927501380,0.074927583337,0.082765117288,0.074927501380,0.082764878869,0.074927501380,0.082765191793,0.074927501380,0.082765191793,0.074927583337,0.074927501380,0.082764953375,0.074927583337,0.082765191793,0.074927583337,0.074927501380,0.082764953375,0.074927665293,0.074927501380,0.082764953375,0.074927665293,0.074927583337,0.082765191793,0.074927583337,0.082765117288,0.074927583337,0.074927583337,0.082765117288,0.082765117288,0.074927501380,0.082765042782,0.074927419424,0.074927583337,0.082765117288,0.082765042782,0.074927419424,0.074927501380,0.082765117288,0.074927583337,0.082765117288,0.074927501380,0.082765117288,0.074927665293,0.082765117288,0.074927583337,0.082765117288,0.074927665293,0.074927583337,0.082765117288,0.082765117288,0.074927665293,0.082765117288,0.074927583337,0.082765117288,0.074927665293,0.082765117288,0.074927665293,0.082765191793,0.074927657843,0.074927501380,0.082765117288,0.082765117288,0.074927583337,0.074927583337,0.082765117288,0.074927583337,0.074927501380,0.082765117288,0.074927583337,0.074927583337,0.082765117288,0.074927583337,0.074927665293,0.082765191793,0.074927657843,0.082765117288,0.074927501380,0.082764953375,0.082764878869,0.082765191793,0.082765191793,0.082765191793,0.082765191793,0.082764878869,0.082764878869,0.082765191793,0.082765191793,0.082764878869,0.082764878869,0.082764878869,0.082764878869,0.082765191793,0.082765191793,0.015205290169,0.015205290169,0.015205290169,0.015205290169,0.015205369331,0.015205370262,0.015205369331,0.015205369331,0.015205291100,0.015205290169,0.015205290169,0.015205290169,0.019704040140,0.019704040140,0.019704040140,0.019704040140,0.019704040140,0.019704040140,0.019704040140,0.019704040140,0.019704040140,0.019704040140,0.019704040140,0.019704120234,0.019703879952,0.019704040140,0.019704120234,0.019704038277,0.019704120234,0.019703879952,0.019704040140,0.019704120234,0.019704038277,0.019704120234,0.019704356790,0.019704040140,0.019704118371,0.019704358652,0.019704040140,0.019704118371,0.019704040140,0.019704118371,0.018683053553,0.020632123575,0.018683211878,0.020631887019,0.018683131784,0.018683210015,0.020631887019,0.018683131784,0.018683053553,0.020632123575,0.018683053553,0.020631887019,0.018683211878,0.020631726831,0.018683053553,0.018683053553,0.020631887019,0.018683211878,0.020631726831,0.018683053553,0.018682971597,0.020631885156,0.018683211878,0.020631806925,0.018682813272,0.018683210015,0.020631806925,0.018682813272,0.018682971597,0.020631885156,0.018682971597,0.020631887019,0.018682813272,0.020631967112,0.018683290109,0.020631726831,0.018683053553,0.018682893366,0.020631728694,0.018683131784,0.020631726831,0.018683053553,0.018682893366,0.020631728694,0.018683053553,0.018682893366,0.020631728694,0.018683053553,0.018683131784,0.020631726831,0.018683053553,0.020631646737,0.018683291972,0.018683211878,0.020631887019,0.020632123575,0.018683291972,0.020631648600,0.018682971597,0.018683211878,0.020632123575,0.020631648600,0.018682971597,0.018682971597,0.020631646737,0.018683291972,0.020631887019,0.018682893366,0.020631724969,0.018683211878,0.020631726831,0.018683053553,0.020631885156,0.018683053553,0.018683053553,0.020631726831,0.020631724969,0.018683211878,0.020631726831,0.018683053553,0.020631885156,0.018683053553,0.020631726831,0.018683131784,0.020631805062,0.018683053553,0.018683211878,0.020631806925,0.020631887019,0.018682971597,0.018683053553,0.020631806925,0.018683131784,0.018683211878,0.020631887019,0.018682971597,0.018683053553,0.020631806925,0.018683131784,0.018683131784,0.020631805062,0.018683053553,0.020631806925,0.018682813272,0.020631724969,0.020631806925,0.020631805062,0.020631726831,0.020631965250,0.020631806925,0.020631805062,0.020631887019,0.020631965250,0.020631806925,0.020631805062,0.020631887019,0.020631805062,0.020631887019,0.020631965250,0.020631806925,0.018348075449,0.018854238093,0.018348312005,0.018854077905,0.018348313868,0.018348312005,0.018854077905,0.018348313868,0.018348075449,0.018854238093,0.018348153681,0.018854157999,0.018348312005,0.018854077905,0.018348153681,0.018348075449,0.018854157999,0.018348312005,0.018854077905,0.018348153681,0.018347915262,0.018854077905,0.018348153681,0.018853917718,0.018347915262,0.018348153681,0.018853917718,0.018347915262,0.018347915262,0.018854077905,0.018347835168,0.018853759393,0.018347993493,0.018853917718,0.018348075449,0.018854156137,0.018348153681,0.018347915262,0.018853839487,0.018348312005,0.018854156137,0.018348153681,0.018347915262,0.018853839487,0.018347995356,0.018347915262,0.018853839487,0.018347995356,0.018348312005,0.018854156137,0.018348153681,0.018854157999,0.018347995356,0.018348233774,0.018854077905,0.020390447229,0.022806024179,0.020390765741,0.018854077905,0.018347995356,0.018854156137,0.018347835168,0.020390607417,0.022805944085,0.020390367135,0.018348231912,0.018854077905,0.018854156137,0.018347835168,0.020390607417,0.022805944085,0.020390367135,0.018347835168,0.018854157999,0.018347995356,0.018854077905,0.020390447229,0.022806024179,0.020390765741,0.018347915262,0.018853919581,0.018348233774,0.018854077905,0.018348153681,0.020390367135,0.022805944085,0.020390527323,0.018853997812,0.018347993493,0.018348153681,0.018853919581,0.020390527323,0.022805944085,0.020390367135,0.018853919581,0.018348233774,0.018854077905,0.018348153681,0.020390367135,0.022805944085,0.020390527323,0.018853997812,0.018347993493,0.018853919581,0.020390527323,0.022805944085,0.020390367135,0.018347995356,0.018853839487,0.018347915262,0.018348153681,0.018853917718,0.020390447229,0.022805865854,0.020390527323,0.018853997812,0.018347915262,0.018347993493,0.018853919581,0.018347993493,0.020390765741,0.022805944085,0.020390685648,0.018348153681,0.018853997812,0.018347915262,0.018347993493,0.018853919581,0.018347993493,0.020390765741,0.022805944085,0.020390685648,0.018347915262,0.018853839487,0.018347915262,0.018853917718,0.018347915262,0.020390447229,0.022805865854,0.020390527323,0.018853759393,0.018853999674,0.020390447229,0.022805944085,0.020390765741,0.018853999674,0.018854156137,0.020390607417,0.022805944085,0.020390527323,0.018853917718,0.018853999674,0.020390685648,0.022805944085,0.020390367135,0.018853839487,0.018853759393,0.020390527323,0.022805944085,0.020390607417,0.018853917718,0.018853999674,0.020390685648,0.022805944085,0.020390367135,0.018853839487,0.018853759393,0.020390527323,0.022805944085,0.020390607417,0.018853839487,0.018853759393,0.020390527323,0.022805944085,0.020390607417,0.018853917718,0.018853999674,0.020390685648,0.022805944085,0.020390367135,0.018557962030,0.018941814080,0.018558120355,0.018941735849,0.020390605554,0.018941657618,0.018557962030,0.018941815943,0.020390845835,0.018558120355,0.018941657618,0.018557962030,0.018941815943,0.020390845835,0.018557962030,0.018941814080,0.018941735849,0.020390605554,0.018558120355,0.018941577524,0.018558040261,0.018941657618,0.020390525460,0.018941577524,0.018557962030,0.018941657618,0.020390765741,0.018558120355,0.018941577524,0.018558040261,0.018941657618,0.020390525460,0.018941577524,0.018557962030,0.018941657618,0.020390765741,0.018557881936,0.018941735849,0.018558120355,0.018941735849,0.020390765741,0.018941735849,0.018557962030,0.018941577524,0.020390763879,0.018558120355,0.018941735849,0.018557962030,0.018941577524,0.020390763879,0.018557881936,0.018941735849,0.018941735849,0.020390765741,0.018557962030,0.018941655755,0.018941417336,0.020390447229,0.018557962030,0.018941417336,0.018558040261,0.018941735849,0.020390685648,0.018941577524,0.018558040261,0.018941657618,0.020390605554,0.018557962030,0.018941577524,0.018941497430,0.020390447229,0.018557962030,0.018941577524,0.018558040261,0.018941657618,0.020390605554,0.018557962030,0.018941577524,0.018557962030,0.018941497430,0.020390447229,0.018557962030,0.018941577524,0.018557962030,0.018941497430,0.020390447229,0.018557962030,0.018941577524,0.018558040261,0.018941657618,0.020390605554,0.018941497430,0.018558042124,0.018941655755,0.020390527323,0.018558120355,0.018941657618,0.020390367135,0.018941815943,0.020390765741,0.022805865854,0.022805944085,0.018941655755,0.018941735849,0.020390765741,0.018558042124,0.018941655755,0.020390607417,0.018557962030,0.018941497430,0.020390447229,0.022806024179,0.022805944085,0.018558120355,0.018941655755,0.018941735849,0.020390765741,0.018941655755,0.020390607417,0.018557962030,0.018941497430,0.020390447229,0.022806024179,0.022805944085,0.018557962030,0.018941497430,0.018558042124,0.018941655755,0.020390527323,0.018941657618,0.020390367135,0.018941815943,0.020390765741,0.022805865854,0.022805944085,0.018557962030,0.018941417336,0.018941497430,0.020390605554,0.018558040261,0.018941577524,0.020390367135,0.018557962030,0.018941657618,0.020390685648,0.022805944085,0.022805944085,0.018941575661,0.018558120355,0.018941497430,0.020390525460,0.018558042124,0.018941497430,0.020390685648,0.018941417336,0.020390367135,0.022805944085,0.022806024179,0.018941417336,0.018941497430,0.020390605554,0.018558040261,0.018941577524,0.020390367135,0.018557962030,0.018941657618,0.020390685648,0.022805944085,0.022805944085,0.018941575661,0.018558120355,0.018941497430,0.020390525460,0.018941497430,0.020390685648,0.018941417336,0.020390367135,0.022805944085,0.022806024179,0.018558120355,0.018941655755,0.018558042124,0.018941577524,0.020390605554,0.018558120355,0.018941735849,0.020390685648,0.018941577524,0.020390685648,0.022806024179,0.022805944085,0.018941655755,0.018557881936,0.018941655755,0.020390605554,0.018558042124,0.018941577524,0.020390683785,0.018558120355,0.018941655755,0.020390527323,0.022805944085,0.022806104273,0.018558120355,0.018941655755,0.018557881936,0.018941655755,0.020390605554,0.018558042124,0.018941577524,0.020390683785,0.018558120355,0.018941655755,0.020390527323,0.022805944085,0.022806104273,0.018558120355,0.018941655755,0.018558042124,0.018941577524,0.020390605554,0.018941735849,0.020390685648,0.018557962030,0.018941577524,0.020390685648,0.022806024179,0.022805944085,0.018941417336,0.018941497430,0.020390605554,0.018941657618,0.020390685648,0.018941657618,0.020390527323,0.022805944085,0.022805944085,0.018941657618,0.018941577524,0.020390525460,0.018941577524,0.020390367135,0.018941657618,0.020390605554,0.022805944085,0.022805944085,0.018941815943,0.018941497430,0.020390527323,0.018941577524,0.020390525460,0.018941657618,0.020390605554,0.022805944085,0.022805944085,0.018941577524,0.018941577524,0.020390685648,0.018941655755,0.020390763879,0.018941417336,0.020390447229,0.022805944085,0.022805944085,0.018941815943,0.018941497430,0.020390527323,0.018941577524,0.020390525460,0.018941657618,0.020390605554,0.022805944085,0.022805944085,0.018941577524,0.018941577524,0.020390685648,0.018941655755,0.020390763879,0.018941417336,0.020390447229,0.022805944085,0.022805944085,0.018941577524,0.018941577524,0.020390685648,0.018941655755,0.020390763879,0.018941417336,0.020390447229,0.022805944085,0.022805944085,0.018941815943,0.018941497430,0.020390527323,0.018941577524,0.020390525460,0.018941657618,0.020390605554,0.022805944085,0.022805944085,0.003796245903,0.003796245903,0.003796245903,0.003796245903,0.003796405159,0.003796405159,0.003796405159,0.003796405159,0.003796325531,0.003796325531,0.003796325531,0.003796325531,0.004922326189,0.004922405351,0.004922564607,0.004922326654,0.004922405351,0.004922564607,0.004922326654,0.004922405817,0.004922325723,0.004922405351,0.004922325723,0.004922326189,0.004922564607,0.004922325723,0.004922326189,0.004922326189,0.004922326189,0.004922564607,0.004922325723,0.004922326189,0.004922484979,0.004922405817,0.004922405351,0.004922484979,0.004922405817,0.004922405817,0.004922484979,0.004922405817,0.004922484979,0.004922405817,0.004667695146,0.005154148676,0.004667774774,0.005154069513,0.004667695146,0.004667774774,0.005154069513,0.004667695146,0.004667695146,0.005154148676,0.004667695146,0.005154148676,0.004667695146,0.005154148676,0.004667615518,0.004667695146,0.005154148676,0.004667695146,0.005154148676,0.004667615518,0.004667536356,0.005154148676,0.004667695146,0.005154068582,0.004667695146,0.004667695612,0.005154068582,0.004667695146,0.004667536356,0.005154148676,0.004667774774,0.005154307466,0.004667695146,0.005154148676,0.004667695146,0.005154068582,0.004667536356,0.004667695146,0.005154227838,0.004667695146,0.005154068582,0.004667536356,0.004667695146,0.005154227838,0.004667695146,0.004667694680,0.005154227838,0.004667695146,0.004667695146,0.005154068582,0.004667536356,0.005154148676,0.004667695146,0.004667774774,0.005154069513,0.005154148676,0.004667695146,0.005154148676,0.004667774774,0.004667774774,0.005154148676,0.005154148676,0.004667774774,0.004667774774,0.005154148676,0.004667695146,0.005154069513,0.004667695146,0.005154148676,0.004667695146,0.005154148676,0.004667615518,0.005154148676,0.004667695146,0.004667536356,0.005154148676,0.005154148676,0.004667695146,0.005154148676,0.004667615518,0.005154148676,0.004667695146,0.005154148676,0.004667536356,0.005154148676,0.004667535890,0.004667695612,0.005154068582,0.005154148676,0.004667536356,0.004667536356,0.005154148676,0.004667535890,0.004667695146,0.005154148676,0.004667536356,0.004667536356,0.005154148676,0.004667535890,0.004667536356,0.005154148676,0.004667536356,0.005154068582,0.004667695146,0.005154227838,0.005154228304,0.005154227838,0.005154068582,0.005154148676,0.005154227838,0.005154227838,0.005154307466,0.005154148676,0.005154227838,0.005154227838,0.005154307466,0.005154227838,0.005154307466,0.005154148676,0.005154227838,0.004583851434,0.004710292444,0.004583851434,0.004710133653,0.004583851434,0.004583851434,0.004710133653,0.004583851434,0.004583851434,0.004710292444,0.004584010225,0.004710292444,0.004583851434,0.004710213281,0.004583931062,0.004584010225,0.004710292444,0.004583851434,0.004710213281,0.004583931062,0.004583851434,0.004710451700,0.004583931062,0.004710133653,0.004584010225,0.004583931062,0.004710133653,0.004584010225,0.004583851434,0.004710451700,0.004584010225,0.004710213281,0.004584010225,0.004710372072,0.004583930597,0.004710372072,0.004584010225,0.004584010225,0.004710213281,0.004583851434,0.004710372072,0.004584010225,0.004584010225,0.004710213281,0.004583851434,0.004584010225,0.004710213281,0.004583851434,0.004583851434,0.004710372072,0.004584010225,0.004710292444,0.004583931062,0.004583851434,0.004710133653,0.005093907937,0.005696789362,0.005094067194,0.004710292444,0.004583931062,0.004710292444,0.004584010225,0.005093907937,0.005696788896,0.005093828309,0.004583851434,0.004710292444,0.004710292444,0.004584010225,0.005093907937,0.005696788896,0.005093828309,0.004584010225,0.004710292444,0.004583931062,0.004710133653,0.005093907937,0.005696789362,0.005094067194,0.004584010225,0.004710292444,0.004583851434,0.004710213281,0.004583931062,0.005093828775,0.005696789362,0.005094146356,0.004710292444,0.004584010225,0.004584010225,0.004710292444,0.005093749147,0.005696788896,0.005093749147,0.004710292444,0.004583851434,0.004710213281,0.004583931062,0.005093828775,0.005696789362,0.005094146356,0.004710292444,0.004584010225,0.004710292444,0.005093749147,0.005696788896,0.005093749147,0.004584010225,0.004710292444,0.004584089853,0.004583930597,0.004710133653,0.005093828775,0.005696868990,0.005094066728,0.004710451700,0.004583851434,0.004584089853,0.004710292444,0.004584010225,0.005093669984,0.005696630105,0.005093669519,0.004583931062,0.004710451700,0.004583851434,0.004584089853,0.004710292444,0.004584010225,0.005093669984,0.005696630105,0.005093669519,0.004584010225,0.004710292444,0.004584089853,0.004710133653,0.004584010225,0.005093828775,0.005696868990,0.005094066728,0.004710213281,0.004710292444,0.005093907937,0.005697106943,0.005093828775,0.004710213281,0.004710372072,0.005093987100,0.005697107408,0.005093987565,0.004710372072,0.004710213281,0.005093987565,0.005697027780,0.005093828309,0.004710292444,0.004710213281,0.005093987565,0.005697027780,0.005093908403,0.004710372072,0.004710213281,0.005093987565,0.005697027780,0.005093828309,0.004710292444,0.004710213281,0.005093987565,0.005697027780,0.005093908403,0.004710292444,0.004710213281,0.005093987565,0.005697027780,0.005093908403,0.004710372072,0.004710213281,0.005093987565,0.005697027780,0.005093828309,0.004636303522,0.004732067697,0.004636621103,0.004732226953,0.005093907937,0.004732226953,0.004636144731,0.004732147325,0.005094067194,0.004636621568,0.004732226953,0.004636144731,0.004732147325,0.005094067194,0.004636303522,0.004732067697,0.004732226953,0.005093907937,0.004636303522,0.004731988534,0.004636462312,0.004732306581,0.005093749613,0.004732226953,0.004636223894,0.004732068162,0.005094146822,0.004636303522,0.004731988534,0.004636462312,0.004732306581,0.005093749613,0.004732226953,0.004636223894,0.004732068162,0.005094146822,0.004636462312,0.004732067697,0.004636462312,0.004732306581,0.005093669519,0.004732386209,0.004636303522,0.004731988534,0.005093987565,0.004636462312,0.004732386209,0.004636303522,0.004731988534,0.005093987565,0.004636462312,0.004732067697,0.004732306581,0.005093669519,0.004636382684,0.004732386209,0.004732306581,0.005093907937,0.004636303522,0.004732147790,0.004636303522,0.004732386209,0.005093988031,0.004732067697,0.004636462312,0.004731909372,0.005093988031,0.004636462312,0.004732067697,0.004732306581,0.005093907937,0.004636144266,0.004732067697,0.004636462312,0.004731909372,0.005093988031,0.004636462312,0.004732067697,0.004636303522,0.004732306581,0.005093907937,0.004636462312,0.004732067697,0.004636303522,0.004732306581,0.005093907937,0.004636144266,0.004732067697,0.004636462312,0.004731909372,0.005093988031,0.004732386209,0.004636303522,0.004732147325,0.005093987565,0.004636621568,0.004732226953,0.005093828309,0.004732147325,0.005094067194,0.005697027780,0.005696788896,0.004732226953,0.004732068162,0.005094067194,0.004636303522,0.004732147790,0.005093987565,0.004636382684,0.004732386209,0.005093907937,0.005696789362,0.005697027780,0.004636621103,0.004732226953,0.004732068162,0.005094067194,0.004732147790,0.005093987565,0.004636382684,0.004732386209,0.005093907937,0.005696789362,0.005697027780,0.004636382684,0.004732386209,0.004636303522,0.004732147325,0.005093987565,0.004732226953,0.005093828309,0.004732147325,0.005094067194,0.005697027780,0.005696788896,0.004636462312,0.004732386209,0.004732147325,0.005093907937,0.004636462312,0.004732226953,0.005093748681,0.004636223894,0.004732068162,0.005094146822,0.005697106943,0.005696788896,0.004732306115,0.004636303522,0.004731988534,0.005094146822,0.004636462312,0.004732147790,0.005093907937,0.004732386209,0.005093828775,0.005696789362,0.005697106943,0.004732386209,0.004732147325,0.005093907937,0.004636462312,0.004732226953,0.005093748681,0.004636223894,0.004732068162,0.005094146822,0.005697106943,0.005696788896,0.004732306115,0.004636303522,0.004731988534,0.005094146822,0.004732147790,0.005093907937,0.004732386209,0.005093828775,0.005696789362,0.005697106943,0.004636383150,0.004732226953,0.004636462312,0.004732306581,0.005093907937,0.004636462312,0.004732386209,0.005093669519,0.004731988534,0.005093987565,0.005696948152,0.005696630105,0.004732307047,0.004636462312,0.004732068162,0.005094067194,0.004636462312,0.004732306581,0.005093907937,0.004636383150,0.004732226953,0.005093828775,0.005696868524,0.005696948152,0.004636462312,0.004732307047,0.004636462312,0.004732068162,0.005094067194,0.004636462312,0.004732306581,0.005093907937,0.004636383150,0.004732226953,0.005093828775,0.005696868524,0.005696948152,0.004636383150,0.004732226953,0.004636462312,0.004732306581,0.005093907937,0.004732386209,0.005093669519,0.004636303522,0.004731988534,0.005093987565,0.005696948152,0.005696630105,0.004732307047,0.004732067697,0.005093908403,0.004731988534,0.005093907937,0.004732306581,0.005093987565,0.005697027780,0.005697027780,0.004732147790,0.004732147325,0.005093987565,0.004732067697,0.005093828309,0.004731909372,0.005093987565,0.005697027780,0.005697027780,0.004732386209,0.004732147325,0.005093987565,0.004732147790,0.005093987565,0.004732147325,0.005093987565,0.005697106943,0.005697027780,0.004732306115,0.004731988534,0.005093908403,0.004732386209,0.005093828309,0.004732306581,0.005093907937,0.005697027780,0.005697106943,0.004732386209,0.004732147325,0.005093987565,0.004732147790,0.005093987565,0.004732147325,0.005093987565,0.005697106943,0.005697027780,0.004732306115,0.004731988534,0.005093908403,0.004732386209,0.005093828309,0.004732306581,0.005093907937,0.005697027780,0.005697106943,0.004732306115,0.004731988534,0.005093908403,0.004732386209,0.005093828309,0.004732306581,0.005093907937,0.005697027780,0.005697106943,0.004732386209,0.004732147325,0.005093987565,0.004732147790,0.005093987565,0.004732147325,0.005093987565,0.005697106943,0.005697027780,0.004562075250,0.004593705758,0.004562075250,0.004593626596,0.004561996087,0.004562075716,0.004593626596,0.004561996087,0.004562075250,0.004593705758,0.004562234972,0.004593705758,0.004561996087,0.004593705758,0.004561996087,0.004562155344,0.004593705758,0.004561996087,0.004593705758,0.004561996087,0.004562075716,0.004593705758,0.004562075716,0.004593865015,0.004562155344,0.004562075716,0.004593865015,0.004562155344,0.004562075716,0.004593705758,0.004562155344,0.004593785387,0.004562155344,0.004593785387,0.004562234972,0.004593865015,0.004562314134,0.004562234972,0.004593785387,0.004561996087,0.004593865015,0.004562314134,0.004562234972,0.004593785387,0.004561996087,0.004562234972,0.004593785387,0.004561996087,0.004561996087,0.004593865015,0.004562314134,0.004593865015,0.004562234506,0.004561996087,0.004593626596,0.005076900590,0.005564228632,0.005077218637,0.004593546968,0.004562234506,0.004593944177,0.004562155344,0.005077059846,0.005563990213,0.005077059846,0.004561996087,0.004593546968,0.004593944177,0.004562155344,0.005077059846,0.005563990213,0.005077059846,0.004562155344,0.004593865015,0.004562234506,0.004593626596,0.005076900590,0.005564228632,0.005077218637,0.004562234506,0.004593865015,0.004561996087,0.004593705758,0.004561996087,0.005077059381,0.005564149003,0.005077139474,0.004593626596,0.004562155344,0.004562314134,0.004593944177,0.005077219103,0.005563830957,0.005077219103,0.004593865015,0.004561996087,0.004593705758,0.004561996087,0.005077059381,0.005564149003,0.005077139474,0.004593626596,0.004562155344,0.004593944177,0.005077219103,0.005563830957,0.005077219103,0.004562234506,0.004593865015,0.004562155344,0.004562075716,0.004593865015,0.005077218637,0.005563990213,0.005077139474,0.004593626596,0.004562075716,0.004562155344,0.004593944177,0.004562155344,0.005077218637,0.005564069375,0.005077218637,0.004562075716,0.004593626596,0.004562075716,0.004562155344,0.004593944177,0.004562155344,0.005077218637,0.005564069375,0.005077218637,0.004562155344,0.004593865015,0.004562155344,0.004593865015,0.004562155344,0.005077218637,0.005563990213,0.005077139474,0.004593785387,0.004593944177,0.005077139474,0.005564069375,0.005077139009,0.004593865015,0.004593865015,0.005076980218,0.005564149003,0.005077059846,0.004593785387,0.004593865015,0.005077059846,0.005563990213,0.005077059846,0.004593865015,0.004593785387,0.005077139474,0.005564069375,0.005077059846,0.004593785387,0.004593865015,0.005077059846,0.005563990213,0.005077059846,0.004593865015,0.004593785387,0.005077139474,0.005564069375,0.005077059846,0.004593865015,0.004593785387,0.005077139474,0.005564069375,0.005077059846,0.004593785387,0.004593865015,0.005077059846,0.005563990213,0.005077059846,0.004627322778,0.004651641473,0.004627163988,0.004651482683,0.005077059381,0.004718239885,0.004843806848,0.004699643236,0.004651561845,0.004627163988,0.004651482683,0.005077218637,0.004718398675,0.004843965638,0.004699563608,0.004627163988,0.004651561845,0.004627163988,0.004651482683,0.005077218637,0.004718398675,0.004843965638,0.004699563608,0.004627322778,0.004651641473,0.004651482683,0.005077059381,0.004718239885,0.004843806848,0.004699643236,0.004627243616,0.004651562311,0.004627243616,0.004651561845,0.005077218637,0.004718319047,0.004843806848,0.004699643236,0.004651561845,0.004627243616,0.004651482683,0.005077377893,0.004718239885,0.004844045267,0.004699563608,0.004627243616,0.004651562311,0.004627243616,0.004651561845,0.005077218637,0.004718319047,0.004843806848,0.004699643236,0.004651561845,0.004627243616,0.004651482683,0.005077377893,0.004718239885,0.004844045267,0.004699563608,0.004627402406,0.004651721101,0.004627402406,0.004651482683,0.005077218637,0.004718081094,0.004844045267,0.004699643236,0.004651562311,0.004627243616,0.004651721101,0.005077139474,0.004718319513,0.004843965638,0.004699484445,0.004627402406,0.004651562311,0.004627243616,0.004651721101,0.005077139474,0.004718319513,0.004843965638,0.004699484445,0.004627402406,0.004651721101,0.004651482683,0.005077218637,0.004718081094,0.004844045267,0.004699643236,0.004627084360,0.004651561845,0.004651721101,0.005077139474,0.004718319513,0.004843965638,0.004699563608,0.004627243616,0.004651721101,0.004627163988,0.004651561845,0.005077059381,0.004718160257,0.004843886010,0.004699563608,0.004651641473,0.004627163988,0.004651641473,0.005076820962,0.004718239419,0.004843966104,0.004699643236,0.004627322778,0.004651720636,0.004651562311,0.005077139009,0.004718239885,0.004843806848,0.004699483979,0.004627163988,0.004651641473,0.004627163988,0.004651641473,0.005076820962,0.004718239419,0.004843966104,0.004699643236,0.004627322778,0.004651720636,0.004627322778,0.004651562311,0.005077139009,0.004718239885,0.004843806848,0.004699483979,0.004627322778,0.004651720636,0.004627322778,0.004651562311,0.005077139009,0.004718239885,0.004843806848,0.004699483979,0.004627163988,0.004651641473,0.004627163988,0.004651641473,0.005076820962,0.004718239419,0.004843966104,0.004699643236,0.004651482683,0.004627163988,0.004651641473,0.005077139474,0.004718557466,0.004843966104,0.004699563608,0.004627163988,0.004651561845,0.005077059381,0.004651482683,0.005077139474,0.004718398675,0.004843965638,0.004699563608,0.005564069375,0.005563990213,0.005678431131,0.005864715204,0.005678351037,0.004651482683,0.004651641473,0.005077218637,0.004718239885,0.004843806848,0.004699484445,0.004627163988,0.004651641473,0.005077218637,0.004627084360,0.004651482683,0.005076901056,0.004718319047,0.004843806848,0.004699643236,0.005564149003,0.005564228632,0.005678351037,0.005864556879,0.005678351969,0.004627163988,0.004651482683,0.004651641473,0.005077218637,0.004718239885,0.004843806848,0.004699484445,0.004651641473,0.005077218637,0.004627084360,0.004651482683,0.005076901056,0.004718319047,0.004843806848,0.004699643236,0.005564149003,0.005564228632,0.005678351037,0.005864556879,0.005678351969,0.004627084360,0.004651482683,0.004627163988,0.004651641473,0.005077139474,0.004718557466,0.004843966104,0.004699563608,0.004651561845,0.005077059381,0.004651482683,0.005077139474,0.004718398675,0.004843965638,0.004699563608,0.005564069375,0.005563990213,0.005678431131,0.005864715204,0.005678351037,0.004627323244,0.004651641473,0.004651641473,0.005077059381,0.004718319513,0.004843966104,0.004699563608,0.004627243616,0.004651561845,0.005077218637,0.004627243616,0.004651482683,0.005077298731,0.004718239885,0.004844045267,0.004699563608,0.005564069841,0.005563830957,0.005678431131,0.005864715204,0.005678351037,0.004651561845,0.004627243616,0.004651562311,0.005077139474,0.004718081094,0.004843886476,0.004699484445,0.004627163988,0.004651641473,0.005077139009,0.004651641473,0.005077060312,0.004718160257,0.004843806848,0.004699643236,0.005564149003,0.005564149003,0.005678351037,0.005864556879,0.005678351969,0.004651641473,0.004651641473,0.005077059381,0.004718319513,0.004843966104,0.004699563608,0.004627243616,0.004651561845,0.005077218637,0.004627243616,0.004651482683,0.005077298731,0.004718239885,0.004844045267,0.004699563608,0.005564069841,0.005563830957,0.005678431131,0.005864715204,0.005678351037,0.004651561845,0.004627243616,0.004651562311,0.005077139474,0.004718081094,0.004843886476,0.004699484445,0.004651641473,0.005077139009,0.004651641473,0.005077060312,0.004718160257,0.004843806848,0.004699643236,0.005564149003,0.005564149003,0.005678351037,0.005864556879,0.005678351969,0.004627323244,0.004651641473,0.004627163988,0.004651641473,0.005077139474,0.004718239885,0.004843806848,0.004699563608,0.004627402406,0.004651562311,0.005077218637,0.004651721101,0.005077139474,0.004718319513,0.004843965638,0.004699484445,0.005563910585,0.005564069375,0.005678431131,0.005864715204,0.005678351037,0.004651482683,0.004627402406,0.004651721101,0.005077139474,0.004718240350,0.004844045732,0.004699643236,0.004627163988,0.004651641473,0.005077139474,0.004627323244,0.004651641473,0.005077218637,0.004718239419,0.004843886476,0.004699643236,0.005563990213,0.005563910585,0.005678271875,0.005864556879,0.005678271875,0.004627402406,0.004651482683,0.004627402406,0.004651721101,0.005077139474,0.004718240350,0.004844045732,0.004699643236,0.004627163988,0.004651641473,0.005077139474,0.004627323244,0.004651641473,0.005077218637,0.004718239419,0.004843886476,0.004699643236,0.005563990213,0.005563910585,0.005678271875,0.005864556879,0.005678271875,0.004627323244,0.004651641473,0.004627163988,0.004651641473,0.005077139474,0.004718239885,0.004843806848,0.004699563608,0.004651562311,0.005077218637,0.004627243616,0.004651721101,0.005077139474,0.004718319513,0.004843965638,0.004699484445,0.005563910585,0.005564069375,0.005678431131,0.005864715204,0.005678351037,0.004651562311,0.004651720636,0.005077059846,0.004718319513,0.004843965638,0.004699563608,0.004651561845,0.005076980218,0.004651562311,0.005077139009,0.004718081094,0.004843727220,0.004699483979,0.005563990213,0.005564069375,0.005678510293,0.005864954088,0.005678510293,0.004651561845,0.004651641473,0.005077059846,0.004718240350,0.004843806848,0.004699483979,0.004651641473,0.005077059381,0.004651641473,0.005076900590,0.004718239419,0.004843966104,0.004699643236,0.005563990213,0.005563990213,0.005678431131,0.005864794832,0.005678589456,0.004651561845,0.004651721101,0.005077059381,0.004718239885,0.004843966104,0.004699722398,0.004651641473,0.005076980218,0.004651561845,0.005076980218,0.004718081094,0.004843886476,0.004699484445,0.005564069375,0.005563990213,0.005678589456,0.005864794366,0.005678510293,0.004651562311,0.004651561845,0.005076980218,0.004718319513,0.004843886476,0.004699563608,0.004651561845,0.005077139009,0.004651721101,0.005077139474,0.004718319513,0.004843965638,0.004699563608,0.005563910585,0.005564069375,0.005678589456,0.005864715204,0.005678430665,0.004651561845,0.004651721101,0.005077059381,0.004718239885,0.004843966104,0.004699722398,0.004651641473,0.005076980218,0.004651561845,0.005076980218,0.004718081094,0.004843886476,0.004699484445,0.005564069375,0.005563990213,0.005678589456,0.005864794366,0.005678510293,0.004651562311,0.004651561845,0.005076980218,0.004718319513,0.004843886476,0.004699563608,0.004651561845,0.005077139009,0.004651721101,0.005077139474,0.004718319513,0.004843965638,0.004699563608,0.005563910585,0.005564069375,0.005678589456,0.005864715204,0.005678430665,0.004651562311,0.004651561845,0.005076980218,0.004718319513,0.004843886476,0.004699563608,0.004651561845,0.005077139009,0.004651721101,0.005077139474,0.004718319513,0.004843965638,0.004699563608,0.005563910585,0.005564069375,0.005678589456,0.005864715204,0.005678430665,0.004651561845,0.004651721101,0.005077059381,0.004718239885,0.004843966104,0.004699722398,0.004651641473,0.005076980218,0.004651561845,0.005076980218,0.004718081094,0.004843886476,0.004699484445,0.005564069375,0.005563990213,0.005678589456,0.005864794366,0.005678510293,0.004578129388,0.004600381479,0.004578049760,0.004600381479,0.004699563608,0.004600222688,0.004578049760,0.004600302316,0.004699563608,0.004578049760,0.004600222688,0.004578049760,0.004600302316,0.004699563608,0.004578129388,0.004600381479,0.004600381479,0.004699563608,0.004578049760,0.004600461107,0.004577970132,0.004600381479,0.004699563608,0.004600302316,0.004577970132,0.004600381479,0.004699642770,0.004578049760,0.004600461107,0.004577970132,0.004600381479,0.004699563608,0.004600302316,0.004577970132,0.004600381479,0.004699642770,0.004577970132,0.004600381479,0.004578049760,0.004600461107,0.004699643236,0.004600222688,0.004578049760,0.004600302316,0.004699563608,0.004578049760,0.004600222688,0.004578049760,0.004600302316,0.004699563608,0.004577970132,0.004600381479,0.004600461107,0.004699643236,0.004577970132,0.004600381479,0.004600381479,0.004699563608,0.004578049760,0.004600381479,0.004578049760,0.004600381479,0.004699722864,0.004600461107,0.004577970132,0.004600461107,0.004699484445,0.004577970132,0.004600381479,0.004600461107,0.004699563608,0.004578049760,0.004600461107,0.004577970132,0.004600461107,0.004699484445,0.004577970132,0.004600381479,0.004578129388,0.004600461107,0.004699563608,0.004577970132,0.004600381479,0.004578129388,0.004600461107,0.004699563608,0.004578049760,0.004600461107,0.004577970132,0.004600461107,0.004699484445,0.004600302316,0.004578049760,0.004600381944,0.004699642770,0.004578049760,0.004600222688,0.004600302316,0.004699563608,0.005081510171,0.005566295236,0.005081510171,0.005566374399,0.005678351503,0.004600302316,0.004600302316,0.004699643236,0.004578049760,0.004600461107,0.004577970132,0.004600381479,0.004699563608,0.005081431009,0.005566533189,0.005081351381,0.005566453561,0.005678351037,0.004578049760,0.004600302316,0.004600302316,0.004699643236,0.004600461107,0.004577970132,0.004600381479,0.004699563608,0.005081431009,0.005566533189,0.005081351381,0.005566453561,0.005678351037,0.004577970132,0.004600302316,0.004578049760,0.004600381944,0.004699642770,0.004600222688,0.004600302316,0.004699563608,0.005081510171,0.005566295236,0.005081510171,0.005566374399,0.005678351503,0.004577970132,0.004600302316,0.004600381944,0.004699642770,0.004577970132,0.004600302316,0.004577970132,0.004600381479,0.004699642770,0.005081431009,0.005566215608,0.005081589334,0.005566294771,0.005678351503,0.004600302316,0.004578049760,0.004600381479,0.004699642770,0.004577970132,0.004600461107,0.004600381479,0.004699563608,0.005081510171,0.005566215143,0.005081431009,0.005566215143,0.005678431131,0.004600302316,0.004600381944,0.004699642770,0.004577970132,0.004600302316,0.004577970132,0.004600381479,0.004699642770,0.005081431009,0.005566215608,0.005081589334,0.005566294771,0.005678351503,0.004600302316,0.004578049760,0.004600381479,0.004699642770,0.004600461107,0.004600381479,0.004699563608,0.005081510171,0.005566215143,0.005081431009,0.005566215143,0.005678431131,0.004577970132,0.004600302316,0.004578049760,0.004600381944,0.004699642770,0.004578049760,0.004600222688,0.004600302316,0.004699563608,0.005081431009,0.005566294771,0.005081589334,0.005566374399,0.005678272340,0.004600381479,0.004577970132,0.004600302316,0.004699563608,0.004578049760,0.004600461107,0.004577970132,0.004600381479,0.004699563608,0.005081431009,0.005566295236,0.005081351381,0.005566215143,0.005678351037,0.004578049760,0.004600381479,0.004577970132,0.004600302316,0.004699563608,0.004578049760,0.004600461107,0.004577970132,0.004600381479,0.004699563608,0.005081431009,0.005566295236,0.005081351381,0.005566215143,0.005678351037,0.004577970132,0.004600302316,0.004578049760,0.004600381944,0.004699642770,0.004600222688,0.004578049760,0.004600302316,0.004699563608,0.005081431009,0.005566294771,0.005081589334,0.005566374399,0.005678272340,0.004600461107,0.004600381479,0.004699483979,0.004600461107,0.004600381479,0.004699563608,0.005081589334,0.005566374399,0.005081351846,0.005566295236,0.005678510293,0.004600461107,0.004600302316,0.004699484445,0.004600461107,0.004600461107,0.004699484445,0.005081589334,0.005566453561,0.005081510171,0.005566533189,0.005678589921,0.004600381479,0.004600381479,0.004699563608,0.004600302316,0.004600461107,0.004699484445,0.005081510171,0.005566374399,0.005081510171,0.005566295236,0.005678510293,0.004600381479,0.004600461107,0.004699484445,0.004600381479,0.004600381479,0.004699563608,0.005081589334,0.005566532724,0.005081510171,0.005566295236,0.005678510293,0.004600381479,0.004600381479,0.004699563608,0.004600302316,0.004600461107,0.004699484445,0.005081510171,0.005566374399,0.005081510171,0.005566295236,0.005678510293,0.004600381479,0.004600461107,0.004699484445,0.004600381479,0.004600381479,0.004699563608,0.005081589334,0.005566532724,0.005081510171,0.005566295236,0.005678510293,0.004600381479,0.004600461107,0.004699484445,0.004600381479,0.004600381479,0.004699563608,0.005081589334,0.005566532724,0.005081510171,0.005566295236,0.005678510293,0.004600381479,0.004600381479,0.004699563608,0.004600302316,0.004600461107,0.004699484445,0.005081510171,0.005566374399,0.005081510171,0.005566295236,0.005678510293,0.004617627244,0.004647509195,0.004652833566,0.004718001466,0.004618024454,0.004647826776,0.004718319513,0.005081431009,0.004652913194,0.004717921838,0.004838323221,0.004843886476,0.004647747148,0.004652833566,0.004717922304,0.004617547616,0.004647588357,0.004718239885,0.005081510171,0.004652992822,0.004718081094,0.004838323221,0.004843806848,0.004618024454,0.004647747148,0.004652833566,0.004717922304,0.004617547616,0.004647588357,0.004718239885,0.005081510171,0.004652992822,0.004718081094,0.004838323221,0.004843806848,0.004617627244,0.004647509195,0.004652833566,0.004718001466,0.004647826776,0.004718319513,0.005081431009,0.004652913194,0.004717921838,0.004838323221,0.004843886476,0.004617627244,0.004647509195,0.004652913194,0.004718001466,0.004617388826,0.004647509195,0.004718160257,0.005081510171,0.004652992822,0.004718001466,0.004838402849,0.004843966104,0.004647429567,0.004652834032,0.004718001932,0.004617468454,0.004647429567,0.004718239419,0.005081510171,0.004652913194,0.004718081094,0.004838482477,0.004843966104,0.004617627244,0.004647509195,0.004652913194,0.004718001466,0.004617388826,0.004647509195,0.004718160257,0.005081510171,0.004652992822,0.004718001466,0.004838402849,0.004843966104,0.004647429567,0.004652834032,0.004718001932,0.004617468454,0.004647429567,0.004718239419,0.005081510171,0.004652913194,0.004718081094,0.004838482477,0.004843966104,0.004617309663,0.004647667985,0.004653071985,0.004717921838,0.004617706873,0.004647667985,0.004718239419,0.005081431009,0.004652833566,0.004718081094,0.004838482477,0.004844045732,0.004647747148,0.004652913194,0.004717921838,0.004617388826,0.004647588357,0.004718001466,0.005081510171,0.004653071985,0.004717921838,0.004838323221,0.004843727220,0.004617706873,0.004647747148,0.004652913194,0.004717921838,0.004617388826,0.004647588357,0.004718001466,0.005081510171,0.004653071985,0.004717921838,0.004838323221,0.004843727220,0.004617309663,0.004647667985,0.004653071985,0.004717921838,0.004647667985,0.004718239419,0.005081431009,0.004652833566,0.004718081094,0.004838482477,0.004844045732,0.004617706873,0.004647747613,0.004653071985,0.004718081094,0.004647588357,0.004718239419,0.005081510171,0.004652992357,0.004718081094,0.004838402849,0.004843886476,0.004617388826,0.004647509195,0.004653071985,0.004718001466,0.004617548082,0.004647667985,0.004718239419,0.005081510171,0.004653151613,0.004718001466,0.004838323221,0.004843966104,0.004647429567,0.004652992357,0.004717921838,0.004617547616,0.004647509195,0.004718001932,0.005081510171,0.004653071985,0.004718001466,0.004838163964,0.004843648523,0.004617548082,0.004647668451,0.004653151613,0.004718081094,0.004647588357,0.004718319513,0.005081590265,0.004653071985,0.004718081094,0.004838244058,0.004843965638,0.004617548082,0.004647429567,0.004652992357,0.004717921838,0.004617547616,0.004647509195,0.004718001932,0.005081510171,0.004653071985,0.004718001466,0.004838163964,0.004843648523,0.004617548082,0.004647668451,0.004653151613,0.004718081094,0.004617627244,0.004647588357,0.004718319513,0.005081590265,0.004653071985,0.004718081094,0.004838244058,0.004843965638,0.004617548082,0.004647668451,0.004653151613,0.004718081094,0.004617627244,0.004647588357,0.004718319513,0.005081590265,0.004653071985,0.004718081094,0.004838244058,0.004843965638,0.004617548082,0.004647429567,0.004652992357,0.004717921838,0.004617547616,0.004647509195,0.004718001932,0.005081510171,0.004653071985,0.004718001466,0.004838163964,0.004843648523,0.004647667985,0.004652992822,0.004718001466,0.004617547616,0.004647667985,0.004718319513,0.005081510171,0.004652992357,0.004718001466,0.004838323221,0.004843806848,0.004618024454,0.004647747148,0.005081351846,0.004652833566,0.004717922304,0.004647588357,0.004718239885,0.005081510171,0.004652992822,0.004718081094,0.004838323221,0.004843806848,0.005566453561,0.005566374399,0.005678272340,0.005566533189,0.005678351503,0.005566453561,0.005678271875,0.005864636041,0.005864556879,0.004647826776,0.004652913194,0.004717921838,0.004647509195,0.004718239885,0.005081510171,0.004652833566,0.004718001466,0.004838323221,0.004843806848,0.004617547616,0.004647667985,0.005081510171,0.004652992357,0.004718001466,0.004617706873,0.004647667985,0.004718557931,0.005081510171,0.004652992822,0.004718001466,0.004838323221,0.004843966104,0.005566294771,0.005566215143,0.005678351037,0.005566453561,0.005678351969,0.005566532724,0.005678431131,0.005864715204,0.005864715204,0.004618024454,0.004647826776,0.004652913194,0.004717921838,0.004647509195,0.004718239885,0.005081510171,0.004652833566,0.004718001466,0.004838323221,0.004843806848,0.004647667985,0.005081510171,0.004652992357,0.004718001466,0.004617706873,0.004647667985,0.004718557931,0.005081510171,0.004652992822,0.004718001466,0.004838323221,0.004843966104,0.005566294771,0.005566215143,0.005678351037,0.005566453561,0.005678351969,0.005566532724,0.005678431131,0.005864715204,0.005864715204,0.004617706873,0.004647667985,0.004652992822,0.004718001466,0.004617547616,0.004647667985,0.004718319513,0.005081510171,0.004652992357,0.004718001466,0.004838323221,0.004843806848,0.004647747148,0.005081351846,0.004652833566,0.004717922304,0.004647588357,0.004718239885,0.005081510171,0.004652992822,0.004718081094,0.004838323221,0.004843806848,0.005566453561,0.005566374399,0.005678272340,0.005566533189,0.005678351503,0.005566453561,0.005678271875,0.005864636041,0.005864556879,0.004617548082,0.004647509195,0.004652992357,0.004718001466,0.004647588357,0.004718160257,0.005081510171,0.004653071985,0.004718001466,0.004838323221,0.004843806848,0.004617388826,0.004647429567,0.005081431009,0.004652834032,0.004718001932,0.004617468454,0.004647429567,0.004718239419,0.005081510171,0.004652913194,0.004718081094,0.004838482477,0.004843966104,0.005566453561,0.005566453561,0.005678351503,0.005566215143,0.005678351503,0.005566215143,0.005678351503,0.005864636041,0.005864556879,0.004647509195,0.004652992822,0.004718001466,0.004617627244,0.004647509195,0.004718319513,0.005081590265,0.004652913194,0.004718001466,0.004838403314,0.004843806848,0.004617547616,0.004647588357,0.005081510171,0.004653071985,0.004718001466,0.004647509195,0.004718319513,0.005081431009,0.004652992357,0.004718001466,0.004838323221,0.004843966104,0.005566294771,0.005566215143,0.005678351037,0.005566453561,0.005678431131,0.005566453561,0.005678431131,0.005864715204,0.005864715204,0.004647509195,0.004652992357,0.004718001466,0.004647588357,0.004718160257,0.005081510171,0.004653071985,0.004718001466,0.004838323221,0.004843806848,0.004617388826,0.004647429567,0.005081431009,0.004652834032,0.004718001932,0.004617468454,0.004647429567,0.004718239419,0.005081510171,0.004652913194,0.004718081094,0.004838482477,0.004843966104,0.005566453561,0.005566453561,0.005678351503,0.005566215143,0.005678351503,0.005566215143,0.005678351503,0.005864636041,0.005864556879,0.004647509195,0.004652992822,0.004718001466,0.004617627244,0.004647509195,0.004718319513,0.005081590265,0.004652913194,0.004718001466,0.004838403314,0.004843806848,0.004647588357,0.005081510171,0.004653071985,0.004718001466,0.004647509195,0.004718319513,0.005081431009,0.004652992357,0.004718001466,0.004838323221,0.004843966104,0.005566294771,0.005566215143,0.005678351037,0.005566453561,0.005678431131,0.005566453561,0.005678431131,0.005864715204,0.005864715204,0.004617468454,0.004647588357,0.004652992357,0.004718001466,0.004617627244,0.004647667985,0.004718239419,0.005081510171,0.004653071985,0.004718081094,0.004838323221,0.004843886476,0.004617706873,0.004647747148,0.005081350915,0.004652913194,0.004717921838,0.004647588357,0.004718001466,0.005081510171,0.004653071985,0.004717921838,0.004838323221,0.004843727220,0.005566294771,0.005566294771,0.005678351503,0.005566295236,0.005678271875,0.005566215143,0.005678271875,0.005864636041,0.005864556879,0.004647667985,0.004652833566,0.004718081094,0.004617309663,0.004647667985,0.004718001932,0.005081590265,0.004653071985,0.004717921838,0.004838482477,0.004843966104,0.004617627244,0.004647667985,0.005081510171,0.004653071985,0.004718081094,0.004617468454,0.004647588357,0.004718239419,0.005081431009,0.004652992357,0.004718001466,0.004838323686,0.004843806848,0.005566374399,0.005566294771,0.005678351037,0.005566294771,0.005678431131,0.005566294771,0.005678431131,0.005864715204,0.005864715204,0.004617706873,0.004647667985,0.004652833566,0.004718081094,0.004617309663,0.004647667985,0.004718001932,0.005081590265,0.004653071985,0.004717921838,0.004838482477,0.004843966104,0.004617627244,0.004647667985,0.005081510171,0.004653071985,0.004718081094,0.004617468454,0.004647588357,0.004718239419,0.005081431009,0.004652992357,0.004718001466,0.004838323686,0.004843806848,0.005566374399,0.005566294771,0.005678351037,0.005566294771,0.005678431131,0.005566294771,0.005678431131,0.005864715204,0.005864715204,0.004617468454,0.004647588357,0.004652992357,0.004718001466,0.004617627244,0.004647667985,0.004718239419,0.005081510171,0.004653071985,0.004718081094,0.004838323221,0.004843886476,0.004647747148,0.005081350915,0.004652913194,0.004717921838,0.004617388826,0.004647588357,0.004718001466,0.005081510171,0.004653071985,0.004717921838,0.004838323221,0.004843727220,0.005566294771,0.005566294771,0.005678351503,0.005566295236,0.005678271875,0.005566215143,0.005678271875,0.005864636041,0.005864556879,0.004647588357,0.004653071985,0.004718081094,0.004647668451,0.004718239419,0.005081510171,0.004653151613,0.004718081094,0.004838243593,0.004843806848,0.004647509195,0.005081510171,0.004653071985,0.004718081094,0.004647588357,0.004718319513,0.005081589799,0.004653071985,0.004718081094,0.004838244058,0.004843886476,0.005566215143,0.005566453561,0.005678431131,0.005566453561,0.005678589456,0.005566294771,0.005678589456,0.005864715204,0.005864794832,0.004647667985,0.004652992822,0.004718239419,0.004647509195,0.004718081094,0.005081510171,0.004653071985,0.004718239419,0.004838402849,0.004843886476,0.004647429567,0.005081510171,0.004652992357,0.004717921838,0.004647509195,0.004718001932,0.005081510171,0.004653071985,0.004718001466,0.004838163964,0.004843648523,0.005566374399,0.005566294771,0.005678431131,0.005566374399,0.005678510293,0.005566295236,0.005678510293,0.005864794832,0.005864794832,0.004647667985,0.004653151613,0.004718081094,0.004647509195,0.004718160257,0.005081510171,0.004653071985,0.004718081094,0.004838403314,0.004843886010,0.004647509195,0.005081510171,0.004653071985,0.004718160257,0.004647667985,0.004718239419,0.005081589334,0.004652992822,0.004718160257,0.004838323221,0.004843806848,0.005566453561,0.005566374399,0.005678510293,0.005566374399,0.005678431131,0.005566453561,0.005678351969,0.005864715204,0.005864794832,0.004647588357,0.004653071985,0.004718081094,0.004647509195,0.004718081094,0.005081510171,0.004653071985,0.004718081094,0.004838243593,0.004843727220,0.004647747613,0.005081350915,0.004653071985,0.004718081094,0.004647588357,0.004718239419,0.005081510171,0.004652992357,0.004718081094,0.004838402849,0.004843886476,0.005566135980,0.005566294771,0.005678589456,0.005566374399,0.005678510293,0.005566295236,0.005678510293,0.005864794832,0.005864953622,0.004647667985,0.004653151613,0.004718081094,0.004647509195,0.004718160257,0.005081510171,0.004653071985,0.004718081094,0.004838403314,0.004843886010,0.004647509195,0.005081510171,0.004653071985,0.004718160257,0.004647667985,0.004718239419,0.005081589334,0.004652992822,0.004718160257,0.004838323221,0.004843806848,0.005566453561,0.005566374399,0.005678510293,0.005566374399,0.005678431131,0.005566453561,0.005678351969,0.005864715204,0.005864794832,0.004647588357,0.004653071985,0.004718081094,0.004647509195,0.004718081094,0.005081510171,0.004653071985,0.004718081094,0.004838243593,0.004843727220,0.004647747613,0.005081350915,0.004653071985,0.004718081094,0.004647588357,0.004718239419,0.005081510171,0.004652992357,0.004718081094,0.004838402849,0.004843886476,0.005566135980,0.005566294771,0.005678589456,0.005566374399,0.005678510293,0.005566295236,0.005678510293,0.005864794832,0.005864953622,0.004647588357,0.004653071985,0.004718081094,0.004647509195,0.004718081094,0.005081510171,0.004653071985,0.004718081094,0.004838243593,0.004843727220,0.004647747613,0.005081350915,0.004653071985,0.004718081094,0.004647588357,0.004718239419,0.005081510171,0.004652992357,0.004718081094,0.004838402849,0.004843886476,0.005566135980,0.005566294771,0.005678589456,0.005566374399,0.005678510293,0.005566295236,0.005678510293,0.005864794832,0.005864953622,0.004647667985,0.004653151613,0.004718081094,0.004647509195,0.004718160257,0.005081510171,0.004653071985,0.004718081094,0.004838403314,0.004843886010,0.004647509195,0.005081510171,0.004653071985,0.004718160257,0.004647667985,0.004718239419,0.005081589334,0.004652992822,0.004718160257,0.004838323221,0.004843806848,0.005566453561,0.005566374399,0.005678510293,0.005566374399,0.005678431131,0.005566453561,0.005678351969,0.005864715204,0.005864794832
];

const SPHERES: SphereRec[] = N_DOT.map((n, i) => {
  const s = DOT_START[i]!;
  return { dot: DOTS.slice(s, s + n), area: AREAS.slice(s, s + n) };
});

/** Sphere tessellation for a `dot_density` (clamped to 0..4). */
export function sphereForDensity(ds: number): SphereRec {
  const i = Math.max(0, Math.min(4, Math.trunc(ds)));
  return SPHERES[i]!;
}
